(function( $ ) { 
   "use strict";
   var body = $('body'),
       $document = $(document);
  
    //Custom start by chintan
    //cart +
    $(document).on("click", ".cart-item-data .quantity .plus", async function(e){
      //console.log('plust clicked from custom_cart_widget.js')
      var engraveAdded = $(this).parents(".cart-item-data").find(".t4s-product-details__item-label").hasClass("engrave-added");
      var customTextAdded = $(this).parents(".cart-item-data").find(".t4s-product-details__item-label").hasClass("custom-text-added");
      var imageAdded = $(this).parents(".cart-item-data").find(".t4s-product-details__item-label").hasClass("image-added");

      //Below is for cart page
      if(body.hasClass("template-cart")){
        var engraveAdded = $(this).parents(".cart-item-data").find(".product-details__item-label").hasClass("engrave-added");
        var customTextAdded = $(this).parents(".cart-item-data").find(".product-details__item-label").hasClass("custom-text-added");
        var imageAdded = $(this).parents(".cart-item-data").find(".product-details__item-label").hasClass("image-added");
      }
      
      //images / logos
      var iphone_image = $(this).parents(".cart-item-data").find(".t4s-cart_meta_propertyList").attr("iphone-image");
      var iphone_image_character = $(this).parents(".cart-item-data").find(".t4s-cart_meta_propertyList").attr("iphone-image-character");
      var iphone_logo = $(this).parents(".cart-item-data").find(".t4s-cart_meta_propertyList").attr("iphone-logo");
      var cardholder_image = $(this).parents(".cart-item-data").find(".t4s-cart_meta_propertyList").attr("cardholder-image");
      var cardholder_image_character = $(this).parents(".cart-item-data").find(".t4s-cart_meta_propertyList").attr("cardholder-image-character");
      var cardholder_logo = $(this).parents(".cart-item-data").find(".t4s-cart_meta_propertyList").attr("cardholder-logo");
      var lanyard_image = $(this).parents(".cart-item-data").find(".t4s-cart_meta_propertyList").attr("lanyard-image");
      var lanyard_image_character = $(this).parents(".cart-item-data").find(".t4s-cart_meta_propertyList").attr("lanyard-image-character");
      var lanyard_logo = $(this).parents(".cart-item-data").find(".t4s-cart_meta_propertyList").attr("lanyard-logo");
      var wallet_image = $(this).parents(".cart-item-data").find(".t4s-cart_meta_propertyList").attr("wallet-image");
      var wallet_image_character = $(this).parents(".cart-item-data").find(".t4s-cart_meta_propertyList").attr("wallet-image-character");
      var wallet_logo = $(this).parents(".cart-item-data").find(".t4s-cart_meta_propertyList").attr("wallet-logo");
      var passport_image = $(this).parents(".cart-item-data").find(".t4s-cart_meta_propertyList").attr("passport-image");
      var passport_image_character = $(this).parents(".cart-item-data").find(".t4s-cart_meta_propertyList").attr("passport-image-character");
      var passport_logo = $(this).parents(".cart-item-data").find(".t4s-cart_meta_propertyList").attr("passport-logo");
      var laptop_image = $(this).parents(".cart-item-data").find(".t4s-cart_meta_propertyList").attr("laptop-image");
      var laptop_image_character = $(this).parents(".cart-item-data").find(".t4s-cart_meta_propertyList").attr("laptop-image-character");
      var laptop_logo = $(this).parents(".cart-item-data").find(".t4s-cart_meta_propertyList").attr("laptop-logo");
      var men_pouch_image = $(this).parents(".cart-item-data").find(".t4s-cart_meta_propertyList").attr("men-pouch-image");
      var men_pouch_image_character = $(this).parents(".cart-item-data").find(".t4s-cart_meta_propertyList").attr("men-pouch-image-character");
      var men_pouch_logo = $(this).parents(".cart-item-data").find(".t4s-cart_meta_propertyList").attr("men-pouch-logo");
      var lady_pouch_image = $(this).parents(".cart-item-data").find(".t4s-cart_meta_propertyList").attr("lady-pouch-image");
      var lady_pouch_image_character = $(this).parents(".cart-item-data").find(".t4s-cart_meta_propertyList").attr("lady-pouch-image-character");
      var lady_pouch_logo = $(this).parents(".cart-item-data").find(".t4s-cart_meta_propertyList").attr("lady-pouch-logo");

      //engrave texts
      var iphone_engrave_text = '';
      var cardholder_engrave_text = '';
      var wallet_engrave_text = '';
      var lanyard_engrave_text = '';
      var passport_engrave_text = '';
      var laptop_engrave_text = '';
      var airpods_engrave_text = '';
      var watch_engrave_text = '';
      var lanyard_engrave_text_length = '';
      var iphone_engrave_text_length = '';
      var wallet_engrave_text_length = '';
      var passport_engrave_text_length = '';
      var cardholder_custom_text_length = '';
    
      //custom text
      var iphone_custom_text = '';
      var cardholder_custom_text = '';
      var wallet_custom_text = '';
      var lanyard_custom_text = '';
      var passport_custom_text = '';
      var laptop_custom_text = '';
      var airpods_custom_text = '';
      var watch_custom_text = '';
      var men_pouch_custom_text = '';
      var lady_pouch_custom_text = '';
      var cardholder_custom_text_extra = '';
      var lanyard_custom_text_extra = '';
      var passport_custom_text_extra = '';
      var wallet_custom_text_extra = '';
      var laptop_custom_text_extra = '';
      var lady_pouch_custom_text_extra = '';
      var men_pouch_custom_text_extra = '';
      var iphone_custom_text_extra = '';

      var actual_product_id = $(this).parents(".cart-item-data").attr("data-item-id");
      if( $('.engrave-charge .t4s-cart_meta_propertyList[actual_product_id="'+actual_product_id+'"]').length <= 0) return;

      if(engraveAdded){
        iphone_engrave_text = $(this).parents(".cart-item-data").find(".t4s-cart_meta_propertyList").attr("iphone-engrave-text");
        cardholder_engrave_text = $(this).parents(".cart-item-data").find(".t4s-cart_meta_propertyList").attr("cardholder-engrave-text");
        wallet_engrave_text = $(this).parents(".cart-item-data").find(".t4s-cart_meta_propertyList").attr("wallet-engrave-text");
        lanyard_engrave_text = $(this).parents(".cart-item-data").find(".t4s-cart_meta_propertyList").attr("lanyard-engrave-text");
        passport_engrave_text = $(this).parents(".cart-item-data").find(".t4s-cart_meta_propertyList").attr("passport-engrave-text");
        airpods_engrave_text = $(this).parents(".cart-item-data").find(".t4s-cart_meta_propertyList").attr("airpods-engrave-text");
        watch_engrave_text = $(this).parents(".cart-item-data").find(".t4s-cart_meta_propertyList").attr("watch-engrave-text");
        laptop_engrave_text = $(this).parents(".cart-item-data").find(".t4s-cart_meta_propertyList").attr("laptop-engrave-text");
      }

      lanyard_engrave_text_length = parseInt(
          $(this).parents(".cart-item-data").find(".t4s-cart_meta_propertyList").attr("lanyard-engrave-text-length")
      ) || 1;

      iphone_engrave_text_length = parseInt(
          $(this).parents(".cart-item-data").find(".t4s-cart_meta_propertyList").attr("iphone-engrave-text-length")
      ) || 1;

      wallet_engrave_text_length = parseInt(
          $(this).parents(".cart-item-data").find(".t4s-cart_meta_propertyList").attr("wallet-engrave-text-length")
      ) || 1;

      passport_engrave_text_length = parseInt(
          $(this).parents(".cart-item-data").find(".t4s-cart_meta_propertyList").attr("passport-engrave-text-length")
      ) || 1;
  
      if(customTextAdded){
        iphone_custom_text = $(this).parents(".cart-item-data").find(".t4s-cart_meta_propertyList").attr("iphone-custom-text");
        cardholder_custom_text = $(this).parents(".cart-item-data").find(".t4s-cart_meta_propertyList").attr("cardholder-custom-text");
        wallet_custom_text = $(this).parents(".cart-item-data").find(".t4s-cart_meta_propertyList").attr("wallet-custom-text");
        lanyard_custom_text = $(this).parents(".cart-item-data").find(".t4s-cart_meta_propertyList").attr("lanyard-custom-text");
        passport_custom_text = $(this).parents(".cart-item-data").find(".t4s-cart_meta_propertyList").attr("passport-custom-text");
        airpods_custom_text = $(this).parents(".cart-item-data").find(".t4s-cart_meta_propertyList").attr("airpods-custom-text");
        watch_custom_text = $(this).parents(".cart-item-data").find(".t4s-cart_meta_propertyList").attr("watch-custom-text");
        laptop_custom_text = $(this).parents(".cart-item-data").find(".t4s-cart_meta_propertyList").attr("laptop-custom-text");
        men_pouch_custom_text = $(this).parents(".cart-item-data").find(".t4s-cart_meta_propertyList").attr("men-pouch-custom-text");
        lady_pouch_custom_text = $(this).parents(".cart-item-data").find(".t4s-cart_meta_propertyList").attr("lady-pouch-custom-text");

        cardholder_custom_text_extra = $(this).parents(".cart-item-data").find(".t4s-cart_meta_propertyList").attr("cardholder-custom-text-extra");
        lanyard_custom_text_extra = $(this).parents(".cart-item-data").find(".t4s-cart_meta_propertyList").attr("lanyard-custom-text-extra");
        passport_custom_text_extra = $(this).parents(".cart-item-data").find(".t4s-cart_meta_propertyList").attr("passport-custom-text-extra");
        wallet_custom_text_extra = $(this).parents(".cart-item-data").find(".t4s-cart_meta_propertyList").attr("wallet-custom-text-extra");
        laptop_custom_text_extra = $(this).parents(".cart-item-data").find(".t4s-cart_meta_propertyList").attr("laptop-custom-text-extra");
        lady_pouch_custom_text_extra = $(this).parents(".cart-item-data").find(".t4s-cart_meta_propertyList").attr("lady-pouch-custom-text-extra");
        men_pouch_custom_text_extra = $(this).parents(".cart-item-data").find(".t4s-cart_meta_propertyList").attr("men-pouch-custom-text-extra");
        iphone_custom_text_extra = $(this).parents(".cart-item-data").find(".t4s-cart_meta_propertyList").attr("iphone-custom-text-extra");
      }
      
      if(imageAdded){
        iphone_image = $(this).parents(".cart-item-data").find(".t4s-cart_meta_propertyList").attr("iphone-image");
        iphone_logo = $(this).parents(".cart-item-data").find(".t4s-cart_meta_propertyList").attr("iphone-logo");
        cardholder_image = $(this).parents(".cart-item-data").find(".t4s-cart_meta_propertyList").attr("cardholder-image");
        cardholder_logo = $(this).parents(".cart-item-data").find(".t4s-cart_meta_propertyList").attr("cardholder-logo");
        wallet_image = $(this).parents(".cart-item-data").find(".t4s-cart_meta_propertyList").attr("wallet-image");
        wallet_logo = $(this).parents(".cart-item-data").find(".t4s-cart_meta_propertyList").attr("wallet-logo");
        lanyard_image = $(this).parents(".cart-item-data").find(".t4s-cart_meta_propertyList").attr("lanyard-image");
        lanyard_logo = $(this).parents(".cart-item-data").find(".t4s-cart_meta_propertyList").attr("lanyard-logo");
        passport_image = $(this).parents(".cart-item-data").find(".t4s-cart_meta_propertyList").attr("passport-image");
        passport_logo = $(this).parents(".cart-item-data").find(".t4s-cart_meta_propertyList").attr("passport-logo");
        laptop_image = $(this).parents(".cart-item-data").find(".t4s-cart_meta_propertyList").attr("laptop-image");
        laptop_logo = $(this).parents(".cart-item-data").find(".t4s-cart_meta_propertyList").attr("laptop-logo");
        men_pouch_image = $(this).parents(".cart-item-data").find(".t4s-cart_meta_propertyList").attr("men-pouch-image");
        men_pouch_logo = $(this).parents(".cart-item-data").find(".t4s-cart_meta_propertyList").attr("men-pouch-logo");
        lady_pouch_image = $(this).parents(".cart-item-data").find(".t4s-cart_meta_propertyList").attr("lady-pouch-image");
        lady_pouch_logo = $(this).parents(".cart-item-data").find(".t4s-cart_meta_propertyList").attr("lady-pouch-logo");
      }

    //1 added custom text as well
    if(iphone_engrave_text.length > 0 || iphone_image.length > 0 || iphone_logo != 0 && iphone_logo.length > 0 || iphone_custom_text.length > 0 || iphone_custom_text_extra.length > 0){
      if(iphone_image.length > 0 && !iphone_custom_text.length){
        iphone_image = $(this).parents(".cart-item-data").find(".t4s-cart_meta_propertyList").attr("iphone-image");
        setTimeout(function(index, value){
          console.log('img only')
          $('.engrave-charge .t4s-cart_meta_propertyList[actual_product_id="'+actual_product_id+'"][iphone-image='+iphone_image+'][iphone-custom-text=""]').parents(".cart-item-data").find(".quantity .plus").click();
          $('.engrave-charge .t4s-cart_meta_propertyList[actual_product_id="'+actual_product_id+'"][iphone-image='+iphone_image+'][iphone-custom-text=""]').parents(".cart-item-data").find(".qty.quantity").html("Qty : <span>"+(parseInt($('.engrave-charge .t4s-cart_meta_propertyList[actual_product_id="'+actual_product_id+'"][iphone-image='+iphone_image+'][iphone-custom-text=""]').parents(".cart-item-data").find(".qty.quantity span").text())+1)+"</span>");
        }, 2500);
      } else if (iphone_image.length > 0 && iphone_custom_text.length > 0) {
        iphone_image = $(this).parents(".cart-item-data").find(".t4s-cart_meta_propertyList").attr("iphone-image");

        setTimeout(async function () {
          let iscart = document.getElementById('t4s-mini_cart') || document.querySelector('.t4s-cartPage__form');
          try {
            const updates = {}; 
            // Fetch current cart
            const res = await fetch('/cart.js');
            const cart = await res.json();

            // --- First product: iPhone Custom Text + Image ---
            const matchingItem1 = cart.items.find(item =>
              item.properties &&
              item.properties["Actual Product"] == actual_product_id &&
              item.properties["iPhone Custom Text"] == iphone_custom_text &&
              item.properties["iPhone Image"]
            );

            if (matchingItem1) {
              const newQty1 = matchingItem1.quantity + 1;
              updates[matchingItem1.key] = newQty1;
     
              // Update DOM manually
              $('.engrave-charge .t4s-cart_meta_propertyList[actual_product_id="' + actual_product_id + '"][iphone-custom-text="' + iphone_custom_text + '"][iphone-image="' + iphone_image + '"]')
                .parents(".cart-item-data")
                .find(".qty.quantity")
                .html(`Qty : <span>${newQty1}</span>`);
            } else {
              console.warn("Matching iPhone item not found.");
            }

            // --- Second product: Extra Custom Text (if applicable) ---
            if (iphone_custom_text_extra.length > 0) {
              const matchingItem2 = cart.items.find(item =>
                item.properties &&
                item.properties["Actual Product"] == actual_product_id &&
                item.properties["iPhone Extra Custom Text"] == iphone_custom_text_extra
              );

              if (matchingItem2) {
                const newQty2 = matchingItem2.quantity + 1;
                updates[matchingItem2.key] = newQty2;

                $('.engrave-charge .t4s-cart_meta_propertyList[actual_product_id="' + actual_product_id + '"][iphone-custom-text-extra="' + iphone_custom_text_extra + '"]')
                  .parents(".cart-item-data")
                  .find(".qty.quantity")
                  .html(`Qty : <span>${newQty2}</span>`);
              } else {
                console.warn("Matching iPhone extra custom text item not found.");
              }
            }

            // --- Send cart update if needed ---
            if (Object.keys(updates).length > 0) {
              iscart.classList.add('is--contentUpdate');
              const updateRes = await fetch('/cart/update.js', {
                method: 'POST',
                headers: {
                  'Content-Type': 'application/json'
                },
                body: JSON.stringify({ updates })
              });

              const result = await updateRes.json();
              iscart.classList.remove('is--contentUpdate');
              $(document).trigger('cart:updated');
              if (window.location.pathname === "/cart") {
                window.location.reload();
              }
            }

          } catch (error) {
            console.error("Error in iPhone cart update:", error);
          }
        }, 3000);
      } else if (iphone_logo != 0 && !iphone_custom_text.length){
        iphone_logo = $(this).parents(".cart-item-data").find(".t4s-cart_meta_propertyList").attr("iphone-logo");
        setTimeout(function(index, value){
          console.log('logo only')
          $('.engrave-charge .t4s-cart_meta_propertyList[actual_product_id="'+actual_product_id+'"][iphone-logo='+iphone_logo+'][iphone-custom-text=""]').parents(".cart-item-data").find(".quantity .plus").click();
          $('.engrave-charge .t4s-cart_meta_propertyList[actual_product_id="'+actual_product_id+'"][iphone-logo='+iphone_logo+'][iphone-custom-text=""]').parents(".cart-item-data").find(".qty.quantity").html("Qty : <span>"+(parseInt($('.engrave-charge .t4s-cart_meta_propertyList[actual_product_id="'+actual_product_id+'"][iphone-logo='+iphone_logo+'][iphone-custom-text=""]').parents(".cart-item-data").find(".qty.quantity span").text())+1)+"</span>");
        }, 2500);
      } else if (iphone_logo != 0 && iphone_custom_text.length > 0) {
        iphone_logo = $(this).parents(".cart-item-data").find(".t4s-cart_meta_propertyList").attr("iphone-logo");

        setTimeout(async function () {
          let iscart = document.getElementById('t4s-mini_cart') || document.querySelector('.t4s-cartPage__form');
          try {
            const updates = {};

            // Fetch current cart
            const res = await fetch('/cart.js');
            const cart = await res.json();

            // --- First product: iPhone Custom Text + Logo ---
            const matchingItem1 = cart.items.find(item =>
              item.properties &&
              item.properties["Actual Product"] == actual_product_id &&
              item.properties["iPhone Custom Text"] == iphone_custom_text &&
              item.properties["iPhone Logo"]
            );

            if (matchingItem1) {
              const newQty1 = matchingItem1.quantity + 1;
              updates[matchingItem1.key] = newQty1;

              // Update DOM manually
              $('.engrave-charge .t4s-cart_meta_propertyList[actual_product_id="' + actual_product_id + '"][iphone-custom-text="' + iphone_custom_text + '"][iphone-logo="' + iphone_logo + '"]')
                .parents(".cart-item-data")
                .find(".qty.quantity")
                .html(`Qty : <span>${newQty1}</span>`);
            } else {
              console.warn("Matching item for iPhone custom_text + logo not found.");
            }

            // --- Second product: Extra Custom Text (optional) ---
            if (iphone_custom_text_extra.length > 0) {
              const matchingItem2 = cart.items.find(item =>
                item.properties &&
                item.properties["Actual Product"] == actual_product_id &&
                item.properties["iPhone Extra Custom Text"] == iphone_custom_text_extra
              );

              if (matchingItem2) {
                const newQty2 = matchingItem2.quantity + 1;
                updates[matchingItem2.key] = newQty2;

                $('.engrave-charge .t4s-cart_meta_propertyList[actual_product_id="' + actual_product_id + '"][iphone-custom-text-extra="' + iphone_custom_text_extra + '"]')
                  .parents(".cart-item-data")
                  .find(".qty.quantity")
                  .html(`Qty : <span>${newQty2}</span>`);
              } else {
                console.warn("Matching item for iPhone extra custom text not found.");
              }
            }

            // --- Call /cart/update.js once ---
            if (Object.keys(updates).length > 0) {
              iscart.classList.add('is--contentUpdate');
              const updateRes = await fetch('/cart/update.js', {
                method: 'POST',
                headers: {
                  'Content-Type': 'application/json'
                },
                body: JSON.stringify({ updates })
              });

              const result = await updateRes.json();
              iscart.classList.remove('is--contentUpdate');
              $(document).trigger('cart:updated');
              if (window.location.pathname === "/cart") {
                window.location.reload();
              }
            }

          } catch (error) {
            console.error("Error in iPhone logo cart update:", error);
          }
        }, 3000);
      } else if (iphone_logo = 0 && iphone_engrave_text.length > 0){
         setTimeout(function() {
          console.log('engrave text no logo',iphone_engrave_text_length)
          let iphone_engrave_text_str = Array.isArray(iphone_engrave_text)
            ? iphone_engrave_text.join(', ')
            : iphone_engrave_text;
        
          let selector = '.engrave-charge .t4s-cart_meta_propertyList' +
            '[actual_product_id="' + actual_product_id + '"]' +
            '[iphone-engrave-text="' + iphone_engrave_text_str + '"]' +
            '[iphone-image=""][iphone-logo=""]';
        
          let $target = $(selector);
          let $input = $target.parents(".cart-item-data").find("input.t4s-quantity-input.t4s-add-quantity");
        
          let currentQty = parseInt($input.val()) || 0;
          let engraveLength = parseInt(iphone_engrave_text_length) || 0;
        
          let newQty = currentQty + engraveLength;
          $input.val(newQty).trigger('change');
        
          $target.parents(".cart-item-data")
            .find(".qty.quantity")
            .html("Qty : <span>" + newQty + "</span>");
        
        }, 2500);
        
      } else if(iphone_engrave_text.length > 0 && !iphone_image.length) {
        setTimeout(function() {
          console.log('engrave text no logo',iphone_engrave_text_length)
          let iphone_engrave_text_str = Array.isArray(iphone_engrave_text)
            ? iphone_engrave_text.join(', ')
            : iphone_engrave_text;
        
          let selector = '.engrave-charge .t4s-cart_meta_propertyList' +
            '[actual_product_id="' + actual_product_id + '"]' +
            '[iphone-engrave-text="' + iphone_engrave_text_str + '"]' +
            '[iphone-image=""][iphone-logo=""]';
        
          let $target = $(selector);
          let $input = $target.parents(".cart-item-data").find("input.t4s-quantity-input.t4s-add-quantity");
        
          let currentQty = parseInt($input.val()) || 0;
          let engraveLength = parseInt(iphone_engrave_text_length) || 0;
        
          let newQty = currentQty + engraveLength;
          $input.val(newQty).trigger('change');
        
          $target.parents(".cart-item-data")
            .find(".qty.quantity")
            .html("Qty : <span>" + newQty + "</span>");
        
        }, 2500);
      } else if (iphone_logo == 0 && iphone_custom_text.length > 0) {
        setTimeout(async function () {
          let iscart = document.getElementById('t4s-mini_cart') || document.querySelector('.t4s-cartPage__form');
          try {
            const updates = {};

            // Fetch current cart
            const res = await fetch('/cart.js');
            const cart = await res.json();

            // --- First product: iPhone Custom Text without logo or image ---
            const matchingItem1 = cart.items.find(item =>
              item.properties &&
              item.properties["Actual Product"] == actual_product_id &&
              item.properties["iPhone Custom Text"] == iphone_custom_text &&
              !item.properties["iPhone Image"] &&
              !item.properties["iPhone Logo"]
            );

            if (matchingItem1) {
              const newQty1 = matchingItem1.quantity + 1;
              updates[matchingItem1.key] = newQty1;

              // Update DOM manually
              $('.engrave-charge .t4s-cart_meta_propertyList[actual_product_id="' + actual_product_id + '"][iphone-custom-text="' + iphone_custom_text + '"][iphone-image=""][iphone-logo=""]')
                .parents(".cart-item-data")
                .find(".qty.quantity")
                .html(`Qty : <span>${newQty1}</span>`);
            } else {
              console.warn("Matching item for iPhone custom_text without logo/image not found.");
            }

            // --- Second product: iPhone Extra Custom Text (optional) ---
            if (iphone_custom_text_extra.length > 0) {
              const matchingItem2 = cart.items.find(item =>
                item.properties &&
                item.properties["Actual Product"] == actual_product_id &&
                item.properties["iPhone Extra Custom Text"] == iphone_custom_text_extra
              );

              if (matchingItem2) {
                const newQty2 = matchingItem2.quantity + 1;
                updates[matchingItem2.key] = newQty2;
                $('.engrave-charge .t4s-cart_meta_propertyList[actual_product_id="' + actual_product_id + '"][iphone-custom-text-extra="' + iphone_custom_text_extra + '"]')
                  .parents(".cart-item-data")
                  .find(".qty.quantity")
                  .html(`Qty : <span>${newQty2}</span>`);
              } else {
                console.warn("Matching item for iPhone extra custom text not found.");
              }
            }

            // --- Call /cart/update.js once ---
            if (Object.keys(updates).length > 0) {
              iscart.classList.add('is--contentUpdate');
              const updateRes = await fetch('/cart/update.js', {
                method: 'POST',
                headers: {
                  'Content-Type': 'application/json'
                },
                body: JSON.stringify({ updates })
              });

              const result = await updateRes.json();
              iscart.classList.remove('is--contentUpdate');
              $(document).trigger('cart:updated');
              if (window.location.pathname === "/cart") {
                window.location.reload();
              }
            }

          } catch (error) {
            console.error("Error in iPhone text-only cart update:", error);
          }
        }, 3000);
      } else if (iphone_custom_text.length > 0 && !iphone_image.length) {
        setTimeout(async function () {
          let iscart = document.getElementById('t4s-mini_cart') || document.querySelector('.t4s-cartPage__form');
          try {
            const updates = {};

            // Fetch current cart
            const res = await fetch('/cart.js');
            const cart = await res.json();

            // --- First product: iPhone Custom Text ---
            const matchingItem1 = cart.items.find(item =>
              item.properties &&
              item.properties["Actual Product"] == actual_product_id &&
              item.properties["iPhone Custom Text"] == iphone_custom_text &&
              !item.properties["iPhone Image"] &&
              !item.properties["iPhone Logo"]
            );

            if (matchingItem1) {
              const newQty1 = matchingItem1.quantity + 1;
              updates[matchingItem1.key] = newQty1;

              // Update DOM manually
              $('.engrave-charge .t4s-cart_meta_propertyList[actual_product_id="' + actual_product_id + '"][iphone-custom-text="' + iphone_custom_text + '"][iphone-image=""][iphone-logo=""]')
                .parents(".cart-item-data")
                .find(".qty.quantity")
                .html(`Qty : <span>${newQty1}</span>`);
            } else {
              console.warn("Matching item for iPhone custom_text not found.");
            }

            // --- Second product: iPhone Extra Custom Text (optional) ---
            if (iphone_custom_text_extra.length > 0) {
              const matchingItem2 = cart.items.find(item =>
                item.properties &&
                item.properties["Actual Product"] == actual_product_id &&
                item.properties["iPhone Extra Custom Text"] == iphone_custom_text_extra
              );

              if (matchingItem2) {
                const newQty2 = matchingItem2.quantity + 1;
                updates[matchingItem2.key] = newQty2;
                $('.engrave-charge .t4s-cart_meta_propertyList[actual_product_id="' + actual_product_id + '"][iphone-custom-text-extra="' + iphone_custom_text_extra + '"]')
                  .parents(".cart-item-data")
                  .find(".qty.quantity")
                  .html(`Qty : <span>${newQty2}</span>`);
              } else {
                console.warn("Matching item for iPhone extra_custom_text not found.");
              }
            }

            // --- Call /cart/update.js once ---
            if (Object.keys(updates).length > 0) {
              iscart.classList.add('is--contentUpdate');
              const updateRes = await fetch('/cart/update.js', {
                method: 'POST',
                headers: {
                  'Content-Type': 'application/json'
                },
                body: JSON.stringify({ updates })
              });

              const result = await updateRes.json();
              iscart.classList.remove('is--contentUpdate');
              $(document).trigger('cart:updated');
              if (window.location.pathname === "/cart") { window.location.reload(); }
            }

          } catch (error) {
            console.error("Error in combined cart update:", error);
          }
        }, 3000);
      }

    }
      
    //2 added custom text as well
    if(cardholder_engrave_text.length > 0 || cardholder_image.length > 0 || cardholder_logo != 0 && cardholder_logo.length > 0 || cardholder_custom_text.length > 0 || cardholder_custom_text_extra.length > 0){
      if(cardholder_image.length > 0 && !cardholder_custom_text.length){
        cardholder_image = $(this).parents(".cart-item-data").find(".t4s-cart_meta_propertyList").attr("cardholder-image");
        setTimeout(function(index, value){
          console.log('img only')
          $('.engrave-charge .t4s-cart_meta_propertyList[actual_product_id="'+actual_product_id+'"][cardholder-image='+cardholder_image+'][cardholder-custom-text=""]').parents(".cart-item-data").find(".quantity .plus").click();
          $('.engrave-charge .t4s-cart_meta_propertyList[actual_product_id="'+actual_product_id+'"][cardholder-image='+cardholder_image+'][cardholder-custom-text=""]').parents(".cart-item-data").find(".qty.quantity").html("Qty : <span>"+(parseInt($('.engrave-charge .t4s-cart_meta_propertyList[actual_product_id="'+actual_product_id+'"][cardholder-image='+cardholder_image+'][cardholder-custom-text=""]').parents(".cart-item-data").find(".qty.quantity span").text())+1)+"</span>");
        }, 2500);
      } else if(cardholder_image.length > 0 && cardholder_custom_text.length > 0){
        cardholder_image = $(this).parents(".cart-item-data").find(".t4s-cart_meta_propertyList").attr("cardholder-image");
        setTimeout(async function () {
          let iscart = document.getElementById('t4s-mini_cart') || document.querySelector('.t4s-cartPage__form');
          try {
            const updates = {};
        
            // Fetch current cart
            const res = await fetch('/cart.js');
            const cart = await res.json();
        
            // --- First product: Cardholder Custom Text ---
            const matchingItem1 = cart.items.find(item =>
              item.properties &&
              item.properties["Actual Product"] == actual_product_id &&
              item.properties["Cardholder Custom Text"] == cardholder_custom_text &&
              item.properties["Cardholder Image"]
            );
        
            if (matchingItem1) {
              const newQty1 = matchingItem1.quantity + 1;
              updates[matchingItem1.key] = newQty1;
        
              // Update DOM manually
              $('.engrave-charge .t4s-cart_meta_propertyList[actual_product_id="' + actual_product_id + '"][cardholder-custom-text="' + cardholder_custom_text + '"][cardholder-image='+cardholder_image+']')
                .parents(".cart-item-data")
                .find(".qty.quantity")
                .html(`Qty : <span>${newQty1}</span>`);
            } else {
              console.warn("Matching item for custom_text not found.");
            }
        
            // --- Second product: Extra Custom Text (optional) ---
            if (cardholder_custom_text_extra.length > 0) {
              const matchingItem2 = cart.items.find(item =>
                item.properties &&
                item.properties["Actual Product"] == actual_product_id &&
                item.properties["Cardholder Extra Custom Text"] == cardholder_custom_text_extra
              );
        
              if (matchingItem2) {
                const newQty2 = matchingItem2.quantity + 1;
                updates[matchingItem2.key] = newQty2;
                $('.engrave-charge .t4s-cart_meta_propertyList[actual_product_id="' + actual_product_id + '"][cardholder-custom-text-extra="' + cardholder_custom_text_extra + '"]')
                .parents(".cart-item-data")
                .find(".qty.quantity")
                .html(`Qty : <span>${newQty2}</span>`);
              } else {
                console.warn("Matching item for extra_custom_text not found.");
              }
            }
        
            // --- Call /cart/update.js once ---
            if (Object.keys(updates).length > 0) {
              iscart.classList.add('is--contentUpdate');
              const updateRes = await fetch('/cart/update.js', {
                method: 'POST',
                headers: {
                  'Content-Type': 'application/json'
                },
                body: JSON.stringify({ updates })
              });
        
              const result = await updateRes.json();
              iscart.classList.remove('is--contentUpdate');
              $(document).trigger('cart:updated');
              if(window.location.pathname==="/cart"){ window.location.reload()}
            }
        
          } catch (error) {
            console.error("Error in combined cart update:", error);
          }
        }, 3000);
      } else if (cardholder_logo != 0 && !cardholder_custom_text.length){
        cardholder_logo = $(this).parents(".cart-item-data").find(".cart_meta_propertyList").attr("cardholder-logo");
        setTimeout(function(index, value){
          console.log('logo only')
          $('.engrave-charge .t4s-cart_meta_propertyList[actual_product_id="'+actual_product_id+'"][cardholder-logo='+cardholder_logo+'][cardholder-custom-text=""]').parents(".cart-item-data").find(".quantity .plus").click();
          $('.engrave-charge .t4s-cart_meta_propertyList[actual_product_id="'+actual_product_id+'"][cardholder-logo='+cardholder_logo+'][cardholder-custom-text=""]').parents(".cart-item-data").find(".qty.quantity").html("Qty : <span>"+(parseInt($('.engrave-charge .t4s-cart_meta_propertyList[actual_product_id="'+actual_product_id+'"][cardholder-logo='+cardholder_logo+'][cardholder-custom-text=""]').parents(".cart-item-data").find(".qty.quantity span").text())+1)+"</span>");
        }, 2500);
      } else if (cardholder_logo != 0 && cardholder_custom_text.length > 0){
        cardholder_logo = $(this).parents(".cart-item-data").find(".t4s-cart_meta_propertyList").attr("cardholder-logo");
        setTimeout(async function () {
          let iscart = document.getElementById('t4s-mini_cart') || document.querySelector('.t4s-cartPage__form');
          try {
            const updates = {};
        
            // Fetch current cart
            const res = await fetch('/cart.js');
            const cart = await res.json();
        
            // --- First product: Cardholder Custom Text ---
            const matchingItem1 = cart.items.find(item =>
              item.properties &&
              item.properties["Actual Product"] == actual_product_id &&
              item.properties["Cardholder Custom Text"] == cardholder_custom_text &&
              item.properties["Cardholder Logo"]
            );
        
            if (matchingItem1) {
              const newQty1 = matchingItem1.quantity + 1;
              updates[matchingItem1.key] = newQty1;
        
              // Update DOM manually
              $('.engrave-charge .t4s-cart_meta_propertyList[actual_product_id="' + actual_product_id + '"][cardholder-custom-text="' + cardholder_custom_text + '"][cardholder-logo='+cardholder_logo+']')
                .parents(".cart-item-data")
                .find(".qty.quantity")
                .html(`Qty : <span>${newQty1}</span>`);
            } else {
              console.warn("Matching item for custom_text not found.");
            }
        
            // --- Second product: Extra Custom Text (optional) ---
            if (cardholder_custom_text_extra.length > 0) {
              const matchingItem2 = cart.items.find(item =>
                item.properties &&
                item.properties["Actual Product"] == actual_product_id &&
                item.properties["Cardholder Extra Custom Text"] == cardholder_custom_text_extra
              );
        
              if (matchingItem2) {
                const newQty2 = matchingItem2.quantity + 1;
                updates[matchingItem2.key] = newQty2;
                $('.engrave-charge .t4s-cart_meta_propertyList[actual_product_id="' + actual_product_id + '"][cardholder-custom-text-extra="' + cardholder_custom_text_extra + '"]')
                .parents(".cart-item-data")
                .find(".qty.quantity")
                .html(`Qty : <span>${newQty2}</span>`);
              } else {
                console.warn("Matching item for extra_custom_text not found.");
              }
            }
        
            // --- Call /cart/update.js once ---
            if (Object.keys(updates).length > 0) {
               iscart.classList.add('is--contentUpdate');
              const updateRes = await fetch('/cart/update.js', {
                method: 'POST',
                headers: {
                  'Content-Type': 'application/json'
                },
                body: JSON.stringify({ updates })
              });
        
              const result = await updateRes.json();
               iscart.classList.remove('is--contentUpdate');
              $(document).trigger('cart:updated');
              if(window.location.pathname==="/cart"){ window.location.reload()}
            }
        
          } catch (error) {
            console.error("Error in combined cart update:", error);
          }
        }, 3000);

      } else if (cardholder_logo == 0 && cardholder_engrave_text.length > 0){
        setTimeout(function(index, value){
          console.log('engrave text no logo')
          $('.engrave-charge .t4s-cart_meta_propertyList[actual_product_id="'+actual_product_id+'"][cardholder-engrave-text='+cardholder_engrave_text+'][cardholder-image=""][cardholder-logo=""]').parents(".cart-item-data").find(".quantity .plus").click();
          $('.engrave-charge .t4s-cart_meta_propertyList[actual_product_id="'+actual_product_id+'"][cardholder-engrave-text='+cardholder_engrave_text+'][cardholder-image=""][cardholder-logo=""]').parents(".cart-item-data").find(".qty.quantity").html("Qty : <span>"+(parseInt($('.engrave-charge .t4s-cart_meta_propertyList[actual_product_id="'+actual_product_id+'"][cardholder-engrave-text='+cardholder_engrave_text+'][cardholder-image=""][cardholder-logo=""]').parents(".cart-item-data").find(".qty.quantity span").text())+1)+"</span>");
        }, 2500);
      } else if (!cardholder_image.length && cardholder_engrave_text.length > 0){
        setTimeout(function(index, value){
          console.log('engrave text no image')
          $('.engrave-charge .t4s-cart_meta_propertyList[actual_product_id="'+actual_product_id+'"][cardholder-engrave-text='+cardholder_engrave_text+'][cardholder-image=""][cardholder-logo=""]').parents(".cart-item-data").find(".quantity .plus").click();
          $('.engrave-charge .t4s-cart_meta_propertyList[actual_product_id="'+actual_product_id+'"][cardholder-engrave-text='+cardholder_engrave_text+'][cardholder-image=""][cardholder-logo=""]').parents(".cart-item-data").find(".qty.quantity").html("Qty : <span>"+(parseInt($('.engrave-charge .t4s-cart_meta_propertyList[actual_product_id="'+actual_product_id+'"][cardholder-engrave-text='+cardholder_engrave_text+'][cardholder-image=""][cardholder-logo=""]').parents(".cart-item-data").find(".qty.quantity span").text())+1)+"</span>");
        }, 2500);
      } else if (cardholder_logo == 0 && cardholder_custom_text.length > 0){
        setTimeout(async function () {
          let iscart = document.getElementById('t4s-mini_cart') || document.querySelector('.t4s-cartPage__form');
          try {
            const updates = {};
        
            // Fetch current cart
            const res = await fetch('/cart.js');
            const cart = await res.json();
        
            // --- First product: Cardholder Custom Text ---
            const matchingItem1 = cart.items.find(item =>
              item.properties &&
              item.properties["Actual Product"] == actual_product_id &&
              item.properties["Cardholder Custom Text"] == cardholder_custom_text &&
              !item.properties["Cardholder Image"] &&
              !item.properties["Cardholder Logo"]
            );
        
            if (matchingItem1) {
              const newQty1 = matchingItem1.quantity + 1;
              updates[matchingItem1.key] = newQty1;
        
              // Update DOM manually
              $('.engrave-charge .t4s-cart_meta_propertyList[actual_product_id="' + actual_product_id + '"][cardholder-custom-text="' + cardholder_custom_text + '"][cardholder-image=""][cardholder-logo=""]')
                .parents(".cart-item-data")
                .find(".qty.quantity")
                .html(`Qty : <span>${newQty1}</span>`);
            } else {
              console.warn("Matching item for custom_text not found.");
            }
        
            // --- Second product: Extra Custom Text (optional) ---
            if (cardholder_custom_text_extra.length > 0) {
              const matchingItem2 = cart.items.find(item =>
                item.properties &&
                item.properties["Actual Product"] == actual_product_id &&
                item.properties["Cardholder Extra Custom Text"] == cardholder_custom_text_extra
              );
        
              if (matchingItem2) {
                const newQty2 = matchingItem2.quantity + 1;
                updates[matchingItem2.key] = newQty2;
                $('.engrave-charge .t4s-cart_meta_propertyList[actual_product_id="' + actual_product_id + '"][cardholder-custom-text-extra="' + cardholder_custom_text_extra + '"]')
                .parents(".cart-item-data")
                .find(".qty.quantity")
                .html(`Qty : <span>${newQty2}</span>`);
              } else {
                console.warn("Matching item for extra_custom_text not found.");
              }
            }
        
            // --- Call /cart/update.js once ---
            if (Object.keys(updates).length > 0) {
               iscart.classList.add('is--contentUpdate');
              const updateRes = await fetch('/cart/update.js', {
                method: 'POST',
                headers: {
                  'Content-Type': 'application/json'
                },
                body: JSON.stringify({ updates })
              });
        
              const result = await updateRes.json();
               iscart.classList.remove('is--contentUpdate');
              $(document).trigger('cart:updated');
              if(window.location.pathname==="/cart"){ window.location.reload()}
            }
        
          } catch (error) {
            console.error("Error in combined cart update:", error);
          }
        }, 3000);

      } else if (!cardholder_image.length && cardholder_custom_text.length > 0){
        setTimeout(async function () {
          let iscart = document.getElementById('t4s-mini_cart') || document.querySelector('.t4s-cartPage__form');
          try {
            const updates = {};
        
            // Fetch current cart
            const res = await fetch('/cart.js');
            const cart = await res.json();
        
            // --- First product: Cardholder Custom Text ---
            const matchingItem1 = cart.items.find(item =>
              item.properties &&
              item.properties["Actual Product"] == actual_product_id &&
              item.properties["Cardholder Custom Text"] == cardholder_custom_text &&
              !item.properties["Cardholder Image"] &&
              !item.properties["Cardholder Logo"]
            );
        
            if (matchingItem1) {
              const newQty1 = matchingItem1.quantity + 1;
              updates[matchingItem1.key] = newQty1;
        
              // Update DOM manually
              $('.engrave-charge .t4s-cart_meta_propertyList[actual_product_id="' + actual_product_id + '"][cardholder-custom-text="' + cardholder_custom_text + '"][cardholder-image=""][cardholder-logo=""]')
                .parents(".cart-item-data")
                .find(".qty.quantity")
                .html(`Qty : <span>${newQty1}</span>`);
            } else {
              console.warn("Matching item for custom_text not found.");
            }
        
            // --- Second product: Extra Custom Text (optional) ---
            if (cardholder_custom_text_extra.length > 0) {
              const matchingItem2 = cart.items.find(item =>
                item.properties &&
                item.properties["Actual Product"] == actual_product_id &&
                item.properties["Cardholder Extra Custom Text"] == cardholder_custom_text_extra
              );
        
              if (matchingItem2) {
                const newQty2 = matchingItem2.quantity + 1;
                updates[matchingItem2.key] = newQty2;
                $('.engrave-charge .t4s-cart_meta_propertyList[actual_product_id="' + actual_product_id + '"][cardholder-custom-text-extra="' + cardholder_custom_text_extra + '"]')
                .parents(".cart-item-data")
                .find(".qty.quantity")
                .html(`Qty : <span>${newQty2}</span>`);
              } else {
                console.warn("Matching item for extra_custom_text not found.");
              }
            }
        
            // --- Call /cart/update.js once ---
            if (Object.keys(updates).length > 0) {
               iscart.classList.add('is--contentUpdate')
              const updateRes = await fetch('/cart/update.js', {
                method: 'POST',
                headers: {
                  'Content-Type': 'application/json'
                },
                body: JSON.stringify({ updates })
              });
        
              const result = await updateRes.json();
               iscart.classList.remove('is--contentUpdate');
              $(document).trigger('cart:updated');
              if(window.location.pathname==="/cart"){ window.location.reload()}
            }
        
          } catch (error) {
            console.error("Error in combined cart update:", error);
          }
        }, 3000);
      }
    }

    //3 added custom text as well
    if(airpods_engrave_text.length > 0){
      setTimeout(function(index, value){
        $(".engrave-charge .t4s-cart_meta_propertyList[actual_product_id='"+actual_product_id+"'][airpods-engrave-text="+airpods_engrave_text+"]").parents(".cart-item-data").find(".quantity .plus").click();
        $(".engrave-charge .t4s-cart_meta_propertyList[actual_product_id='"+actual_product_id+"'][airpods-engrave-text="+airpods_engrave_text+"]").parents(".cart-item-data").find(".qty.quantity").html("Qty : <span>"+(parseInt($(".engrave-charge .t4s-cart_meta_propertyList[actual_product_id='"+actual_product_id+"'][airpods-engrave-text="+airpods_engrave_text+"]").parents(".cart-item-data").find(".qty.quantity span").text())+1)+"</span>");
      }, 2500);
    } else if (airpods_custom_text.length > 0){
      setTimeout(function(index, value){
        $(".engrave-charge .t4s-cart_meta_propertyList[actual_product_id='"+actual_product_id+"'][airpods-custom-text="+airpods_custom_text+"]").parents(".cart-item-data").find(".quantity .plus").click();
        $(".engrave-charge .t4s-cart_meta_propertyList[actual_product_id='"+actual_product_id+"'][airpods-custom-text="+airpods_custom_text+"]").parents(".cart-item-data").find(".qty.quantity").html("Qty : <span>"+(parseInt($(".engrave-charge .t4s-cart_meta_propertyList[actual_product_id='"+actual_product_id+"'][airpods-custom-text="+airpods_custom_text+"]").parents(".cart-item-data").find(".qty.quantity span").text())+1)+"</span>");
      }, 2500);
    }

    //4 added custom text as well
    if(watch_engrave_text.length > 0){
      setTimeout(function(index, value){
        $(".engrave-charge .t4s-cart_meta_propertyList[actual_product_id='"+actual_product_id+"'][watch-engrave-text="+watch_engrave_text+"]").parents(".cart-item-data").find(".quantity .plus").click();
        $(".engrave-charge .t4s-cart_meta_propertyList[actual_product_id='"+actual_product_id+"'][watch-engrave-text="+watch_engrave_text+"]").parents(".cart-item-data").find(".qty.quantity").html("Qty : <span>"+(parseInt($(".engrave-charge .t4s-cart_meta_propertyList[actual_product_id='"+actual_product_id+"'][watch-engrave-text="+watch_engrave_text+"]").parents(".cart-item-data").find(".qty.quantity span").text())+1)+"</span>");
      }, 2500);
    } else if (watch_custom_text.length > 0){
      setTimeout(function(index, value){
        $(".engrave-charge .t4s-cart_meta_propertyList[actual_product_id='"+actual_product_id+"'][watch-custom-text="+watch_custom_text+"]").parents(".cart-item-data").find(".quantity .plus").click();
        $(".engrave-charge .t4s-cart_meta_propertyList[actual_product_id='"+actual_product_id+"'][watch-custom-text="+watch_custom_text+"]").parents(".cart-item-data").find(".qty.quantity").html("Qty : <span>"+(parseInt($(".engrave-charge .t4s-cart_meta_propertyList[actual_product_id='"+actual_product_id+"'][watch-custom-text="+watch_custom_text+"]").parents(".cart-item-data").find(".qty.quantity span").text())+1)+"</span>");
      }, 2500);
    }

    //5 added custom text as well
    if(wallet_engrave_text.length > 0 || wallet_image.length > 0 || wallet_logo != 0 && wallet_logo.length > 0 || wallet_custom_text.length > 0 || wallet_custom_text_extra.length > 0){
      if(wallet_image.length > 0 && !wallet_custom_text.length){
        wallet_image = $(this).parents(".cart-item-data").find(".t4s-cart_meta_propertyList").attr("wallet-image");
        setTimeout(function(index, value){
          console.log('img only')
          $('.engrave-charge .t4s-cart_meta_propertyList[actual_product_id="'+actual_product_id+'"][wallet-image='+wallet_image+'][wallet-custom-text=""]').parents(".cart-item-data").find(".quantity .plus").click();
          $('.engrave-charge .t4s-cart_meta_propertyList[actual_product_id="'+actual_product_id+'"][wallet-image='+wallet_image+'][wallet-custom-text=""]').parents(".cart-item-data").find(".qty.quantity").html("Qty : <span>"+(parseInt($('.engrave-charge .t4s-cart_meta_propertyList[actual_product_id="'+actual_product_id+'"][wallet-image='+wallet_image+'][wallet-custom-text=""]').parents(".cart-item-data").find(".qty.quantity span").text())+1)+"</span>");
        }, 2500);
      } else if (wallet_image.length > 0 && wallet_custom_text.length > 0) {
        wallet_image = $(this).parents(".cart-item-data").find(".t4s-cart_meta_propertyList").attr("wallet-image");
        setTimeout(async function () {
          let iscart = document.getElementById('t4s-mini_cart') || document.querySelector('.t4s-cartPage__form');
          
          const updates = {};

          // Fetch current cart
          const res = await fetch('/cart.js');
          const cart = await res.json();

          // --- First product: Wallet Custom Text + Image ---
          const matchingItem1 = cart.items.find(item =>
            item.properties &&
            item.properties["Actual Product"] == actual_product_id &&
            item.properties["Wallet Custom Text"] == wallet_custom_text &&
            item.properties["Wallet Image"]
          );

          if (matchingItem1) {
            const newQty1 = matchingItem1.quantity + 1;
            updates[matchingItem1.key] = newQty1;

            // Update DOM manually
            $('.engrave-charge .t4s-cart_meta_propertyList[actual_product_id="' + actual_product_id + '"][wallet-custom-text="' + wallet_custom_text + '"][wallet-image="' + wallet_image + '"]')
              .parents(".cart-item-data")
              .find(".qty.quantity")
              .html(`Qty : <span>${newQty1}</span>`);
          } else {
            console.warn("Matching item for wallet custom_text + image not found.");
          }

          // --- Second product: Extra Custom Text (optional) ---
          if (wallet_custom_text_extra.length > 0) {
            const matchingItem2 = cart.items.find(item =>
              item.properties &&
              item.properties["Actual Product"] == actual_product_id &&
              item.properties["Wallet Extra Custom Text"] == wallet_custom_text_extra
            );

            if (matchingItem2) {
              const newQty2 = matchingItem2.quantity + 1;
              updates[matchingItem2.key] = newQty2;

              $('.engrave-charge .t4s-cart_meta_propertyList[actual_product_id="' + actual_product_id + '"][wallet-custom-text-extra="' + wallet_custom_text_extra + '"]')
                .parents(".cart-item-data")
                .find(".qty.quantity")
                .html(`Qty : <span>${newQty2}</span>`);
            } else {
              console.warn("Matching item for wallet extra_custom_text not found.");
            }
          }

          // --- Call /cart/update.js once ---
          if (Object.keys(updates).length > 0) {
            iscart.classList.add('is--contentUpdate');
            const updateRes = await fetch('/cart/update.js', {
              method: 'POST',
              headers: {
                'Content-Type': 'application/json'
              },
              body: JSON.stringify({ updates })
            });

            const result = await updateRes.json();
            iscart.classList.remove('is--contentUpdate');
            $(document).trigger('cart:updated');
            if (window.location.pathname === "/cart") {
              window.location.reload();
            }
          }
         
        }, 3000);
      } else if (wallet_logo != 0 && !wallet_custom_text.length){
        wallet_logo = $(this).parents(".cart-item-data").find(".t4s-cart_meta_propertyList").attr("wallet-logo");
        setTimeout(function(index, value){
          console.log('logo only')
          $('.engrave-charge .t4s-cart_meta_propertyList[actual_product_id="'+actual_product_id+'"][wallet-logo='+wallet_logo+'][wallet-custom-text=""]').parents(".cart-item-data").find(".quantity .plus").click();
          $('.engrave-charge .t4s-cart_meta_propertyList[actual_product_id="'+actual_product_id+'"][wallet-logo='+wallet_logo+'][wallet-custom-text=""]').parents(".cart-item-data").find(".qty.quantity").html("Qty : <span>"+(parseInt($('.engrave-charge .t4s-cart_meta_propertyList[actual_product_id="'+actual_product_id+'"][wallet-logo='+wallet_logo+'][wallet-custom-text=""]').parents(".cart-item-data").find(".qty.quantity span").text())+1)+"</span>");
        }, 2500);
      } else if (wallet_logo != 0 && wallet_custom_text.length > 0) {
        wallet_logo = $(this).parents(".cart-item-data").find(".t4s-cart_meta_propertyList").attr("wallet-logo");

        setTimeout(async function () {
          let iscart = document.getElementById('t4s-mini_cart') || document.querySelector('.t4s-cartPage__form');

          try {
            const updates = {};

            // Fetch current cart
            const res = await fetch('/cart.js');
            const cart = await res.json();

            // --- First product: Wallet Custom Text + Logo ---
            const matchingItem1 = cart.items.find(item =>
              item.properties &&
              item.properties["Actual Product"] == actual_product_id &&
              item.properties["Wallet Custom Text"] == wallet_custom_text &&
              item.properties["Wallet Logo"]
            );

            if (matchingItem1) {
              const newQty1 = matchingItem1.quantity + 1;
              updates[matchingItem1.key] = newQty1;

              // Update DOM manually
              $('.engrave-charge .t4s-cart_meta_propertyList[actual_product_id="' + actual_product_id + '"][wallet-custom-text="' + wallet_custom_text + '"][wallet-logo="' + wallet_logo + '"]')
                .parents(".cart-item-data")
                .find(".qty.quantity")
                .html(`Qty : <span>${newQty1}</span>`);
            } else {
              console.warn("Matching wallet item for custom text + logo not found.");
            }

            // --- Second product: Extra Custom Text (optional) ---
            if (wallet_custom_text_extra.length > 0) {
              const matchingItem2 = cart.items.find(item =>
                item.properties &&
                item.properties["Actual Product"] == actual_product_id &&
                item.properties["Wallet Extra Custom Text"] == wallet_custom_text_extra
              );

              if (matchingItem2) {
                const newQty2 = matchingItem2.quantity + 1;
                updates[matchingItem2.key] = newQty2;

                $('.engrave-charge .t4s-cart_meta_propertyList[actual_product_id="' + actual_product_id + '"][wallet-custom-text-extra="' + wallet_custom_text_extra + '"]')
                  .parents(".cart-item-data")
                  .find(".qty.quantity")
                  .html(`Qty : <span>${newQty2}</span>`);
              } else {
                console.warn("Matching wallet item for extra custom text not found.");
              }
            }

            // --- Call /cart/update.js once ---
            if (Object.keys(updates).length > 0) {
              iscart.classList.add('is--contentUpdate');
              const updateRes = await fetch('/cart/update.js', {
                method: 'POST',
                headers: {
                  'Content-Type': 'application/json'
                },
                body: JSON.stringify({ updates })
              });

              const result = await updateRes.json();
              iscart.classList.remove('is--contentUpdate');
              $(document).trigger('cart:updated');

              if (window.location.pathname === "/cart") {
                window.location.reload();
              }
            }

          } catch (error) {
            console.error("Error in wallet logo + text cart update:", error);
          }
        }, 3000);
      } else if (wallet_logo == 0 && wallet_engrave_text.length > 0){
        setTimeout(function() {
          console.log('engrave text no logo',wallet_engrave_text_length)
          let wallet_engrave_text_str = Array.isArray(wallet_engrave_text)
            ? wallet_engrave_text.join(', ')
            : wallet_engrave_text;
        
          let selector = '.engrave-charge .t4s-cart_meta_propertyList' +
            '[actual_product_id="' + actual_product_id + '"]' +
            '[wallet-engrave-text="' + wallet_engrave_text_str + '"]' +
            '[wallet-image=""][wallet-logo=""]';
        
          let $target = $(selector);
          let $input = $target.parents(".cart-item-data").find("input.t4s-quantity-input.t4s-add-quantity");
        
          let currentQty = parseInt($input.val()) || 0;
          let engraveLength = parseInt(wallet_engrave_text_length) || 0;
        
          let newQty = currentQty + engraveLength;
          $input.val(newQty).trigger('change');
        
          $target.parents(".cart-item-data")
            .find(".qty.quantity")
            .html("Qty : <span>" + newQty + "</span>");
        
        }, 2500);
      } else if (!wallet_image.length && wallet_engrave_text.length > 0){
        setTimeout(function() {
          console.log('engrave text no logo',wallet_engrave_text_length)
          let wallet_engrave_text_str = Array.isArray(wallet_engrave_text)
            ? wallet_engrave_text.join(', ')
            : wallet_engrave_text;
        
          let selector = '.engrave-charge .t4s-cart_meta_propertyList' +
            '[actual_product_id="' + actual_product_id + '"]' +
            '[wallet-engrave-text="' + wallet_engrave_text_str + '"]' +
            '[wallet-image=""][wallet-logo=""]';
        
          let $target = $(selector);
          let $input = $target.parents(".cart-item-data").find("input.t4s-quantity-input.t4s-add-quantity");
        
          let currentQty = parseInt($input.val()) || 0;
          let engraveLength = parseInt(wallet_engrave_text_length) || 0;
        
          let newQty = currentQty + engraveLength;
          $input.val(newQty).trigger('change');
        
          $target.parents(".cart-item-data")
            .find(".qty.quantity")
            .html("Qty : <span>" + newQty + "</span>");
        
        }, 2500);
      } else if (wallet_logo == 0 && wallet_custom_text.length > 0) {
        setTimeout(async function () {
          let iscart = document.getElementById('t4s-mini_cart') || document.querySelector('.t4s-cartPage__form');

          try {
            const updates = {};

            // Fetch current cart
            const res = await fetch('/cart.js');
            const cart = await res.json();

            // --- First product: Wallet Custom Text only ---
            const matchingItem1 = cart.items.find(item =>
              item.properties &&
              item.properties["Actual Product"] == actual_product_id &&
              item.properties["Wallet Custom Text"] == wallet_custom_text &&
              !item.properties["Wallet Image"] &&
              !item.properties["Wallet Logo"]
            );

            if (matchingItem1) {
              const newQty1 = matchingItem1.quantity + 1;
              updates[matchingItem1.key] = newQty1;

              // Update DOM manually
              $('.engrave-charge .t4s-cart_meta_propertyList[actual_product_id="' + actual_product_id + '"][wallet-custom-text="' + wallet_custom_text + '"][wallet-image=""][wallet-logo=""]')
                .parents(".cart-item-data")
                .find(".qty.quantity")
                .html(`Qty : <span>${newQty1}</span>`);
            } else {
              console.warn("Matching wallet item for custom text only not found.");
            }

            // --- Second product: Wallet Extra Custom Text (optional) ---
            if (wallet_custom_text_extra.length > 0) {
              const matchingItem2 = cart.items.find(item =>
                item.properties &&
                item.properties["Actual Product"] == actual_product_id &&
                item.properties["Wallet Extra Custom Text"] == wallet_custom_text_extra
              );

              if (matchingItem2) {
                const newQty2 = matchingItem2.quantity + 1;
                updates[matchingItem2.key] = newQty2;

                $('.engrave-charge .t4s-cart_meta_propertyList[actual_product_id="' + actual_product_id + '"][wallet-custom-text-extra="' + wallet_custom_text_extra + '"]')
                  .parents(".cart-item-data")
                  .find(".qty.quantity")
                  .html(`Qty : <span>${newQty2}</span>`);
              } else {
                console.warn("Matching wallet item for extra custom text not found.");
              }
            }

            // --- Call /cart/update.js once ---
            if (Object.keys(updates).length > 0) {
              iscart.classList.add('is--contentUpdate');
              const updateRes = await fetch('/cart/update.js', {
                method: 'POST',
                headers: {
                  'Content-Type': 'application/json'
                },
                body: JSON.stringify({ updates })
              });

              const result = await updateRes.json();
              iscart.classList.remove('is--contentUpdate');
              $(document).trigger('cart:updated');

              if (window.location.pathname === "/cart") {
                window.location.reload();
              }
            }

          } catch (error) {
            console.error("Error in wallet custom text only cart update:", error);
          }
        }, 3000);
      } else if (!wallet_image.length && wallet_custom_text.length > 0){
        setTimeout(async function () {
          let iscart = document.getElementById('t4s-mini_cart') || document.querySelector('.t4s-cartPage__form');

          try {
            const updates = {};

            // Fetch current cart
            const res = await fetch('/cart.js');
            const cart = await res.json();

            // --- First product: Wallet Custom Text only ---
            const matchingItem1 = cart.items.find(item =>
              item.properties &&
              item.properties["Actual Product"] == actual_product_id &&
              item.properties["Wallet Custom Text"] == wallet_custom_text &&
              !item.properties["Wallet Image"] &&
              !item.properties["Wallet Logo"]
            );

            if (matchingItem1) {
              const newQty1 = matchingItem1.quantity + 1;
              updates[matchingItem1.key] = newQty1;

              // Update DOM manually
              $('.engrave-charge .t4s-cart_meta_propertyList[actual_product_id="' + actual_product_id + '"][wallet-custom-text="' + wallet_custom_text + '"][wallet-image=""][wallet-logo=""]')
                .parents(".cart-item-data")
                .find(".qty.quantity")
                .html(`Qty : <span>${newQty1}</span>`);
            } else {
              console.warn("Matching wallet item for custom text only not found.");
            }

            // --- Second product: Wallet Extra Custom Text (optional) ---
            if (wallet_custom_text_extra.length > 0) {
              const matchingItem2 = cart.items.find(item =>
                item.properties &&
                item.properties["Actual Product"] == actual_product_id &&
                item.properties["Wallet Extra Custom Text"] == wallet_custom_text_extra
              );

              if (matchingItem2) {
                const newQty2 = matchingItem2.quantity + 1;
                updates[matchingItem2.key] = newQty2;

                $('.engrave-charge .t4s-cart_meta_propertyList[actual_product_id="' + actual_product_id + '"][wallet-custom-text-extra="' + wallet_custom_text_extra + '"]')
                  .parents(".cart-item-data")
                  .find(".qty.quantity")
                  .html(`Qty : <span>${newQty2}</span>`);
              } else {
                console.warn("Matching wallet item for extra custom text not found.");
              }
            }

            // --- Call /cart/update.js once ---
            if (Object.keys(updates).length > 0) {
              iscart.classList.add('is--contentUpdate');
              const updateRes = await fetch('/cart/update.js', {
                method: 'POST',
                headers: {
                  'Content-Type': 'application/json'
                },
                body: JSON.stringify({ updates })
              });

              const result = await updateRes.json();
              iscart.classList.remove('is--contentUpdate');
              $(document).trigger('cart:updated');

              if (window.location.pathname === "/cart") {
                window.location.reload();
              }
            }

          } catch (error) {
            console.error("Error in wallet custom text only cart update:", error);
          }
        }, 3000);
      }
    }

    //6 added custom text as well
    if(lanyard_engrave_text.length > 0 || lanyard_image.length > 0 || lanyard_logo != 0 && lanyard_logo.length > 0 || lanyard_custom_text.length > 0 || lanyard_custom_text_extra.length > 0){
      if(lanyard_image.length > 0 && !lanyard_custom_text.length){
        lanyard_image = $(this).parents(".cart-item-data").find(".t4s-cart_meta_propertyList").attr("lanyard-image");
        setTimeout(function(index, value){
          console.log('img only')
          $('.engrave-charge .t4s-cart_meta_propertyList[actual_product_id="'+actual_product_id+'"][lanyard-image='+lanyard_image+'][lanyard-custom-text=""]').parents(".cart-item-data").find(".quantity .plus").click();
          $('.engrave-charge .t4s-cart_meta_propertyList[actual_product_id="'+actual_product_id+'"][lanyard-image='+lanyard_image+'][lanyard-custom-text=""]').parents(".cart-item-data").find(".qty.quantity").html("Qty : <span>"+(parseInt($('.engrave-charge .t4s-cart_meta_propertyList[actual_product_id="'+actual_product_id+'"][lanyard-image='+lanyard_image+'][lanyard-custom-text=""]').parents(".cart-item-data").find(".qty.quantity span").text())+1)+"</span>");
        }, 2500);
      } else if (lanyard_image.length > 0 && lanyard_custom_text.length > 0) {
        lanyard_image = $(this).parents(".cart-item-data").find(".t4s-cart_meta_propertyList").attr("lanyard-image");

        setTimeout(async function () {
          let iscart = document.getElementById('t4s-mini_cart') || document.querySelector('.t4s-cartPage__form');

          try {
            const updates = {};

            // Fetch current cart
            const res = await fetch('/cart.js');
            const cart = await res.json();

            // --- First product: Lanyard Custom Text ---
            const matchingItem1 = cart.items.find(item =>
              item.properties &&
              item.properties["Actual Product"] == actual_product_id &&
              item.properties["Lanyard Custom Text"] == lanyard_custom_text &&
              item.properties["Lanyard Image"]
            );

            if (matchingItem1) {
              const newQty1 = matchingItem1.quantity + 1;
              updates[matchingItem1.key] = newQty1;

              // Update DOM manually
              $('.engrave-charge .t4s-cart_meta_propertyList[actual_product_id="' + actual_product_id + '"][lanyard-custom-text="' + lanyard_custom_text + '"][lanyard-image=' + lanyard_image + ']')
                .parents(".cart-item-data")
                .find(".qty.quantity")
                .html(`Qty : <span>${newQty1}</span>`);
            } else {
              console.warn("Matching item for lanyard_custom_text not found.");
            }

            // --- Second product: Lanyard Extra Custom Text (optional) ---
            if (lanyard_custom_text_extra.length > 0) {
              const matchingItem2 = cart.items.find(item =>
                item.properties &&
                item.properties["Actual Product"] == actual_product_id &&
                item.properties["Lanyard Extra Custom Text"] == lanyard_custom_text_extra
              );

              if (matchingItem2) {
                const newQty2 = matchingItem2.quantity + 1;
                updates[matchingItem2.key] = newQty2;

                $('.engrave-charge .t4s-cart_meta_propertyList[actual_product_id="' + actual_product_id + '"][lanyard-custom-text-extra="' + lanyard_custom_text_extra + '"]')
                  .parents(".cart-item-data")
                  .find(".qty.quantity")
                  .html(`Qty : <span>${newQty2}</span>`);
              } else {
                console.warn("Matching item for lanyard_custom_text_extra not found.");
              }
            }

            // --- Call /cart/update.js once ---
            if (Object.keys(updates).length > 0) {
              iscart.classList.add('is--contentUpdate');
              const updateRes = await fetch('/cart/update.js', {
                method: 'POST',
                headers: {
                  'Content-Type': 'application/json'
                },
                body: JSON.stringify({ updates })
              });

              const result = await updateRes.json();
              iscart.classList.remove('is--contentUpdate');
              $(document).trigger('cart:updated');
              if (window.location.pathname === "/cart") {
                window.location.reload();
              }
            }

          } catch (error) {
            console.error("Error in combined cart update:", error);
          }
        }, 3000);
      } else if (lanyard_logo != 0 && !lanyard_custom_text.length){
        lanyard_logo = $(this).parents(".cart-item-data").find(".t4s-cart_meta_propertyList").attr("lanyard-logo");
        setTimeout(function(index, value){
          console.log('logo only')
          $('.engrave-charge .t4s-cart_meta_propertyList[actual_product_id="'+actual_product_id+'"][lanyard-logo='+lanyard_logo+'][lanyard-custom-text=""]').parents(".cart-item-data").find(".quantity .plus").click();
          $('.engrave-charge .t4s-cart_meta_propertyList[actual_product_id="'+actual_product_id+'"][lanyard-logo='+lanyard_logo+'][lanyard-custom-text=""]').parents(".cart-item-data").find(".qty.quantity").html("Qty : <span>"+(parseInt($('.engrave-charge .t4s-cart_meta_propertyList[actual_product_id="'+actual_product_id+'"][lanyard-logo='+lanyard_logo+'][lanyard-custom-text=""]').parents(".cart-item-data").find(".qty.quantity span").text())+1)+"</span>");
        }, 2500);
      } else if (lanyard_logo != 0 && lanyard_custom_text.length > 0) {
        lanyard_logo = $(this).parents(".cart-item-data").find(".t4s-cart_meta_propertyList").attr("lanyard-logo");

        setTimeout(async function () {
          let iscart = document.getElementById('t4s-mini_cart') || document.querySelector('.t4s-cartPage__form');

          try {
            const updates = {};

            // Fetch current cart
            const res = await fetch('/cart.js');
            const cart = await res.json();

            // --- First product: Lanyard Custom Text ---
            const matchingItem1 = cart.items.find(item =>
              item.properties &&
              item.properties["Actual Product"] == actual_product_id &&
              item.properties["Lanyard Custom Text"] == lanyard_custom_text &&
              item.properties["Lanyard Logo"]
            );

            if (matchingItem1) {
              const newQty1 = matchingItem1.quantity + 1;
              updates[matchingItem1.key] = newQty1;

              // Update DOM manually
              $('.engrave-charge .t4s-cart_meta_propertyList[actual_product_id="' + actual_product_id + '"][lanyard-custom-text="' + lanyard_custom_text + '"][lanyard-logo=' + lanyard_logo + ']')
                .parents(".cart-item-data")
                .find(".qty.quantity")
                .html(`Qty : <span>${newQty1}</span>`);
            } else {
              console.warn("Matching item for lanyard_custom_text not found.");
            }

            // --- Second product: Lanyard Extra Custom Text (optional) ---
            if (lanyard_custom_text_extra.length > 0) {
              const matchingItem2 = cart.items.find(item =>
                item.properties &&
                item.properties["Actual Product"] == actual_product_id &&
                item.properties["Lanyard Extra Custom Text"] == lanyard_custom_text_extra
              );

              if (matchingItem2) {
                const newQty2 = matchingItem2.quantity + 1;
                updates[matchingItem2.key] = newQty2;

                $('.engrave-charge .t4s-cart_meta_propertyList[actual_product_id="' + actual_product_id + '"][lanyard-custom-text-extra="' + lanyard_custom_text_extra + '"]')
                  .parents(".cart-item-data")
                  .find(".qty.quantity")
                  .html(`Qty : <span>${newQty2}</span>`);
              } else {
                console.warn("Matching item for lanyard_custom_text_extra not found.");
              }
            }

            // --- Call /cart/update.js once ---
            if (Object.keys(updates).length > 0) {
              iscart.classList.add('is--contentUpdate');
              const updateRes = await fetch('/cart/update.js', {
                method: 'POST',
                headers: {
                  'Content-Type': 'application/json'
                },
                body: JSON.stringify({ updates })
              });

              const result = await updateRes.json();
              iscart.classList.remove('is--contentUpdate');
              $(document).trigger('cart:updated');
              if (window.location.pathname === "/cart") {
                window.location.reload();
              }
            }

          } catch (error) {
            console.error("Error in combined cart update:", error);
          }
        }, 3000);
      } else if (lanyard_logo == 0 && lanyard_engrave_text.length > 0){
        setTimeout(function() {
          console.log('engrave text no logo',lanyard_engrave_text_length)
          let lanyard_engrave_text_str = Array.isArray(lanyard_engrave_text)
            ? lanyard_engrave_text.join(', ')
            : lanyard_engrave_text;
        
          let selector = '.engrave-charge .t4s-cart_meta_propertyList' +
            '[actual_product_id="' + actual_product_id + '"]' +
            '[lanyard-engrave-text="' + lanyard_engrave_text_str + '"]' +
            '[lanyard-image=""][lanyard-logo=""]';
        
          let $target = $(selector);
          let $input = $target.parents(".cart-item-data").find("input.t4s-quantity-input.t4s-add-quantity");
        
          let currentQty = parseInt($input.val()) || 0;
          let engraveLength = parseInt(lanyard_engrave_text_length) || 0;
        
          let newQty = currentQty + engraveLength;
          $input.val(newQty).trigger('change');
        
          $target.parents(".cart-item-data")
            .find(".qty.quantity")
            .html("Qty : <span>" + newQty + "</span>");
        
        }, 2500);

      } else if (!lanyard_image.length && lanyard_engrave_text.length > 0){
        setTimeout(function() {
          console.log('engrave text no logo',lanyard_engrave_text_length)
          let lanyard_engrave_text_str = Array.isArray(lanyard_engrave_text)
            ? lanyard_engrave_text.join(', ')
            : lanyard_engrave_text;
        
          let selector = '.engrave-charge .t4s-cart_meta_propertyList' +
            '[actual_product_id="' + actual_product_id + '"]' +
            '[lanyard-engrave-text="' + lanyard_engrave_text_str + '"]' +
            '[lanyard-image=""][lanyard-logo=""]';
        
          let $target = $(selector);
          let $input = $target.parents(".cart-item-data").find("input.t4s-quantity-input.t4s-add-quantity");
        
          let currentQty = parseInt($input.val()) || 0;
          let engraveLength = parseInt(lanyard_engrave_text_length) || 0;
        
          let newQty = currentQty + engraveLength;
          $input.val(newQty).trigger('change');
        
          $target.parents(".cart-item-data")
            .find(".qty.quantity")
            .html("Qty : <span>" + newQty + "</span>");
        
        }, 2500);
      } else if (lanyard_logo == 0 && lanyard_custom_text.length > 0) {
        setTimeout(async function () {
          let iscart = document.getElementById('t4s-mini_cart') || document.querySelector('.t4s-cartPage__form');
          try {
            const updates = {};

            // Fetch current cart
            const res = await fetch('/cart.js');
            const cart = await res.json();

            // --- First product: Lanyard Custom Text ---
            const matchingItem1 = cart.items.find(item =>
              item.properties &&
              item.properties["Actual Product"] == actual_product_id &&
              item.properties["Lanyard Custom Text"] == lanyard_custom_text &&
              !item.properties["Lanyard Image"] &&
              !item.properties["Lanyard Logo"]
            );

            if (matchingItem1) {
              const newQty1 = matchingItem1.quantity + 1;
              updates[matchingItem1.key] = newQty1;

              // Update DOM manually
              $('.engrave-charge .t4s-cart_meta_propertyList[actual_product_id="' + actual_product_id + '"][lanyard-custom-text="' + lanyard_custom_text + '"][lanyard-image=""][lanyard-logo=""]')
                .parents(".cart-item-data")
                .find(".qty.quantity")
                .html(`Qty : <span>${newQty1}</span>`);
            } else {
              console.warn("Matching item for lanyard custom_text not found.");
            }

            // --- Second product: Extra Custom Text (optional) ---
            if (lanyard_custom_text_extra.length > 0) {
              const matchingItem2 = cart.items.find(item =>
                item.properties &&
                item.properties["Actual Product"] == actual_product_id &&
                item.properties["Lanyard Extra Custom Text"] == lanyard_custom_text_extra
              );

              if (matchingItem2) {
                const newQty2 = matchingItem2.quantity + 1;
                updates[matchingItem2.key] = newQty2;
                $('.engrave-charge .t4s-cart_meta_propertyList[actual_product_id="' + actual_product_id + '"][lanyard-custom-text-extra="' + lanyard_custom_text_extra + '"]')
                  .parents(".cart-item-data")
                  .find(".qty.quantity")
                  .html(`Qty : <span>${newQty2}</span>`);
              } else {
                console.warn("Matching item for lanyard extra_custom_text not found.");
              }
            }

            // --- Call /cart/update.js once ---
            if (Object.keys(updates).length > 0) {
              iscart.classList.add('is--contentUpdate');
              const updateRes = await fetch('/cart/update.js', {
                method: 'POST',
                headers: {
                  'Content-Type': 'application/json'
                },
                body: JSON.stringify({ updates })
              });

              const result = await updateRes.json();
              iscart.classList.remove('is--contentUpdate');
              $(document).trigger('cart:updated');
              if (window.location.pathname === "/cart") {
                window.location.reload();
              }
            }

          } catch (error) {
            console.error("Error in combined cart update:", error);
          }
        }, 3000);
      } else if (!lanyard_image.length && lanyard_custom_text.length > 0) {
        setTimeout(async function () {
          let iscart = document.getElementById('t4s-mini_cart') || document.querySelector('.t4s-cartPage__form');
          try {
            const updates = {};

            // Fetch current cart
            const res = await fetch('/cart.js');
            const cart = await res.json();

            // --- First product: Lanyard Custom Text ---
            const matchingItem1 = cart.items.find(item =>
              item.properties &&
              item.properties["Actual Product"] == actual_product_id &&
              item.properties["Lanyard Custom Text"] == lanyard_custom_text &&
              !item.properties["Lanyard Image"] &&
              !item.properties["Lanyard Logo"]
            );

            if (matchingItem1) {
              const newQty1 = matchingItem1.quantity + 1;
              updates[matchingItem1.key] = newQty1;

              // Update DOM manually
              $('.engrave-charge .t4s-cart_meta_propertyList[actual_product_id="' + actual_product_id + '"][lanyard-custom-text="' + lanyard_custom_text + '"][lanyard-image=""][lanyard-logo=""]')
                .parents(".cart-item-data")
                .find(".qty.quantity")
                .html(`Qty : <span>${newQty1}</span>`);
            } else {
              console.warn("Matching item for lanyard custom_text not found.");
            }

            // --- Second product: Extra Custom Text (optional) ---
            if (lanyard_custom_text_extra.length > 0) {
              const matchingItem2 = cart.items.find(item =>
                item.properties &&
                item.properties["Actual Product"] == actual_product_id &&
                item.properties["Lanyard Extra Custom Text"] == lanyard_custom_text_extra
              );

              if (matchingItem2) {
                const newQty2 = matchingItem2.quantity + 1;
                updates[matchingItem2.key] = newQty2;
                $('.engrave-charge .t4s-cart_meta_propertyList[actual_product_id="' + actual_product_id + '"][lanyard-custom-text-extra="' + lanyard_custom_text_extra + '"]')
                  .parents(".cart-item-data")
                  .find(".qty.quantity")
                  .html(`Qty : <span>${newQty2}</span>`);
              } else {
                console.warn("Matching item for lanyard extra_custom_text not found.");
              }
            }

            // --- Call /cart/update.js once ---
            if (Object.keys(updates).length > 0) {
              iscart.classList.add('is--contentUpdate')
              const updateRes = await fetch('/cart/update.js', {
                method: 'POST',
                headers: {
                  'Content-Type': 'application/json'
                },
                body: JSON.stringify({ updates })
              });

              const result = await updateRes.json();
              iscart.classList.remove('is--contentUpdate');
              $(document).trigger('cart:updated');
              if (window.location.pathname === "/cart") { window.location.reload() }
            }

          } catch (error) {
            console.error("Error in combined cart update:", error);
          }
        }, 3000);
      }
    }

    //7 passport added custom text as well
    if(passport_engrave_text.length > 0 || passport_image.length > 0 || passport_logo != 0 && passport_logo.length > 0 || passport_custom_text.length > 0 || passport_custom_text_extra.length > 0){
      if(passport_image.length > 0 && !passport_custom_text.length){
        passport_image = $(this).parents(".cart-item-data").find(".t4s-cart_meta_propertyList").attr("passport-image");
        setTimeout(function(index, value){
          console.log('img only')
          $('.engrave-charge .t4s-cart_meta_propertyList[actual_product_id="'+actual_product_id+'"][passport-image='+passport_image+'][passport-custom-text=""]').parents(".cart-item-data").find(".quantity .plus").click();
          $('.engrave-charge .t4s-cart_meta_propertyList[actual_product_id="'+actual_product_id+'"][passport-image='+passport_image+'][passport-custom-text=""]').parents(".cart-item-data").find(".qty.quantity").html("Qty : <span>"+(parseInt($('.engrave-charge .t4s-cart_meta_propertyList[actual_product_id="'+actual_product_id+'"][passport-image='+passport_image+'][passport-custom-text=""]').parents(".cart-item-data").find(".qty.quantity span").text())+1)+"</span>");
        }, 2500);
      } else if(passport_image.length > 0 && passport_custom_text.length > 0){
        passport_image = $(this).parents(".cart-item-data").find(".t4s-cart_meta_propertyList").attr("passport-image");
        setTimeout(async function () {
          let iscart = document.getElementById('t4s-mini_cart') || document.querySelector('.t4s-cartPage__form');

          try {
            const updates = {};

            // Fetch current cart
            const res = await fetch('/cart.js');
            const cart = await res.json();

            // --- First product: Passport Custom Text + Image ---
            const matchingItem1 = cart.items.find(item =>
              item.properties &&
              item.properties["Actual Product"] == actual_product_id &&
              item.properties["Passport Custom Text"] == passport_custom_text &&
              item.properties["Passport Image"]
            );

            if (matchingItem1) {
              const newQty1 = matchingItem1.quantity + 1;
              updates[matchingItem1.key] = newQty1;

              // Update DOM manually
              $('.engrave-charge .t4s-cart_meta_propertyList[actual_product_id="' + actual_product_id + '"][passport-custom-text="' + passport_custom_text + '"][passport-image=' + passport_image + ']')
                .parents(".cart-item-data")
                .find(".qty.quantity")
                .html(`Qty : <span>${newQty1}</span>`);
            } else {
              console.warn("Matching item for passport_custom_text + image not found.");
            }

            // --- Second product: Passport Extra Custom Text (optional) ---
            if (passport_custom_text_extra.length > 0) {
              const matchingItem2 = cart.items.find(item =>
                item.properties &&
                item.properties["Actual Product"] == actual_product_id &&
                item.properties["Passport Extra Custom Text"] == passport_custom_text_extra
              );

              if (matchingItem2) {
                const newQty2 = matchingItem2.quantity + 1;
                updates[matchingItem2.key] = newQty2;

                $('.engrave-charge .t4s-cart_meta_propertyList[actual_product_id="' + actual_product_id + '"][passport-custom-text-extra="' + passport_custom_text_extra + '"]')
                  .parents(".cart-item-data")
                  .find(".qty.quantity")
                  .html(`Qty : <span>${newQty2}</span>`);
              } else {
                console.warn("Matching item for passport_custom_text_extra not found.");
              }
            }

            // --- Call /cart/update.js once ---
            if (Object.keys(updates).length > 0) {
              iscart.classList.add('is--contentUpdate');
              const updateRes = await fetch('/cart/update.js', {
                method: 'POST',
                headers: {
                  'Content-Type': 'application/json'
                },
                body: JSON.stringify({ updates })
              });

              const result = await updateRes.json();
              iscart.classList.remove('is--contentUpdate');
              $(document).trigger('cart:updated');
              if (window.location.pathname === "/cart") {
                window.location.reload();
              }
            }

          } catch (error) {
            console.error("Error in combined cart update (passport image + text):", error);
          }
        }, 3000);
      } else if (passport_logo != 0 && !passport_custom_text.length){
        passport_logo = $(this).parents(".cart-item-data").find(".t4s-cart_meta_propertyList").attr("passport-logo");
        setTimeout(function(index, value){
          console.log('logo only')
          $('.engrave-charge .t4s-cart_meta_propertyList[actual_product_id="'+actual_product_id+'"][passport-logo='+passport_logo+'][passport-custom-text=""]').parents(".cart-item-data").find(".quantity .plus").click();
          $('.engrave-charge .t4s-cart_meta_propertyList[actual_product_id="'+actual_product_id+'"][passport-logo='+passport_logo+'][passport-custom-text=""]').parents(".cart-item-data").find(".qty.quantity").html("Qty : <span>"+(parseInt($('.engrave-charge .t4s-cart_meta_propertyList[actual_product_id="'+actual_product_id+'"][passport-logo='+passport_logo+'][passport-custom-text=""]').parents(".cart-item-data").find(".qty.quantity span").text())+1)+"</span>");
        }, 2500);
      } else if (passport_logo != 0 && passport_custom_text.length > 0) {
        passport_logo = $(this).parents(".cart-item-data").find(".t4s-cart_meta_propertyList").attr("passport-logo");

        setTimeout(async function () {
          let iscart = document.getElementById('t4s-mini_cart') || document.querySelector('.t4s-cartPage__form');

          try {
            const updates = {};

            // Fetch current cart
            const res = await fetch('/cart.js');
            const cart = await res.json();

            // --- First product: Passport Custom Text + Logo ---
            const matchingItem1 = cart.items.find(item =>
              item.properties &&
              item.properties["Actual Product"] == actual_product_id &&
              item.properties["Passport Custom Text"] == passport_custom_text &&
              item.properties["Passport Logo"]
            );

            if (matchingItem1) {
              const newQty1 = matchingItem1.quantity + 1;
              updates[matchingItem1.key] = newQty1;

              // Update DOM manually
              $('.engrave-charge .t4s-cart_meta_propertyList[actual_product_id="' + actual_product_id + '"][passport-custom-text="' + passport_custom_text + '"][passport-logo=' + passport_logo + ']')
                .parents(".cart-item-data")
                .find(".qty.quantity")
                .html(`Qty : <span>${newQty1}</span>`);
            } else {
              console.warn("Matching item for passport_custom_text + logo not found.");
            }

            // --- Second product: Passport Extra Custom Text (optional) ---
            if (passport_custom_text_extra.length > 0) {
              const matchingItem2 = cart.items.find(item =>
                item.properties &&
                item.properties["Actual Product"] == actual_product_id &&
                item.properties["Passport Extra Custom Text"] == passport_custom_text_extra
              );

              if (matchingItem2) {
                const newQty2 = matchingItem2.quantity + 1;
                updates[matchingItem2.key] = newQty2;

                $('.engrave-charge .t4s-cart_meta_propertyList[actual_product_id="' + actual_product_id + '"][passport-custom-text-extra="' + passport_custom_text_extra + '"]')
                  .parents(".cart-item-data")
                  .find(".qty.quantity")
                  .html(`Qty : <span>${newQty2}</span>`);
              } else {
                console.warn("Matching item for passport_custom_text_extra not found.");
              }
            }

            // --- Call /cart/update.js once ---
            if (Object.keys(updates).length > 0) {
              iscart.classList.add('is--contentUpdate');
              const updateRes = await fetch('/cart/update.js', {
                method: 'POST',
                headers: {
                  'Content-Type': 'application/json'
                },
                body: JSON.stringify({ updates })
              });

              const result = await updateRes.json();
              iscart.classList.remove('is--contentUpdate');
              $(document).trigger('cart:updated');
              if (window.location.pathname === "/cart") {
                window.location.reload();
              }
            }

          } catch (error) {
            console.error("Error in combined cart update (passport logo + text):", error);
          }
        }, 3000);
      } else if (passport_logo == 0 && passport_engrave_text.length > 0){
        setTimeout(function() {
          console.log('engrave text no logo',passport_engrave_text_length)
          let passport_engrave_text_str = Array.isArray(passport_engrave_text)
            ? passport_engrave_text.join(', ')
            : passport_engrave_text;
        
          let selector = '.engrave-charge .t4s-cart_meta_propertyList' +
            '[actual_product_id="' + actual_product_id + '"]' +
            '[passport-engrave-text="' + passport_engrave_text_str + '"]' +
            '[passport-image=""][passport-logo=""]';
        
          let $target = $(selector);
          let $input = $target.parents(".cart-item-data").find("input.t4s-quantity-input.t4s-add-quantity");
        
          let currentQty = parseInt($input.val()) || 0;
          let engraveLength = parseInt(passport_engrave_text_length) || 0;
        
          let newQty = currentQty + engraveLength;
          $input.val(newQty).trigger('change');
        
          $target.parents(".cart-item-data")
            .find(".qty.quantity")
            .html("Qty : <span>" + newQty + "</span>");
        
        }, 2500);
      } else if (!passport_image.length && passport_engrave_text.length > 0){
        setTimeout(function() {
          console.log('engrave text no logo',passport_engrave_text_length)
          let passport_engrave_text_str = Array.isArray(passport_engrave_text)
            ? passport_engrave_text.join(', ')
            : passport_engrave_text;
        
          let selector = '.engrave-charge .t4s-cart_meta_propertyList' +
            '[actual_product_id="' + actual_product_id + '"]' +
            '[passport-engrave-text="' + passport_engrave_text_str + '"]' +
            '[passport-image=""][passport-logo=""]';
        
          let $target = $(selector);
          let $input = $target.parents(".cart-item-data").find("input.t4s-quantity-input.t4s-add-quantity");
        
          let currentQty = parseInt($input.val()) || 0;
          let engraveLength = parseInt(passport_engrave_text_length) || 0;
        
          let newQty = currentQty + engraveLength;
          $input.val(newQty).trigger('change');
        
          $target.parents(".cart-item-data")
            .find(".qty.quantity")
            .html("Qty : <span>" + newQty + "</span>");
        
        }, 2500);
      } else if (passport_logo == 0 && passport_custom_text.length > 0) {
        setTimeout(async function () {
          let iscart = document.getElementById('t4s-mini_cart') || document.querySelector('.t4s-cartPage__form');
          try {
            const updates = {};

            // Fetch current cart
            const res = await fetch('/cart.js');
            const cart = await res.json();

            // --- First product: Passport Custom Text only (no image, no logo) ---
            const matchingItem1 = cart.items.find(item =>
              item.properties &&
              item.properties["Actual Product"] == actual_product_id &&
              item.properties["Passport Custom Text"] == passport_custom_text &&
              !item.properties["Passport Image"] &&
              !item.properties["Passport Logo"]
            );

            if (matchingItem1) {
              const newQty1 = matchingItem1.quantity + 1;
              updates[matchingItem1.key] = newQty1;

              // Update DOM manually
              $('.engrave-charge .t4s-cart_meta_propertyList[actual_product_id="' + actual_product_id + '"][passport-custom-text="' + passport_custom_text + '"][passport-image=""][passport-logo=""]')
                .parents(".cart-item-data")
                .find(".qty.quantity")
                .html(`Qty : <span>${newQty1}</span>`);
            } else {
              console.warn("Matching item for passport custom_text (no image/logo) not found.");
            }

            // --- Second product: Passport Extra Custom Text (optional) ---
            if (passport_custom_text_extra.length > 0) {
              const matchingItem2 = cart.items.find(item =>
                item.properties &&
                item.properties["Actual Product"] == actual_product_id &&
                item.properties["Passport Extra Custom Text"] == passport_custom_text_extra
              );

              if (matchingItem2) {
                const newQty2 = matchingItem2.quantity + 1;
                updates[matchingItem2.key] = newQty2;

                $('.engrave-charge .t4s-cart_meta_propertyList[actual_product_id="' + actual_product_id + '"][passport-custom-text-extra="' + passport_custom_text_extra + '"]')
                  .parents(".cart-item-data")
                  .find(".qty.quantity")
                  .html(`Qty : <span>${newQty2}</span>`);
              } else {
                console.warn("Matching item for passport extra_custom_text not found.");
              }
            }

            // --- Call /cart/update.js once ---
            if (Object.keys(updates).length > 0) {
              iscart.classList.add('is--contentUpdate');
              const updateRes = await fetch('/cart/update.js', {
                method: 'POST',
                headers: {
                  'Content-Type': 'application/json'
                },
                body: JSON.stringify({ updates })
              });

              const result = await updateRes.json();
              iscart.classList.remove('is--contentUpdate');
              $(document).trigger('cart:updated');
              if (window.location.pathname === "/cart") {
                window.location.reload();
              }
            }

          } catch (error) {
            console.error("Error in combined cart update (passport custom_text only):", error);
          }
        }, 3000);
      }
    }

    //8 Laptop added custom text as well
    if(laptop_engrave_text.length > 0 || laptop_image.length > 0 || laptop_logo != 0 && laptop_logo.length > 0 || laptop_custom_text.length > 0 || lady_pouch_custom_text_extra.length > 0){
      if(laptop_image.length > 0 && !laptop_custom_text.length){
        laptop_image = $(this).parents(".cart-item-data").find(".t4s-cart_meta_propertyList").attr("laptop-image");
        setTimeout(function(index, value){
          console.log('img only')
          $('.engrave-charge .t4s-cart_meta_propertyList[actual_product_id="'+actual_product_id+'"][laptop-image='+laptop_image+'][laptop-custom-text=""]').parents(".cart-item-data").find(".quantity .plus").click();
          $('.engrave-charge .t4s-cart_meta_propertyList[actual_product_id="'+actual_product_id+'"][laptop-image='+laptop_image+'][laptop-custom-text=""]').parents(".cart-item-data").find(".qty.quantity").html("Qty : <span>"+(parseInt($('.engrave-charge .t4s-cart_meta_propertyList[actual_product_id="'+actual_product_id+'"][laptop-image='+laptop_image+'][laptop-custom-text=""]').parents(".cart-item-data").find(".qty.quantity span").text())+1)+"</span>");
        }, 2500);
      } else if (laptop_image.length > 0 && laptop_custom_text.length > 0) {
        laptop_image = $(this).parents(".cart-item-data").find(".t4s-cart_meta_propertyList").attr("laptop-image");

        setTimeout(async function () {
          let iscart = document.getElementById('t4s-mini_cart') || document.querySelector('.t4s-cartPage__form');

          try {
            const updates = {};

            // Fetch current cart
            const res = await fetch('/cart.js');
            const cart = await res.json();

            // --- First product: Laptop Custom Text + Image ---
            const matchingItem1 = cart.items.find(item =>
              item.properties &&
              item.properties["Actual Product"] == actual_product_id &&
              item.properties["Laptop Custom Text"] == laptop_custom_text &&
              item.properties["Laptop Image"] == laptop_image
            );

            if (matchingItem1) {
              const newQty1 = matchingItem1.quantity + 1;
              updates[matchingItem1.key] = newQty1;

              // Update DOM manually
              $('.engrave-charge .t4s-cart_meta_propertyList[actual_product_id="' + actual_product_id + '"][laptop-custom-text="' + laptop_custom_text + '"][laptop-image="' + laptop_image + '"]')
                .parents(".cart-item-data")
                .find(".qty.quantity")
                .html(`Qty : <span>${newQty1}</span>`);
            } else {
              console.warn("Matching laptop item with text + image not found.");
            }

            // --- Second product: Laptop Extra Custom Text (optional) ---
            if (laptop_custom_text_extra.length > 0) {
              const matchingItem2 = cart.items.find(item =>
                item.properties &&
                item.properties["Actual Product"] == actual_product_id &&
                item.properties["Laptop Extra Custom Text"] == laptop_custom_text_extra
              );

              if (matchingItem2) {
                const newQty2 = matchingItem2.quantity + 1;
                updates[matchingItem2.key] = newQty2;

                $('.engrave-charge .t4s-cart_meta_propertyList[actual_product_id="' + actual_product_id + '"][laptop-custom-text-extra="' + laptop_custom_text_extra + '"]')
                  .parents(".cart-item-data")
                  .find(".qty.quantity")
                  .html(`Qty : <span>${newQty2}</span>`);
              } else {
                console.warn("Matching laptop extra custom text item not found.");
              }
            }

            // --- Update cart if needed ---
            if (Object.keys(updates).length > 0) {
              iscart.classList.add('is--contentUpdate');

              const updateRes = await fetch('/cart/update.js', {
                method: 'POST',
                headers: {
                  'Content-Type': 'application/json'
                },
                body: JSON.stringify({ updates })
              });

              const result = await updateRes.json();
              iscart.classList.remove('is--contentUpdate');
              $(document).trigger('cart:updated');

              if (window.location.pathname === "/cart") {
                window.location.reload();
              }
            }

          } catch (error) {
            console.error("Error in laptop cart update:", error);
          }
        }, 3000);
      } else if (laptop_logo != 0 && !laptop_custom_text.length){
        laptop_logo = $(this).parents(".cart-item-data").find(".t4s-cart_meta_propertyList").attr("laptop-logo");
        setTimeout(function(index, value){
          console.log('logo only')
          $('.engrave-charge .t4s-cart_meta_propertyList[actual_product_id="'+actual_product_id+'"][laptop-logo='+laptop_logo+'][laptop-custom-text=""]').parents(".cart-item-data").find(".quantity .plus").click();
          $('.engrave-charge .t4s-cart_meta_propertyList[actual_product_id="'+actual_product_id+'"][laptop-logo='+laptop_logo+'][laptop-custom-text=""]').parents(".cart-item-data").find(".qty.quantity").html("Qty : <span>"+(parseInt($('.engrave-charge .t4s-cart_meta_propertyList[actual_product_id="'+actual_product_id+'"][laptop-logo='+laptop_logo+'][laptop-custom-text=""]').parents(".cart-item-data").find(".qty.quantity span").text())+1)+"</span>");
        }, 2500);
      } else if (laptop_logo != 0 && laptop_custom_text.length > 0) {
        laptop_logo = $(this).parents(".cart-item-data").find(".t4s-cart_meta_propertyList").attr("laptop-logo");

        setTimeout(async function () {
          let iscart = document.getElementById('t4s-mini_cart') || document.querySelector('.t4s-cartPage__form');

          try {
            const updates = {};

            // Fetch current cart
            const res = await fetch('/cart.js');
            const cart = await res.json();

            // --- First product: Laptop Custom Text + Logo ---
            const matchingItem1 = cart.items.find(item =>
              item.properties &&
              item.properties["Actual Product"] == actual_product_id &&
              item.properties["Laptop Custom Text"] == laptop_custom_text &&
              item.properties["Laptop Logo"]
            );

            if (matchingItem1) {
              const newQty1 = matchingItem1.quantity + 1;
              updates[matchingItem1.key] = newQty1;

              // Update DOM manually
              $('.engrave-charge .t4s-cart_meta_propertyList[actual_product_id="' + actual_product_id + '"][laptop-custom-text="' + laptop_custom_text + '"][laptop-logo="' + laptop_logo + '"]')
                .parents(".cart-item-data")
                .find(".qty.quantity")
                .html(`Qty : <span>${newQty1}</span>`);
            } else {
              console.warn("Matching laptop item with logo + text not found.");
            }

            // --- Second product: Laptop Extra Custom Text (optional) ---
            if (laptop_custom_text_extra.length > 0) {
              const matchingItem2 = cart.items.find(item =>
                item.properties &&
                item.properties["Actual Product"] == actual_product_id &&
                item.properties["Laptop Extra Custom Text"] == laptop_custom_text_extra
              );

              if (matchingItem2) {
                const newQty2 = matchingItem2.quantity + 1;
                updates[matchingItem2.key] = newQty2;

                $('.engrave-charge .t4s-cart_meta_propertyList[actual_product_id="' + actual_product_id + '"][laptop-custom-text-extra="' + laptop_custom_text_extra + '"]')
                  .parents(".cart-item-data")
                  .find(".qty.quantity")
                  .html(`Qty : <span>${newQty2}</span>`);
              } else {
                console.warn("Matching laptop extra custom text item not found.");
              }
            }

            // --- Final update call ---
            if (Object.keys(updates).length > 0) {
              iscart.classList.add('is--contentUpdate');

              const updateRes = await fetch('/cart/update.js', {
                method: 'POST',
                headers: {
                  'Content-Type': 'application/json'
                },
                body: JSON.stringify({ updates })
              });

              const result = await updateRes.json();
              iscart.classList.remove('is--contentUpdate');
              $(document).trigger('cart:updated');

              if (window.location.pathname === "/cart") {
                window.location.reload();
              }
            }

          } catch (error) {
            console.error("Error in laptop logo + text cart update:", error);
          }
        }, 3000);
      } else if (laptop_logo == 0 && laptop_engrave_text.length > 0){
        setTimeout(function(index, value){
          console.log('engrave text no logo')
          $('.engrave-charge .t4s-cart_meta_propertyList[actual_product_id="'+actual_product_id+'"][laptop-engrave-text='+laptop_engrave_text+'][laptop-image=""][laptop-logo=""]').parents(".cart-item-data").find(".quantity .plus").click();
          $('.engrave-charge .t4s-cart_meta_propertyList[actual_product_id="'+actual_product_id+'"][laptop-engrave-text='+laptop_engrave_text+'][laptop-image=""][laptop-logo=""]').parents(".cart-item-data").find(".qty.quantity").html("Qty : <span>"+(parseInt($('.engrave-charge .t4s-cart_meta_propertyList[actual_product_id="'+actual_product_id+'"][laptop-engrave-text='+laptop_engrave_text+'][laptop-image=""][laptop-logo=""]').parents(".cart-item-data").find(".qty.quantity span").text())+1)+"</span>");
        }, 2500);
      } else if (!laptop_image.length && laptop_engrave_text.length > 0){
        setTimeout(function(index, value){
          console.log('engrave text no image')
          $('.engrave-charge .t4s-cart_meta_propertyList[actual_product_id="'+actual_product_id+'"][laptop-engrave-text='+laptop_engrave_text+'][laptop-image=""][laptop-logo=""]').parents(".cart-item-data").find(".quantity .plus").click();
          $('.engrave-charge .t4s-cart_meta_propertyList[actual_product_id="'+actual_product_id+'"][laptop-engrave-text='+laptop_engrave_text+'][laptop-image=""][laptop-logo=""]').parents(".cart-item-data").find(".qty.quantity").html("Qty : <span>"+(parseInt($('.engrave-charge .t4s-cart_meta_propertyList[actual_product_id="'+actual_product_id+'"][laptop-engrave-text='+laptop_engrave_text+'][laptop-image=""][laptop-logo=""]').parents(".cart-item-data").find(".qty.quantity span").text())+1)+"</span>");
        }, 2500);
      } else if (laptop_logo == 0 && laptop_custom_text.length > 0) {
        setTimeout(async function () {
          let iscart = document.getElementById('t4s-mini_cart') || document.querySelector('.t4s-cartPage__form');

          try {
            const updates = {};

            // Fetch current cart
            const res = await fetch('/cart.js');
            const cart = await res.json();

            // --- First product: Laptop Custom Text Only (No Logo, No Image) ---
            const matchingItem1 = cart.items.find(item =>
              item.properties &&
              item.properties["Actual Product"] == actual_product_id &&
              item.properties["Laptop Custom Text"] == laptop_custom_text &&
              !item.properties["Laptop Image"] &&
              !item.properties["Laptop Logo"]
            );

            if (matchingItem1) {
              const newQty1 = matchingItem1.quantity + 1;
              updates[matchingItem1.key] = newQty1;

              // Update DOM manually
              $('.engrave-charge .t4s-cart_meta_propertyList[actual_product_id="' + actual_product_id + '"][laptop-custom-text="' + laptop_custom_text + '"][laptop-image=""][laptop-logo=""]')
                .parents(".cart-item-data")
                .find(".qty.quantity")
                .html(`Qty : <span>${newQty1}</span>`);
            } else {
              console.warn("Matching laptop item with text only not found.");
            }

            // --- Second product: Laptop Extra Custom Text (Optional) ---
            if (laptop_custom_text_extra.length > 0) {
              const matchingItem2 = cart.items.find(item =>
                item.properties &&
                item.properties["Actual Product"] == actual_product_id &&
                item.properties["Laptop Extra Custom Text"] == laptop_custom_text_extra
              );

              if (matchingItem2) {
                const newQty2 = matchingItem2.quantity + 1;
                updates[matchingItem2.key] = newQty2;

                $('.engrave-charge .t4s-cart_meta_propertyList[actual_product_id="' + actual_product_id + '"][laptop-custom-text-extra="' + laptop_custom_text_extra + '"]')
                  .parents(".cart-item-data")
                  .find(".qty.quantity")
                  .html(`Qty : <span>${newQty2}</span>`);
              } else {
                console.warn("Matching laptop extra custom text item not found.");
              }
            }

            // --- Final Update ---
            if (Object.keys(updates).length > 0) {
              iscart.classList.add('is--contentUpdate');

              const updateRes = await fetch('/cart/update.js', {
                method: 'POST',
                headers: {
                  'Content-Type': 'application/json'
                },
                body: JSON.stringify({ updates })
              });

              const result = await updateRes.json();
              iscart.classList.remove('is--contentUpdate');
              $(document).trigger('cart:updated');

              if (window.location.pathname === "/cart") {
                window.location.reload();
              }
            }

          } catch (error) {
            console.error("Error in laptop text-only cart update:", error);
          }
        }, 3000);
      }

    }

    if(men_pouch_image.length > 0 || men_pouch_logo != 0 && men_pouch_logo.length > 0 || men_pouch_custom_text.length > 0){
      if(men_pouch_image.length > 0 && !men_pouch_custom_text.length){
        men_pouch_image = $(this).parents(".cart-item-data").find(".t4s-cart_meta_propertyList").attr("men-pouch-image");
        setTimeout(function(){
          console.log('men pouch img only');
          $('.engrave-charge .t4s-cart_meta_propertyList[actual_product_id="'+actual_product_id+'"][men-pouch-image="'+men_pouch_image+'"][men-pouch-custom-text=""]').parents(".cart-item-data").find(".quantity .plus").click();
          $('.engrave-charge .t4s-cart_meta_propertyList[actual_product_id="'+actual_product_id+'"][men-pouch-image="'+men_pouch_image+'"][men-pouch-custom-text=""]').parents(".cart-item-data").find(".qty.quantity").html("Qty : <span>"+(parseInt($('.engrave-charge .t4s-cart_meta_propertyList[actual_product_id="'+actual_product_id+'"][men-pouch-image="'+men_pouch_image+'"][men-pouch-custom-text=""]').parents(".cart-item-data").find(".qty.quantity span").text())+1)+"</span>");
        }, 2500);
      } else if (men_pouch_image.length > 0 && men_pouch_custom_text.length > 0) {
        men_pouch_image = $(this).parents(".cart-item-data").find(".t4s-cart_meta_propertyList").attr("men-pouch-image");

        setTimeout(async function () {
          const iscart = document.getElementById('t4s-mini_cart') || document.querySelector('.t4s-cartPage__form');
          try {
            const updates = {};

            // Fetch current cart
            const res = await fetch('/cart.js');
            const cart = await res.json();

            // --- First product: Men Pouch Custom Text with Image ---
            const matchingItem1 = cart.items.find(item =>
              item.properties &&
              item.properties["Actual Product"] == actual_product_id &&
              item.properties["Men Pouch Custom Text"] == men_pouch_custom_text &&
              item.properties["Men Pouch Image"]
            );

            if (matchingItem1) {
              const newQty1 = matchingItem1.quantity + 1;
              updates[matchingItem1.key] = newQty1;

              // Update DOM manually
              $('.engrave-charge .t4s-cart_meta_propertyList[actual_product_id="' + actual_product_id + '"][men-pouch-custom-text="' + men_pouch_custom_text + '"][men-pouch-image="' + men_pouch_image + '"]')
                .parents(".cart-item-data")
                .find(".qty.quantity")
                .html(`Qty : <span>${newQty1}</span>`);
            } else {
              console.warn("Matching item for men pouch custom_text not found.");
            }

            // --- Second product: Men Pouch Extra Custom Text (optional) ---
            if (men_pouch_custom_text_extra.length > 0) {
              const matchingItem2 = cart.items.find(item =>
                item.properties &&
                item.properties["Actual Product"] == actual_product_id &&
                item.properties["Men Pouch Extra Custom Text"] == men_pouch_custom_text_extra
              );

              if (matchingItem2) {
                const newQty2 = matchingItem2.quantity + 1;
                updates[matchingItem2.key] = newQty2;

                $('.engrave-charge .t4s-cart_meta_propertyList[actual_product_id="' + actual_product_id + '"][men-pouch-custom-text-extra="' + men_pouch_custom_text_extra + '"]')
                  .parents(".cart-item-data")
                  .find(".qty.quantity")
                  .html(`Qty : <span>${newQty2}</span>`);
              } else {
                console.warn("Matching item for men pouch extra_custom_text not found.");
              }
            }

            // --- Call /cart/update.js once if needed ---
            if (Object.keys(updates).length > 0) {
              iscart.classList.add('is--contentUpdate');

              const updateRes = await fetch('/cart/update.js', {
                method: 'POST',
                headers: {
                  'Content-Type': 'application/json'
                },
                body: JSON.stringify({ updates })
              });

              const result = await updateRes.json();
              iscart.classList.remove('is--contentUpdate');
              $(document).trigger('cart:updated');
              if (window.location.pathname === "/cart") {
                window.location.reload();
              }
            }

          } catch (error) {
            console.error("Error in men pouch cart update:", error);
          }
        }, 3000);
      } else if(men_pouch_logo != 0 && !men_pouch_custom_text.length){
        men_pouch_logo = $(this).parents(".cart-item-data").find(".t4s-cart_meta_propertyList").attr("men-pouch-logo");
        setTimeout(function(){
          console.log('men pouch logo only');
          $('.engrave-charge .t4s-cart_meta_propertyList[actual_product_id="'+actual_product_id+'"][men-pouch-logo="'+men_pouch_logo+'"][men-pouch-custom-text=""]').parents(".cart-item-data").find(".quantity .plus").click();
          $('.engrave-charge .t4s-cart_meta_propertyList[actual_product_id="'+actual_product_id+'"][men-pouch-logo="'+men_pouch_logo+'"][men-pouch-custom-text=""]').parents(".cart-item-data").find(".qty.quantity").html("Qty : <span>"+(parseInt($('.engrave-charge .t4s-cart_meta_propertyList[actual_product_id="'+actual_product_id+'"][men-pouch-logo="'+men_pouch_logo+'"][men-pouch-custom-text=""]').parents(".cart-item-data").find(".qty.quantity span").text())+1)+"</span>");
        }, 2500);
      } else if (men_pouch_logo != 0 && men_pouch_custom_text.length > 0) {
        men_pouch_logo = $(this).parents(".cart-item-data").find(".t4s-cart_meta_propertyList").attr("men-pouch-logo");

        setTimeout(async function () {
          let iscart = document.getElementById('t4s-mini_cart') || document.querySelector('.t4s-cartPage__form');
          try {
            const updates = {};

            // Fetch current cart
            const res = await fetch('/cart.js');
            const cart = await res.json();

            // --- First product: Men Pouch Custom Text + Logo ---
            const matchingItem1 = cart.items.find(item =>
              item.properties &&
              item.properties["Actual Product"] == actual_product_id &&
              item.properties["Men Pouch Custom Text"] == men_pouch_custom_text &&
              item.properties["Men Pouch Logo"]
            );

            if (matchingItem1) {
              const newQty1 = matchingItem1.quantity + 1;
              updates[matchingItem1.key] = newQty1;

              // Update DOM manually
              $('.engrave-charge .t4s-cart_meta_propertyList[actual_product_id="' + actual_product_id + '"][men-pouch-custom-text="' + men_pouch_custom_text + '"][men-pouch-logo="' + men_pouch_logo + '"]')
                .parents(".cart-item-data")
                .find(".qty.quantity")
                .html(`Qty : <span>${newQty1}</span>`);
            } else {
              console.warn("Matching item for men pouch logo + custom_text not found.");
            }

            // --- Second product: Men Pouch Extra Custom Text (optional) ---
            if (men_pouch_custom_text_extra.length > 0) {
              const matchingItem2 = cart.items.find(item =>
                item.properties &&
                item.properties["Actual Product"] == actual_product_id &&
                item.properties["Men Pouch Extra Custom Text"] == men_pouch_custom_text_extra
              );

              if (matchingItem2) {
                const newQty2 = matchingItem2.quantity + 1;
                updates[matchingItem2.key] = newQty2;

                $('.engrave-charge .t4s-cart_meta_propertyList[actual_product_id="' + actual_product_id + '"][men-pouch-custom-text-extra="' + men_pouch_custom_text_extra + '"]')
                  .parents(".cart-item-data")
                  .find(".qty.quantity")
                  .html(`Qty : <span>${newQty2}</span>`);
              } else {
                console.warn("Matching item for men pouch extra_custom_text not found.");
              }
            }

            // --- Call /cart/update.js once ---
            if (Object.keys(updates).length > 0) {
              iscart.classList.add('is--contentUpdate');

              const updateRes = await fetch('/cart/update.js', {
                method: 'POST',
                headers: {
                  'Content-Type': 'application/json'
                },
                body: JSON.stringify({ updates })
              });

              const result = await updateRes.json();
              iscart.classList.remove('is--contentUpdate');
              $(document).trigger('cart:updated');

              if (window.location.pathname === "/cart") {
                window.location.reload();
              }
            }

          } catch (error) {
            console.error("Error in men pouch logo + text cart update:", error);
          }
        }, 3000);
      } else if(men_pouch_logo == 0 && men_pouch_image_character.length > 0){
        setTimeout(function(){
          console.log('men pouch image char no logo');
          $('.engrave-charge .t4s-cart_meta_propertyList[actual_product_id="'+actual_product_id+'"][men-pouch-image-character="'+men_pouch_image_character+'"][men-pouch-image=""][men-pouch-logo=""]').parents(".cart-item-data").find(".quantity .plus").click();
          $('.engrave-charge .t4s-cart_meta_propertyList[actual_product_id="'+actual_product_id+'"][men-pouch-image-character="'+men_pouch_image_character+'"][men-pouch-image=""][men-pouch-logo=""]').parents(".cart-item-data").find(".qty.quantity").html("Qty : <span>"+(parseInt($('.engrave-charge .t4s-cart_meta_propertyList[actual_product_id="'+actual_product_id+'"][men-pouch-image-character="'+men_pouch_image_character+'"][men-pouch-image=""][men-pouch-logo=""]').parents(".cart-item-data").find(".qty.quantity span").text())+1)+"</span>");
        }, 2500);
      } else if(!men_pouch_image.length && men_pouch_image_character.length > 0){
        setTimeout(function(){
          console.log('men pouch image char no image');
          $('.engrave-charge .t4s-cart_meta_propertyList[actual_product_id="'+actual_product_id+'"][men-pouch-image-character="'+men_pouch_image_character+'"][men-pouch-image=""][men-pouch-logo=""]').parents(".cart-item-data").find(".quantity .plus").click();
          $('.engrave-charge .t4s-cart_meta_propertyList[actual_product_id="'+actual_product_id+'"][men-pouch-image-character="'+men_pouch_image_character+'"][men-pouch-image=""][men-pouch-logo=""]').parents(".cart-item-data").find(".qty.quantity").html("Qty : <span>"+(parseInt($('.engrave-charge .t4s-cart_meta_propertyList[actual_product_id="'+actual_product_id+'"][men-pouch-image-character="'+men_pouch_image_character+'"][men-pouch-image=""][men-pouch-logo=""]').parents(".cart-item-data").find(".qty.quantity span").text())+1)+"</span>");
        }, 2500);
      } else if (men_pouch_logo == 0 && men_pouch_custom_text.length > 0) {
        setTimeout(async function () {
          let iscart = document.getElementById('t4s-mini_cart') || document.querySelector('.t4s-cartPage__form');
          try {
            const updates = {};

            // Fetch current cart
            const res = await fetch('/cart.js');
            const cart = await res.json();

            // --- First product: Men Pouch Custom Text (no logo or image) ---
            const matchingItem1 = cart.items.find(item =>
              item.properties &&
              item.properties["Actual Product"] == actual_product_id &&
              item.properties["Men Pouch Custom Text"] == men_pouch_custom_text &&
              !item.properties["Men Pouch Image"] &&
              !item.properties["Men Pouch Logo"]
            );

            if (matchingItem1) {
              const newQty1 = matchingItem1.quantity + 1;
              updates[matchingItem1.key] = newQty1;

              // Update DOM manually
              $('.engrave-charge .t4s-cart_meta_propertyList[actual_product_id="' + actual_product_id + '"][men-pouch-custom-text="' + men_pouch_custom_text + '"][men-pouch-image=""][men-pouch-logo=""]')
                .parents(".cart-item-data")
                .find(".qty.quantity")
                .html(`Qty : <span>${newQty1}</span>`);
            } else {
              console.warn("Matching item for men pouch custom_text (no logo/image) not found.");
            }

            // --- Second product: Extra Custom Text (optional) ---
            if (men_pouch_custom_text_extra.length > 0) {
              const matchingItem2 = cart.items.find(item =>
                item.properties &&
                item.properties["Actual Product"] == actual_product_id &&
                item.properties["Men Pouch Extra Custom Text"] == men_pouch_custom_text_extra
              );

              if (matchingItem2) {
                const newQty2 = matchingItem2.quantity + 1;
                updates[matchingItem2.key] = newQty2;

                $('.engrave-charge .t4s-cart_meta_propertyList[actual_product_id="' + actual_product_id + '"][men-pouch-custom-text-extra="' + men_pouch_custom_text_extra + '"]')
                  .parents(".cart-item-data")
                  .find(".qty.quantity")
                  .html(`Qty : <span>${newQty2}</span>`);
              } else {
                console.warn("Matching item for men pouch extra_custom_text not found.");
              }
            }

            // --- Call /cart/update.js once ---
            if (Object.keys(updates).length > 0) {
              iscart.classList.add('is--contentUpdate');
              const updateRes = await fetch('/cart/update.js', {
                method: 'POST',
                headers: {
                  'Content-Type': 'application/json'
                },
                body: JSON.stringify({ updates })
              });

              const result = await updateRes.json();
              iscart.classList.remove('is--contentUpdate');
              $(document).trigger('cart:updated');

              if (window.location.pathname === "/cart") {
                window.location.reload();
              }
            }

          } catch (error) {
            console.error("Error in men pouch custom_text (no logo) update:", error);
          }
        }, 3000);
      }
    }

    if(lady_pouch_image.length > 0 || lady_pouch_logo != 0 && lady_pouch_logo.length > 0 || lady_pouch_custom_text.length > 0 || lady_pouch_custom_text_extra.length > 0){
      if(lady_pouch_image.length > 0 && !lady_pouch_custom_text.length){
        lady_pouch_image = $(this).parents(".cart-item-data").find(".t4s-cart_meta_propertyList").attr("lady-pouch-image");
        setTimeout(function(){
          console.log('lady pouch img only');
          $('.engrave-charge .t4s-cart_meta_propertyList[actual_product_id="'+actual_product_id+'"][lady-pouch-image="'+lady_pouch_image+'"][lady-pouch-custom-text=""]').parents(".cart-item-data").find(".quantity .plus").click();
          $('.engrave-charge .t4s-cart_meta_propertyList[actual_product_id="'+actual_product_id+'"][lady-pouch-image="'+lady_pouch_image+'"][lady-pouch-custom-text=""]').parents(".cart-item-data").find(".qty.quantity").html("Qty : <span>"+(parseInt($('.engrave-charge .t4s-cart_meta_propertyList[actual_product_id="'+actual_product_id+'"][lady-pouch-image="'+lady_pouch_image+'"][lady-pouch-custom-text=""]').parents(".cart-item-data").find(".qty.quantity span").text())+1)+"</span>");
        }, 2500);
      } else if (lady_pouch_image.length > 0 && lady_pouch_custom_text.length > 0) {
        lady_pouch_image = $(this).parents(".cart-item-data").find(".t4s-cart_meta_propertyList").attr("lady-pouch-image");
        setTimeout(async function () {
          let iscart = document.getElementById('t4s-mini_cart') || document.querySelector('.t4s-cartPage__form');
          try {
            const updates = {};
            
            // Fetch current cart
            const res = await fetch('/cart.js');
            const cart = await res.json();

            // --- First product: Lady Pouch Custom Text with Image ---
            const matchingItem1 = cart.items.find(item =>
              item.properties &&
              item.properties["Actual Product"] == actual_product_id &&
              item.properties["Lady Pouch Custom Text"] == lady_pouch_custom_text &&
              item.properties["Lady Pouch Image"]
            );

            if (matchingItem1) {
              const newQty1 = matchingItem1.quantity + 1;
              updates[matchingItem1.key] = newQty1;

              // Update DOM manually
              $('.engrave-charge .t4s-cart_meta_propertyList[actual_product_id="' + actual_product_id + '"][lady-pouch-custom-text="' + lady_pouch_custom_text + '"][lady-pouch-image="' + lady_pouch_image + '"]')
                .parents(".cart-item-data")
                .find(".qty.quantity")
                .html(`Qty : <span>${newQty1}</span>`);
            } else {
              console.warn("Matching item for lady pouch custom_text not found.");
            }

            // --- Second product: Lady Pouch Extra Custom Text (optional) ---
            if (lady_pouch_custom_text_extra.length > 0) {
              const matchingItem2 = cart.items.find(item =>
                item.properties &&
                item.properties["Actual Product"] == actual_product_id &&
                item.properties["Lady Pouch Extra Custom Text"] == lady_pouch_custom_text_extra
              );

              if (matchingItem2) {
                const newQty2 = matchingItem2.quantity + 1;
                updates[matchingItem2.key] = newQty2;

                $('.engrave-charge .t4s-cart_meta_propertyList[actual_product_id="' + actual_product_id + '"][lady-pouch-custom-text-extra="' + lady_pouch_custom_text_extra + '"]')
                  .parents(".cart-item-data")
                  .find(".qty.quantity")
                  .html(`Qty : <span>${newQty2}</span>`);
              } else {
                console.warn("Matching item for lady pouch extra_custom_text not found.");
              }
            }

            // --- Call /cart/update.js once ---
            if (Object.keys(updates).length > 0) {
              iscart.classList.add('is--contentUpdate');
              const updateRes = await fetch('/cart/update.js', {
                method: 'POST',
                headers: {
                  'Content-Type': 'application/json'
                },
                body: JSON.stringify({ updates })
              });

              const result = await updateRes.json();
              iscart.classList.remove('is--contentUpdate');
              $(document).trigger('cart:updated');
              if (window.location.pathname === "/cart") {
                window.location.reload();
              }
            }

          } catch (error) {
            console.error("Error in lady pouch cart update:", error);
          }
        }, 3000);
      } else if(lady_pouch_logo != 0 && !lady_pouch_custom_text.length){
        lady_pouch_logo = $(this).parents(".cart-item-data").find(".t4s-cart_meta_propertyList").attr("lady-pouch-logo");
        setTimeout(function(){
          console.log('lady pouch logo only');
          $('.engrave-charge .t4s-cart_meta_propertyList[actual_product_id="'+actual_product_id+'"][lady-pouch-logo="'+lady_pouch_logo+'"][lady-pouch-custom-text=""]').parents(".cart-item-data").find(".quantity .plus").click();
          $('.engrave-charge .t4s-cart_meta_propertyList[actual_product_id="'+actual_product_id+'"][lady-pouch-logo="'+lady_pouch_logo+'"][lady-pouch-custom-text=""]').parents(".cart-item-data").find(".qty.quantity").html("Qty : <span>"+(parseInt($('.engrave-charge .t4s-cart_meta_propertyList[actual_product_id="'+actual_product_id+'"][lady-pouch-logo="'+lady_pouch_logo+'"][lady-pouch-custom-text=""]').parents(".cart-item-data").find(".qty.quantity span").text())+1)+"</span>");
        }, 2500);
      } else if (lady_pouch_logo != 0 && lady_pouch_custom_text.length > 0) {
        lady_pouch_logo = $(this).parents(".cart-item-data").find(".t4s-cart_meta_propertyList").attr("lady-pouch-logo");

        setTimeout(async function () {
          let iscart = document.getElementById('t4s-mini_cart') || document.querySelector('.t4s-cartPage__form');
          try {
            const updates = {};

            // Fetch current cart
            const res = await fetch('/cart.js');
            const cart = await res.json();

            // --- First product: Lady Pouch Custom Text + Logo ---
            const matchingItem1 = cart.items.find(item =>
              item.properties &&
              item.properties["Actual Product"] == actual_product_id &&
              item.properties["Lady Pouch Custom Text"] == lady_pouch_custom_text &&
              item.properties["Lady Pouch Logo"]
            );

            if (matchingItem1) {
              const newQty1 = matchingItem1.quantity + 1;
              updates[matchingItem1.key] = newQty1;

              // Update DOM manually
              $('.engrave-charge .t4s-cart_meta_propertyList[actual_product_id="' + actual_product_id + '"][lady-pouch-custom-text="' + lady_pouch_custom_text + '"][lady-pouch-logo="' + lady_pouch_logo + '"]')
                .parents(".cart-item-data")
                .find(".qty.quantity")
                .html(`Qty : <span>${newQty1}</span>`);
            } else {
              console.warn("Matching item for lady pouch logo+custom_text not found.");
            }

            // --- Second product: Lady Pouch Extra Custom Text (optional) ---
            if (lady_pouch_custom_text_extra.length > 0) {
              const matchingItem2 = cart.items.find(item =>
                item.properties &&
                item.properties["Actual Product"] == actual_product_id &&
                item.properties["Lady Pouch Extra Custom Text"] == lady_pouch_custom_text_extra
              );

              if (matchingItem2) {
                const newQty2 = matchingItem2.quantity + 1;
                updates[matchingItem2.key] = newQty2;

                $('.engrave-charge .t4s-cart_meta_propertyList[actual_product_id="' + actual_product_id + '"][lady-pouch-custom-text-extra="' + lady_pouch_custom_text_extra + '"]')
                  .parents(".cart-item-data")
                  .find(".qty.quantity")
                  .html(`Qty : <span>${newQty2}</span>`);
              } else {
                console.warn("Matching item for lady pouch extra_custom_text not found.");
              }
            }

            // --- Call /cart/update.js once ---
            if (Object.keys(updates).length > 0) {
              iscart.classList.add('is--contentUpdate');
              const updateRes = await fetch('/cart/update.js', {
                method: 'POST',
                headers: {
                  'Content-Type': 'application/json'
                },
                body: JSON.stringify({ updates })
              });

              const result = await updateRes.json();
              iscart.classList.remove('is--contentUpdate');
              $(document).trigger('cart:updated');
              if (window.location.pathname === "/cart") {
                window.location.reload();
              }
            }

          } catch (error) {
            console.error("Error in lady pouch logo + text cart update:", error);
          }
        }, 3000);
      } else if(lady_pouch_logo == 0 && lady_pouch_image_character.length > 0){
        setTimeout(function(){
          console.log('lady pouch image char no logo');
          $('.engrave-charge .t4s-cart_meta_propertyList[actual_product_id="'+actual_product_id+'"][lady-pouch-image-character="'+lady_pouch_image_character+'"][lady-pouch-image=""][lady-pouch-logo=""]').parents(".cart-item-data").find(".quantity .plus").click();
          $('.engrave-charge .t4s-cart_meta_propertyList[actual_product_id="'+actual_product_id+'"][lady-pouch-image-character="'+lady_pouch_image_character+'"][lady-pouch-image=""][lady-pouch-logo=""]').parents(".cart-item-data").find(".qty.quantity").html("Qty : <span>"+(parseInt($('.engrave-charge .t4s-cart_meta_propertyList[actual_product_id="'+actual_product_id+'"][lady-pouch-image-character="'+lady_pouch_image_character+'"][lady-pouch-image=""][lady-pouch-logo=""]').parents(".cart-item-data").find(".qty.quantity span").text())+1)+"</span>");
        }, 2500);
      } else if(!lady_pouch_image.length && lady_pouch_image_character.length > 0){
        setTimeout(function(){
          console.log('lady pouch image char no image');
          $('.engrave-charge .t4s-cart_meta_propertyList[actual_product_id="'+actual_product_id+'"][lady-pouch-image-character="'+lady_pouch_image_character+'"][lady-pouch-image=""][lady-pouch-logo=""]').parents(".cart-item-data").find(".quantity .plus").click();
          $('.engrave-charge .t4s-cart_meta_propertyList[actual_product_id="'+actual_product_id+'"][lady-pouch-image-character="'+lady_pouch_image_character+'"][lady-pouch-image=""][lady-pouch-logo=""]').parents(".cart-item-data").find(".qty.quantity").html("Qty : <span>"+(parseInt($('.engrave-charge .t4s-cart_meta_propertyList[actual_product_id="'+actual_product_id+'"][lady-pouch-image-character="'+lady_pouch_image_character+'"][lady-pouch-image=""][lady-pouch-logo=""]').parents(".cart-item-data").find(".qty.quantity span").text())+1)+"</span>");
        }, 2500);
      } else if (lady_pouch_logo == 0 && lady_pouch_custom_text.length > 0) {
        setTimeout(async function () {
          let iscart = document.getElementById('t4s-mini_cart') || document.querySelector('.t4s-cartPage__form');
          try {
            const updates = {};

            // Fetch current cart
            const res = await fetch('/cart.js');
            const cart = await res.json();

            // --- First product: Lady Pouch Custom Text (no logo or image) ---
            const matchingItem1 = cart.items.find(item =>
              item.properties &&
              item.properties["Actual Product"] == actual_product_id &&
              item.properties["Lady Pouch Custom Text"] == lady_pouch_custom_text &&
              !item.properties["Lady Pouch Image"] &&
              !item.properties["Lady Pouch Logo"]
            );

            if (matchingItem1) {
              const newQty1 = matchingItem1.quantity + 1;
              updates[matchingItem1.key] = newQty1;

              // Update DOM manually
              $('.engrave-charge .t4s-cart_meta_propertyList[actual_product_id="' + actual_product_id + '"][lady-pouch-custom-text="' + lady_pouch_custom_text + '"][lady-pouch-image=""][lady-pouch-logo=""]')
                .parents(".cart-item-data")
                .find(".qty.quantity")
                .html(`Qty : <span>${newQty1}</span>`);
            } else {
              console.warn("Matching item for lady pouch custom_text (no logo) not found.");
            }

            // --- Second product: Extra Custom Text (optional) ---
            if (lady_pouch_custom_text_extra.length > 0) {
              const matchingItem2 = cart.items.find(item =>
                item.properties &&
                item.properties["Actual Product"] == actual_product_id &&
                item.properties["Lady Pouch Extra Custom Text"] == lady_pouch_custom_text_extra
              );

              if (matchingItem2) {
                const newQty2 = matchingItem2.quantity + 1;
                updates[matchingItem2.key] = newQty2;

                $('.engrave-charge .t4s-cart_meta_propertyList[actual_product_id="' + actual_product_id + '"][lady-pouch-custom-text-extra="' + lady_pouch_custom_text_extra + '"]')
                  .parents(".cart-item-data")
                  .find(".qty.quantity")
                  .html(`Qty : <span>${newQty2}</span>`);
              } else {
                console.warn("Matching item for lady pouch extra_custom_text not found.");
              }
            }

            // --- Call /cart/update.js once ---
            if (Object.keys(updates).length > 0) {
              iscart.classList.add('is--contentUpdate');
              const updateRes = await fetch('/cart/update.js', {
                method: 'POST',
                headers: {
                  'Content-Type': 'application/json'
                },
                body: JSON.stringify({ updates })
              });

              const result = await updateRes.json();
              iscart.classList.remove('is--contentUpdate');
              $(document).trigger('cart:updated');
              if (window.location.pathname === "/cart") {
                window.location.reload();
              }
            }

          } catch (error) {
            console.error("Error in lady pouch custom_text (no logo) update:", error);
          }
        }, 3000);
      }
    }
      
    });

    //cart -
    $(document).on("click", ".cart-item-data .quantity .minus", function(e){
      //console.log('minus clicked from custom_cart_widget.js')
      var engraveAdded = $(this).parents(".cart-item-data").find(".t4s-product-details__item-label").hasClass("engrave-added");
      var customTextAdded = $(this).parents(".cart-item-data").find(".t4s-product-details__item-label").hasClass("custom-text-added");
      var imageAdded = $(this).parents(".cart-item-data").find(".t4s-product-details__item-label").hasClass("image-added");

      //Below is for cart page
      if(body.hasClass("template-cart")){
        var engraveAdded = $(this).parents(".cart-item-data").find(".product-details__item-label").hasClass("engrave-added");
        var customTextAdded = $(this).parents(".cart-item-data").find(".product-details__item-label").hasClass("custom-text-added");
        var imageAdded = $(this).parents(".cart-item-data").find(".product-details__item-label").hasClass("image-added");
      }
      
      //images / logos
      var iphone_image = $(this).parents(".cart-item-data").find(".t4s-cart_meta_propertyList").attr("iphone-image");
      var iphone_image_character = $(this).parents(".cart-item-data").find(".t4s-cart_meta_propertyList").attr("iphone-image-character");
      var iphone_logo = $(this).parents(".cart-item-data").find(".t4s-cart_meta_propertyList").attr("iphone-logo");
      var cardholder_image = $(this).parents(".cart-item-data").find(".t4s-cart_meta_propertyList").attr("cardholder-image");
      var cardholder_image_character = $(this).parents(".cart-item-data").find(".t4s-cart_meta_propertyList").attr("cardholder-image-character");
      var cardholder_logo = $(this).parents(".cart-item-data").find(".t4s-cart_meta_propertyList").attr("cardholder-logo");
      var lanyard_image = $(this).parents(".cart-item-data").find(".t4s-cart_meta_propertyList").attr("lanyard-image");
      var lanyard_image_character = $(this).parents(".cart-item-data").find(".t4s-cart_meta_propertyList").attr("lanyard-image-character");
      var lanyard_logo = $(this).parents(".cart-item-data").find(".t4s-cart_meta_propertyList").attr("lanyard-logo");
      var wallet_image = $(this).parents(".cart-item-data").find(".t4s-cart_meta_propertyList").attr("wallet-image");
      var wallet_image_character = $(this).parents(".cart-item-data").find(".t4s-cart_meta_propertyList").attr("wallet-image-character");
      var wallet_logo = $(this).parents(".cart-item-data").find(".t4s-cart_meta_propertyList").attr("wallet-logo");
      var passport_image = $(this).parents(".cart-item-data").find(".t4s-cart_meta_propertyList").attr("passport-image");
      var passport_image_character = $(this).parents(".cart-item-data").find(".t4s-cart_meta_propertyList").attr("passport-image-character");
      var passport_logo = $(this).parents(".cart-item-data").find(".t4s-cart_meta_propertyList").attr("passport-logo");
      var laptop_image = $(this).parents(".cart-item-data").find(".t4s-cart_meta_propertyList").attr("laptop-image");
      var laptop_image_character = $(this).parents(".cart-item-data").find(".t4s-cart_meta_propertyList").attr("laptop-image-character");
      var laptop_logo = $(this).parents(".cart-item-data").find(".t4s-cart_meta_propertyList").attr("laptop-logo");
      var men_pouch_image = $(this).parents(".cart-item-data").find(".t4s-cart_meta_propertyList").attr("men-pouch-image");
      var men_pouch_image_character = $(this).parents(".cart-item-data").find(".t4s-cart_meta_propertyList").attr("men-pouch-image-character");
      var men_pouch_logo = $(this).parents(".cart-item-data").find(".t4s-cart_meta_propertyList").attr("men-pouch-logo");
      var lady_pouch_image = $(this).parents(".cart-item-data").find(".t4s-cart_meta_propertyList").attr("lady-pouch-image");
      var lady_pouch_image_character = $(this).parents(".cart-item-data").find(".t4s-cart_meta_propertyList").attr("lady-pouch-image-character");
      var lady_pouch_logo = $(this).parents(".cart-item-data").find(".t4s-cart_meta_propertyList").attr("lady-pouch-logo");

      //engrave texts
      var iphone_engrave_text = '';
      var cardholder_engrave_text = '';
      var wallet_engrave_text = '';
      var lanyard_engrave_text = '';
      var passport_engrave_text = '';
      var airpods_engrave_text = '';
      var watch_engrave_text = '';
      var laptop_engrave_text = '';
      var lanyard_engrave_text_length = '';
      var iphone_engrave_text_length = '';
      var wallet_engrave_text_length = '';
      var passport_engrave_text_length = '';
    
      //custom text
      var iphone_custom_text = '';
      var cardholder_custom_text = '';
      var wallet_custom_text = '';
      var lanyard_custom_text = '';
      var passport_custom_text = '';
      var airpods_custom_text = '';
      var watch_custom_text = '';
      var laptop_custom_text = '';
      var men_pouch_custom_text = '';
      var lady_pouch_custom_text = '';
      var cardholder_custom_text_extra = '';
      var lanyard_custom_text_extra = '';
      var passport_custom_text_extra = '';
      var wallet_custom_text_extra = '';
      var laptop_custom_text_extra = '';
      var lady_pouch_custom_text_extra = '';
      var men_pouch_custom_text_extra = '';
      var iphone_custom_text_extra = '';

      var actual_product_id = $(this).parents(".cart-item-data").attr("data-item-id");
      if( $('.engrave-charge .t4s-cart_meta_propertyList[actual_product_id="'+actual_product_id+'"]').length <= 0) return;
      
      if(engraveAdded){
        iphone_engrave_text = $(this).parents(".cart-item-data").find(".t4s-cart_meta_propertyList").attr("iphone-engrave-text");
        cardholder_engrave_text = $(this).parents(".cart-item-data").find(".t4s-cart_meta_propertyList").attr("cardholder-engrave-text");
        wallet_engrave_text = $(this).parents(".cart-item-data").find(".t4s-cart_meta_propertyList").attr("wallet-engrave-text");
        lanyard_engrave_text = $(this).parents(".cart-item-data").find(".t4s-cart_meta_propertyList").attr("lanyard-engrave-text");
        passport_engrave_text = $(this).parents(".cart-item-data").find(".t4s-cart_meta_propertyList").attr("passport-engrave-text");
        airpods_engrave_text = $(this).parents(".cart-item-data").find(".t4s-cart_meta_propertyList").attr("airpods-engrave-text");
        watch_engrave_text = $(this).parents(".cart-item-data").find(".t4s-cart_meta_propertyList").attr("watch-engrave-text");
        laptop_engrave_text = $(this).parents(".cart-item-data").find(".t4s-cart_meta_propertyList").attr("laptop-engrave-text");
      }

      lanyard_engrave_text_length = parseInt(
          $(this).parents(".cart-item-data").find(".t4s-cart_meta_propertyList").attr("lanyard-engrave-text-length")
      ) || 1;

      iphone_engrave_text_length = parseInt(
          $(this).parents(".cart-item-data").find(".t4s-cart_meta_propertyList").attr("iphone-engrave-text-length")
      ) || 1;

      wallet_engrave_text_length = parseInt(
          $(this).parents(".cart-item-data").find(".t4s-cart_meta_propertyList").attr("wallet-engrave-text-length")
      ) || 1;

      passport_engrave_text_length = parseInt(
          $(this).parents(".cart-item-data").find(".t4s-cart_meta_propertyList").attr("passport-engrave-text-length")
      ) || 1;

      if(customTextAdded){
        iphone_custom_text = $(this).parents(".cart-item-data").find(".t4s-cart_meta_propertyList").attr("iphone-custom-text");
        cardholder_custom_text = $(this).parents(".cart-item-data").find(".t4s-cart_meta_propertyList").attr("cardholder-custom-text");
        wallet_custom_text = $(this).parents(".cart-item-data").find(".t4s-cart_meta_propertyList").attr("wallet-custom-text");
        lanyard_custom_text = $(this).parents(".cart-item-data").find(".t4s-cart_meta_propertyList").attr("lanyard-custom-text");
        passport_custom_text = $(this).parents(".cart-item-data").find(".t4s-cart_meta_propertyList").attr("passport-custom-text");
        airpods_custom_text = $(this).parents(".cart-item-data").find(".t4s-cart_meta_propertyList").attr("airpods-custom-text");
        watch_custom_text = $(this).parents(".cart-item-data").find(".t4s-cart_meta_propertyList").attr("watch-custom-text");
        laptop_custom_text = $(this).parents(".cart-item-data").find(".t4s-cart_meta_propertyList").attr("laptop-custom-text");
        men_pouch_custom_text = $(this).parents(".cart-item-data").find(".t4s-cart_meta_propertyList").attr("men-pouch-custom-text");
        lady_pouch_custom_text = $(this).parents(".cart-item-data").find(".t4s-cart_meta_propertyList").attr("lady-pouch-custom-text");

        cardholder_custom_text_extra = $(this).parents(".cart-item-data").find(".t4s-cart_meta_propertyList").attr("cardholder-custom-text-extra");
        lanyard_custom_text_extra = $(this).parents(".cart-item-data").find(".t4s-cart_meta_propertyList").attr("lanyard-custom-text-extra");
        passport_custom_text_extra = $(this).parents(".cart-item-data").find(".t4s-cart_meta_propertyList").attr("passport-custom-text-extra");
        wallet_custom_text_extra = $(this).parents(".cart-item-data").find(".t4s-cart_meta_propertyList").attr("wallet-custom-text-extra");
        laptop_custom_text_extra = $(this).parents(".cart-item-data").find(".t4s-cart_meta_propertyList").attr("laptop-custom-text-extra");
        lady_pouch_custom_text_extra = $(this).parents(".cart-item-data").find(".t4s-cart_meta_propertyList").attr("lady-pouch-custom-text-extra");
        men_pouch_custom_text_extra = $(this).parents(".cart-item-data").find(".t4s-cart_meta_propertyList").attr("men-pouch-custom-text-extra");
        iphone_custom_text_extra = $(this).parents(".cart-item-data").find(".t4s-cart_meta_propertyList").attr("iphone-custom-text-extra");
      }
      
      if(imageAdded){
        iphone_image = $(this).parents(".cart-item-data").find(".t4s-cart_meta_propertyList").attr("iphone-image");
        iphone_logo = $(this).parents(".cart-item-data").find(".t4s-cart_meta_propertyList").attr("iphone-logo");
        cardholder_image = $(this).parents(".cart-item-data").find(".t4s-cart_meta_propertyList").attr("cardholder-image");
        cardholder_logo = $(this).parents(".cart-item-data").find(".t4s-cart_meta_propertyList").attr("cardholder-logo");
        wallet_image = $(this).parents(".cart-item-data").find(".t4s-cart_meta_propertyList").attr("wallet-image");
        wallet_logo = $(this).parents(".cart-item-data").find(".t4s-cart_meta_propertyList").attr("wallet-logo");
        lanyard_image = $(this).parents(".cart-item-data").find(".t4s-cart_meta_propertyList").attr("lanyard-image");
        lanyard_logo = $(this).parents(".cart-item-data").find(".t4s-cart_meta_propertyList").attr("lanyard-logo");
        passport_image = $(this).parents(".cart-item-data").find(".t4s-cart_meta_propertyList").attr("passport-image");
        passport_logo = $(this).parents(".cart-item-data").find(".t4s-cart_meta_propertyList").attr("passport-logo");
        laptop_image = $(this).parents(".cart-item-data").find(".t4s-cart_meta_propertyList").attr("laptop-image");
        laptop_logo = $(this).parents(".cart-item-data").find(".t4s-cart_meta_propertyList").attr("laptop-logo");
        men_pouch_image = $(this).parents(".cart-item-data").find(".t4s-cart_meta_propertyList").attr("men-pouch-image");
        men_pouch_logo = $(this).parents(".cart-item-data").find(".t4s-cart_meta_propertyList").attr("men-pouch-logo");
        lady_pouch_image = $(this).parents(".cart-item-data").find(".t4s-cart_meta_propertyList").attr("lady-pouch-image");
        lady_pouch_logo = $(this).parents(".cart-item-data").find(".t4s-cart_meta_propertyList").attr("lady-pouch-logo");
      }
 
    //1 added custom text as well
    if(iphone_engrave_text.length > 0 || iphone_image.length > 0 || iphone_logo != 0 && iphone_logo.length > 0 || iphone_custom_text.length > 0 || iphone_custom_text_extra.length > 0){
      if(iphone_image.length > 0 && !iphone_custom_text.length){
        iphone_image = $(this).parents(".cart-item-data").find(".t4s-cart_meta_propertyList").attr("iphone-image");
        setTimeout(function(index, value){
          console.log('img only')
          $('.engrave-charge .t4s-cart_meta_propertyList[actual_product_id="'+actual_product_id+'"][iphone-image='+iphone_image+'][iphone-custom-text=""]').parents(".cart-item-data").find(".quantity .minus").click();
          $('.engrave-charge .t4s-cart_meta_propertyList[actual_product_id="'+actual_product_id+'"][iphone-image='+iphone_image+'][iphone-custom-text=""]').parents(".cart-item-data").find(".qty.quantity").html("Qty : <span>"+(parseInt($('.engrave-charge .t4s-cart_meta_propertyList[actual_product_id="'+actual_product_id+'"][iphone-image='+iphone_image+'][iphone-custom-text=""]').parents(".cart-item-data").find(".qty.quantity span").text())-1)+"</span>");
        }, 2500);
      } else if(iphone_image.length > 0 && iphone_custom_text.length > 0){
        iphone_image = $(this).parents(".cart-item-data").find(".t4s-cart_meta_propertyList").attr("iphone-image");
        setTimeout(async function () {
          let iscart = document.getElementById('t4s-mini_cart') || document.querySelector('.t4s-cartPage__form');
          try {
            const updates = {};

            // Fetch current cart
            const res = await fetch('/cart.js');
            const cart = await res.json();

            // --- First product: iPhone Custom Text + Image ---
            const matchingItem1 = cart.items.find(item =>
              item.properties &&
              item.properties["Actual Product"] == actual_product_id &&
              item.properties["iPhone Custom Text"] == iphone_custom_text &&
              item.properties["iPhone Image"]
            );

            if (matchingItem1) {
              const newQty1 = matchingItem1.quantity - 1;
              updates[matchingItem1.key] = newQty1;

              // Update DOM manually
              $('.engrave-charge .t4s-cart_meta_propertyList[actual_product_id="' + actual_product_id + '"][iphone-custom-text="' + iphone_custom_text + '"][iphone-image="' + iphone_image + '"]')
                .parents(".cart-item-data")
                .find(".qty.quantity")
                .html(`Qty : <span>${newQty1}</span>`);
            } else {
              console.warn("Matching iPhone item not found.");
            }

            // --- Second product: Extra Custom Text (if applicable) ---
            if (iphone_custom_text_extra.length > 0) {
              const matchingItem2 = cart.items.find(item =>
                item.properties &&
                item.properties["Actual Product"] == actual_product_id &&
                item.properties["iPhone Extra Custom Text"] == iphone_custom_text_extra
              );

              if (matchingItem2) {
                const newQty2 = matchingItem2.quantity - 1;
                updates[matchingItem2.key] = newQty2;

                $('.engrave-charge .t4s-cart_meta_propertyList[actual_product_id="' + actual_product_id + '"][iphone-custom-text-extra="' + iphone_custom_text_extra + '"]')
                  .parents(".cart-item-data")
                  .find(".qty.quantity")
                  .html(`Qty : <span>${newQty2}</span>`);
              } else {
                console.warn("Matching iPhone extra custom text item not found.");
              }
            }

            // --- Send cart update if needed ---
            if (Object.keys(updates).length > 0) {
              iscart.classList.add('is--contentUpdate');
              const updateRes = await fetch('/cart/update.js', {
                method: 'POST',
                headers: {
                  'Content-Type': 'application/json'
                },
                body: JSON.stringify({ updates })
              });

              const result = await updateRes.json();
              iscart.classList.remove('is--contentUpdate');
              $(document).trigger('cart:updated');
              if (window.location.pathname === "/cart") {
                window.location.reload();
              }
            }

          } catch (error) {
            console.error("Error in iPhone cart update:", error);
          }
        }, 3000);
      } else if (iphone_logo != 0 && !iphone_custom_text.length){
        iphone_logo = $(this).parents(".cart-item-data").find(".t4s-cart_meta_propertyList").attr("iphone-logo");
        setTimeout(function(index, value){
          console.log('logo only')
          $('.engrave-charge .t4s-cart_meta_propertyList[actual_product_id="'+actual_product_id+'"][iphone-logo='+iphone_logo+'][iphone-custom-text=""]').parents(".cart-item-data").find(".quantity .minus").click();
          $('.engrave-charge .t4s-cart_meta_propertyList[actual_product_id="'+actual_product_id+'"][iphone-logo='+iphone_logo+'][iphone-custom-text=""]').parents(".cart-item-data").find(".qty.quantity").html("Qty : <span>"+(parseInt($('.engrave-charge .t4s-cart_meta_propertyList[actual_product_id="'+actual_product_id+'"][iphone-logo='+iphone_logo+'][iphone-custom-text=""]').parents(".cart-item-data").find(".qty.quantity span").text())-1)+"</span>");
        }, 2500);
      } else if (iphone_logo != 0 && iphone_custom_text.length > 0){
        iphone_logo = $(this).parents(".cart-item-data").find(".t4s-cart_meta_propertyList").attr("iphone-logo");
        setTimeout(async function () {
          let iscart = document.getElementById('t4s-mini_cart') || document.querySelector('.t4s-cartPage__form');
          try {
            const updates = {};

            // Fetch current cart
            const res = await fetch('/cart.js');
            const cart = await res.json();

            // --- First product: iPhone Custom Text + Logo ---
            const matchingItem1 = cart.items.find(item =>
              item.properties &&
              item.properties["Actual Product"] == actual_product_id &&
              item.properties["iPhone Custom Text"] == iphone_custom_text &&
              item.properties["iPhone Logo"]
            );

            if (matchingItem1) {
              const newQty1 = matchingItem1.quantity - 1;
              updates[matchingItem1.key] = newQty1;

              // Update DOM manually
              $('.engrave-charge .t4s-cart_meta_propertyList[actual_product_id="' + actual_product_id + '"][iphone-custom-text="' + iphone_custom_text + '"][iphone-logo="' + iphone_logo + '"]')
                .parents(".cart-item-data")
                .find(".qty.quantity")
                .html(`Qty : <span>${newQty1}</span>`);
            } else {
              console.warn("Matching item for iPhone custom_text + logo not found.");
            }

            // --- Second product: Extra Custom Text (optional) ---
            if (iphone_custom_text_extra.length > 0) {
              const matchingItem2 = cart.items.find(item =>
                item.properties &&
                item.properties["Actual Product"] == actual_product_id &&
                item.properties["iPhone Extra Custom Text"] == iphone_custom_text_extra
              );

              if (matchingItem2) {
                const newQty2 = matchingItem2.quantity - 1;
                updates[matchingItem2.key] = newQty2;

                $('.engrave-charge .t4s-cart_meta_propertyList[actual_product_id="' + actual_product_id + '"][iphone-custom-text-extra="' + iphone_custom_text_extra + '"]')
                  .parents(".cart-item-data")
                  .find(".qty.quantity")
                  .html(`Qty : <span>${newQty2}</span>`);
              } else {
                console.warn("Matching item for iPhone extra custom text not found.");
              }
            }

            // --- Call /cart/update.js once ---
            if (Object.keys(updates).length > 0) {
              iscart.classList.add('is--contentUpdate');
              const updateRes = await fetch('/cart/update.js', {
                method: 'POST',
                headers: {
                  'Content-Type': 'application/json'
                },
                body: JSON.stringify({ updates })
              });

              const result = await updateRes.json();
              iscart.classList.remove('is--contentUpdate');
              $(document).trigger('cart:updated');
              if (window.location.pathname === "/cart") {
                window.location.reload();
              }
            }

          } catch (error) {
            console.error("Error in iPhone logo cart update:", error);
          }
        }, 3000);
      } else if (iphone_logo == 0 && iphone_engrave_text.length > 0){
        setTimeout(function() {
          console.log('engrave text no logo',iphone_engrave_text_length)
          let iphone_engrave_text_str = Array.isArray(iphone_engrave_text)
            ? iphone_engrave_text.join(', ')
            : iphone_engrave_text;
        
          let selector = '.engrave-charge .t4s-cart_meta_propertyList' +
            '[actual_product_id="' + actual_product_id + '"]' +
            '[iphone-engrave-text="' + iphone_engrave_text_str + '"]' +
            '[iphone-image=""][iphone-logo=""]';
        
          let $target = $(selector);
          let $input = $target.parents(".cart-item-data").find("input.t4s-quantity-input.t4s-add-quantity");
        
          let currentQty = parseInt($input.val()) || 0;
          let engraveLength = parseInt(iphone_engrave_text_length) || 0;
        
          let newQty = currentQty - engraveLength;
          $input.val(newQty).trigger('change');
        
          $target.parents(".cart-item-data")
            .find(".qty.quantity")
            .html("Qty : <span>" + newQty + "</span>");
        
        }, 2500);
      } else if(iphone_engrave_text.length > 0 && !iphone_image.length) {
        setTimeout(function() {
          console.log('engrave text no logo',iphone_engrave_text_length)
          let iphone_engrave_text_str = Array.isArray(iphone_engrave_text)
            ? iphone_engrave_text.join(', ')
            : iphone_engrave_text;
        
          let selector = '.engrave-charge .t4s-cart_meta_propertyList' +
            '[actual_product_id="' + actual_product_id + '"]' +
            '[iphone-engrave-text="' + iphone_engrave_text_str + '"]' +
            '[iphone-image=""][iphone-logo=""]';
        
          let $target = $(selector);
          let $input = $target.parents(".cart-item-data").find("input.t4s-quantity-input.t4s-add-quantity");
        
          let currentQty = parseInt($input.val()) || 0;
          let engraveLength = parseInt(iphone_engrave_text_length) || 0;
        
          let newQty = currentQty - engraveLength;
          $input.val(newQty).trigger('change');
        
          $target.parents(".cart-item-data")
            .find(".qty.quantity")
            .html("Qty : <span>" + newQty + "</span>");
        
        }, 2500);
      } else if(iphone_logo == 0 && iphone_custom_text.length > 0) {
        setTimeout(async function () {
          let iscart = document.getElementById('t4s-mini_cart') || document.querySelector('.t4s-cartPage__form');
          try {
            const updates = {};

            // Fetch current cart
            const res = await fetch('/cart.js');
            const cart = await res.json();

            // --- First product: iPhone Custom Text without logo or image ---
            const matchingItem1 = cart.items.find(item =>
              item.properties &&
              item.properties["Actual Product"] == actual_product_id &&
              item.properties["iPhone Custom Text"] == iphone_custom_text &&
              !item.properties["iPhone Image"] &&
              !item.properties["iPhone Logo"]
            );

            if (matchingItem1) {
              const newQty1 = matchingItem1.quantity - 1;
              updates[matchingItem1.key] = newQty1;

              // Update DOM manually
              $('.engrave-charge .t4s-cart_meta_propertyList[actual_product_id="' + actual_product_id + '"][iphone-custom-text="' + iphone_custom_text + '"][iphone-image=""][iphone-logo=""]')
                .parents(".cart-item-data")
                .find(".qty.quantity")
                .html(`Qty : <span>${newQty1}</span>`);
            } else {
              console.warn("Matching item for iPhone custom_text without logo/image not found.");
            }

            // --- Second product: iPhone Extra Custom Text (optional) ---
            if (iphone_custom_text_extra.length > 0) {
              const matchingItem2 = cart.items.find(item =>
                item.properties &&
                item.properties["Actual Product"] == actual_product_id &&
                item.properties["iPhone Extra Custom Text"] == iphone_custom_text_extra
              );

              if (matchingItem2) {
                const newQty2 = matchingItem2.quantity - 1;
                updates[matchingItem2.key] = newQty2;
                $('.engrave-charge .t4s-cart_meta_propertyList[actual_product_id="' + actual_product_id + '"][iphone-custom-text-extra="' + iphone_custom_text_extra + '"]')
                  .parents(".cart-item-data")
                  .find(".qty.quantity")
                  .html(`Qty : <span>${newQty2}</span>`);
              } else {
                console.warn("Matching item for iPhone extra custom text not found.");
              }
            }

            // --- Call /cart/update.js once ---
            if (Object.keys(updates).length > 0) {
              iscart.classList.add('is--contentUpdate');
              const updateRes = await fetch('/cart/update.js', {
                method: 'POST',
                headers: {
                  'Content-Type': 'application/json'
                },
                body: JSON.stringify({ updates })
              });

              const result = await updateRes.json();
              iscart.classList.remove('is--contentUpdate');
              $(document).trigger('cart:updated');
              if (window.location.pathname === "/cart") {
                window.location.reload();
              }
            }

          } catch (error) {
            console.error("Error in iPhone text-only cart update:", error);
          }
        }, 3000);
      } else if(iphone_custom_text.length > 0 && !iphone_image.length) {
       setTimeout(async function () {
          let iscart = document.getElementById('t4s-mini_cart') || document.querySelector('.t4s-cartPage__form');
          try {
            const updates = {};

            // Fetch current cart
            const res = await fetch('/cart.js');
            const cart = await res.json();

            // --- First product: iPhone Custom Text ---
            const matchingItem1 = cart.items.find(item =>
              item.properties &&
              item.properties["Actual Product"] == actual_product_id &&
              item.properties["iPhone Custom Text"] == iphone_custom_text &&
              !item.properties["iPhone Image"] &&
              !item.properties["iPhone Logo"]
            );

            if (matchingItem1) {
              const newQty1 = matchingItem1.quantity - 1;
              updates[matchingItem1.key] = newQty1;

              // Update DOM manually
              $('.engrave-charge .t4s-cart_meta_propertyList[actual_product_id="' + actual_product_id + '"][iphone-custom-text="' + iphone_custom_text + '"][iphone-image=""][iphone-logo=""]')
                .parents(".cart-item-data")
                .find(".qty.quantity")
                .html(`Qty : <span>${newQty1}</span>`);
            } else {
              console.warn("Matching item for iPhone custom_text not found.");
            }

            // --- Second product: iPhone Extra Custom Text (optional) ---
            if (iphone_custom_text_extra.length > 0) {
              const matchingItem2 = cart.items.find(item =>
                item.properties &&
                item.properties["Actual Product"] == actual_product_id &&
                item.properties["iPhone Extra Custom Text"] == iphone_custom_text_extra
              );

              if (matchingItem2) {
                const newQty2 = matchingItem2.quantity - 1;
                updates[matchingItem2.key] = newQty2;
                $('.engrave-charge .t4s-cart_meta_propertyList[actual_product_id="' + actual_product_id + '"][iphone-custom-text-extra="' + iphone_custom_text_extra + '"]')
                  .parents(".cart-item-data")
                  .find(".qty.quantity")
                  .html(`Qty : <span>${newQty2}</span>`);
              } else {
                console.warn("Matching item for iPhone extra_custom_text not found.");
              }
            }

            // --- Call /cart/update.js once ---
            if (Object.keys(updates).length > 0) {
              iscart.classList.add('is--contentUpdate');
              const updateRes = await fetch('/cart/update.js', {
                method: 'POST',
                headers: {
                  'Content-Type': 'application/json'
                },
                body: JSON.stringify({ updates })
              });

              const result = await updateRes.json();
              iscart.classList.remove('is--contentUpdate');
              $(document).trigger('cart:updated');
              if (window.location.pathname === "/cart") { window.location.reload(); }
            }

          } catch (error) {
            console.error("Error in combined cart update:", error);
          }
        }, 3000);
      }
    }

    //2 added custom text as well
    if(cardholder_engrave_text.length > 0 || cardholder_image.length > 0 || cardholder_logo != 0 && cardholder_logo.length > 0 || cardholder_custom_text.length > 0 || cardholder_custom_text_extra.length > 0){
      if(cardholder_image.length > 0 && !cardholder_custom_text.length){
        cardholder_image = $(this).parents(".cart-item-data").find(".t4s-cart_meta_propertyList").attr("cardholder-image");
        setTimeout(function(index, value){
          console.log('img only')
          $('.engrave-charge .t4s-cart_meta_propertyList[actual_product_id="'+actual_product_id+'"][cardholder-image='+cardholder_image+'][cardholder-custom-text=""]').parents(".cart-item-data").find(".quantity .minus").click();
          $('.engrave-charge .t4s-cart_meta_propertyList[actual_product_id="'+actual_product_id+'"][cardholder-image='+cardholder_image+'][cardholder-custom-text=""]').parents(".cart-item-data").find(".qty.quantity").html("Qty : <span>"+(parseInt($('.engrave-charge .t4s-cart_meta_propertyList[actual_product_id="'+actual_product_id+'"][cardholder-image='+cardholder_image+'][cardholder-custom-text=""]').parents(".cart-item-data").find(".qty.quantity span").text())-1)+"</span>");
        }, 2500);
      } else if(cardholder_image.length > 0 && cardholder_custom_text.length > 0){
        cardholder_image = $(this).parents(".cart-item-data").find(".t4s-cart_meta_propertyList").attr("cardholder-image");
        setTimeout(async function () {
          let iscart = document.getElementById('t4s-mini_cart') || document.querySelector('.t4s-cartPage__form');
          try {
            const updates = {};
        
            // Fetch current cart
            const res = await fetch('/cart.js');
            const cart = await res.json();
        
            // --- First product: Cardholder Custom Text ---
            const matchingItem1 = cart.items.find(item =>
              item.properties &&
              item.properties["Actual Product"] == actual_product_id &&
              item.properties["Cardholder Custom Text"] == cardholder_custom_text &&
              item.properties["Cardholder Image"]
            );
        
            if (matchingItem1) {
              const newQty1 = matchingItem1.quantity - 1;
              updates[matchingItem1.key] = newQty1;
        
              // Update DOM manually
              $('.engrave-charge .t4s-cart_meta_propertyList[actual_product_id="' + actual_product_id + '"][cardholder-custom-text="' + cardholder_custom_text + '"][cardholder-image='+cardholder_image+']')
                .parents(".cart-item-data")
                .find(".qty.quantity")
                .html(`Qty : <span>${newQty1}</span>`);
            } else {
              console.warn("Matching item for custom_text not found.");
            }
        
            // --- Second product: Extra Custom Text (optional) ---
            if (cardholder_custom_text_extra.length > 0) {
              const matchingItem2 = cart.items.find(item =>
                item.properties &&
                item.properties["Actual Product"] == actual_product_id &&
                item.properties["Cardholder Extra Custom Text"] == cardholder_custom_text_extra
              );
        
              if (matchingItem2) {
                const newQty2 = matchingItem2.quantity - 1;
                updates[matchingItem2.key] = newQty2;
                $('.engrave-charge .t4s-cart_meta_propertyList[actual_product_id="' + actual_product_id + '"][cardholder-custom-text-extra="' + cardholder_custom_text_extra + '"]')
                .parents(".cart-item-data")
                .find(".qty.quantity")
                .html(`Qty : <span>${newQty2}</span>`);
              } else {
                console.warn("Matching item for extra_custom_text not found.");
              }
            }
        
            // --- Call /cart/update.js once ---
            if (Object.keys(updates).length > 0) {
              iscart.classList.add('is--contentUpdate');
              const updateRes = await fetch('/cart/update.js', {
                method: 'POST',
                headers: {
                  'Content-Type': 'application/json'
                },
                body: JSON.stringify({ updates })
              });
        
              const result = await updateRes.json();
               iscart.classList.remove('is--contentUpdate');
              $(document).trigger('cart:updated');
              if(window.location.pathname==="/cart"){ window.location.reload()}
            }
        
          } catch (error) {
            console.error("Error in combined cart quantity decrease:", error);
          }
        }, 3000);
      } else if (cardholder_logo != 0 && !cardholder_custom_text.length){
        cardholder_logo = $(this).parents(".cart-item-data").find(".cart_meta_propertyList").attr("cardholder-logo");
        setTimeout(function(index, value){
          console.log('logo only')
          $('.engrave-charge .t4s-cart_meta_propertyList[actual_product_id="'+actual_product_id+'"][cardholder-logo='+cardholder_logo+'][cardholder-custom-text=""]').parents(".cart-item-data").find(".quantity .minus").click();
          $('.engrave-charge .t4s-cart_meta_propertyList[actual_product_id="'+actual_product_id+'"][cardholder-logo='+cardholder_logo+'][cardholder-custom-text=""]').parents(".cart-item-data").find(".qty.quantity").html("Qty : <span>"+(parseInt($('.engrave-charge .t4s-cart_meta_propertyList[actual_product_id="'+actual_product_id+'"][cardholder-logo='+cardholder_logo+'][cardholder-custom-text=""]').parents(".cart-item-data").find(".qty.quantity span").text())-1)+"</span>");
        }, 2500);
      } else if (cardholder_logo != 0 && cardholder_custom_text.length > 0){
        cardholder_logo = $(this).parents(".cart-item-data").find(".t4s-cart_meta_propertyList").attr("cardholder-logo");
        setTimeout(async function () {
          let iscart = document.getElementById('t4s-mini_cart') || document.querySelector('.t4s-cartPage__form');
          try {
            const updates = {};
        
            // Fetch current cart
            const res = await fetch('/cart.js');
            const cart = await res.json();
        
            // --- First product: Cardholder Custom Text ---
            const matchingItem1 = cart.items.find(item =>
              item.properties &&
              item.properties["Actual Product"] == actual_product_id &&
              item.properties["Cardholder Custom Text"] == cardholder_custom_text &&
              item.properties["Cardholder Logo"]
            );
        
            if (matchingItem1) {
              const newQty1 = matchingItem1.quantity - 1;
              updates[matchingItem1.key] = newQty1;
        
              // Update DOM manually
              $('.engrave-charge .t4s-cart_meta_propertyList[actual_product_id="' + actual_product_id + '"][cardholder-custom-text="' + cardholder_custom_text + '"][cardholder-logo='+cardholder_logo+']')
                .parents(".cart-item-data")
                .find(".qty.quantity")
                .html(`Qty : <span>${newQty1}</span>`);
            } else {
              console.warn("Matching item for custom_text not found.");
            }
        
            // --- Second product: Extra Custom Text (optional) ---
            if (cardholder_custom_text_extra.length > 0) {
              const matchingItem2 = cart.items.find(item =>
                item.properties &&
                item.properties["Actual Product"] == actual_product_id &&
                item.properties["Cardholder Extra Custom Text"] == cardholder_custom_text_extra
              );
        
              if (matchingItem2) {
                const newQty2 = matchingItem2.quantity - 1;
                updates[matchingItem2.key] = newQty2;
                $('.engrave-charge .t4s-cart_meta_propertyList[actual_product_id="' + actual_product_id + '"][cardholder-custom-text-extra="' + cardholder_custom_text_extra + '"]')
                .parents(".cart-item-data")
                .find(".qty.quantity")
                .html(`Qty : <span>${newQty2}</span>`);
              } else {
                console.warn("Matching item for extra_custom_text not found.");
              }
            }
        
            // --- Call /cart/update.js once ---
            if (Object.keys(updates).length > 0) {
              iscart.classList.add('is--contentUpdate');
              const updateRes = await fetch('/cart/update.js', {
                method: 'POST',
                headers: {
                  'Content-Type': 'application/json'
                },
                body: JSON.stringify({ updates })
              });
        
              const result = await updateRes.json();
              iscart.classList.remove('is--contentUpdate');
              $(document).trigger('cart:updated');
              if(window.location.pathname==="/cart"){ window.location.reload()}
            }
        
          } catch (error) {
            console.error("Error in combined cart quantity decrease:", error);
          }
        }, 3000);
      } else if (cardholder_logo == 0 && cardholder_engrave_text.length > 0){
        setTimeout(function(index, value){
          console.log('engrave text no logo')
          $('.engrave-charge .t4s-cart_meta_propertyList[actual_product_id="'+actual_product_id+'"][cardholder-engrave-text='+cardholder_engrave_text+'][cardholder-image=""][cardholder-logo=""]').parents(".cart-item-data").find(".quantity .minus").click();
          $('.engrave-charge .t4s-cart_meta_propertyList[actual_product_id="'+actual_product_id+'"][cardholder-engrave-text='+cardholder_engrave_text+'][cardholder-image=""][cardholder-logo=""]').parents(".cart-item-data").find(".qty.quantity").html("Qty : <span>"+(parseInt($('.engrave-charge .t4s-cart_meta_propertyList[actual_product_id="'+actual_product_id+'"][cardholder-engrave-text='+cardholder_engrave_text+'][cardholder-image=""][cardholder-logo=""]').parents(".cart-item-data").find(".qty.quantity span").text())-1)+"</span>");
        }, 2500);
      } else if (!cardholder_image.length && cardholder_engrave_text.length > 0){
        setTimeout(function(index, value){
          console.log('engrave text no image')
          $('.engrave-charge .t4s-cart_meta_propertyList[actual_product_id="'+actual_product_id+'"][cardholder-engrave-text='+cardholder_engrave_text+'][cardholder-image=""][cardholder-logo=""]').parents(".cart-item-data").find(".quantity .minus").click();
          $('.engrave-charge .t4s-cart_meta_propertyList[actual_product_id="'+actual_product_id+'"][cardholder-engrave-text='+cardholder_engrave_text+'][cardholder-image=""][cardholder-logo=""]').parents(".cart-item-data").find(".qty.quantity").html("Qty : <span>"+(parseInt($('.engrave-charge .t4s-cart_meta_propertyList[actual_product_id="'+actual_product_id+'"][cardholder-engrave-text='+cardholder_engrave_text+'][cardholder-image=""][cardholder-logo=""]').parents(".cart-item-data").find(".qty.quantity span").text())-1)+"</span>");
        }, 2500);
      } else if (cardholder_logo == 0 && cardholder_custom_text.length > 0){
         setTimeout(async function () {
          let iscart = document.getElementById('t4s-mini_cart') || document.querySelector('.t4s-cartPage__form');
          try {
            const updates = {};
        
            // Fetch current cart
            const res = await fetch('/cart.js');
            const cart = await res.json();
        
            // --- First product: Cardholder Custom Text ---
            const matchingItem1 = cart.items.find(item =>
              item.properties &&
              item.properties["Actual Product"] == actual_product_id &&
              item.properties["Cardholder Custom Text"] == cardholder_custom_text &&
              !item.properties["Cardholder Image"] &&
              !item.properties["Cardholder Logo"]
            );
        
            if (matchingItem1) {
              const newQty1 = matchingItem1.quantity - 1;
              updates[matchingItem1.key] = newQty1;
        
              // Update DOM manually
              $('.engrave-charge .t4s-cart_meta_propertyList[actual_product_id="' + actual_product_id + '"][cardholder-custom-text="' + cardholder_custom_text + '"][cardholder-image=""][cardholder-logo=""]')
                .parents(".cart-item-data")
                .find(".qty.quantity")
                .html(`Qty : <span>${newQty1}</span>`);
            } else {
              console.warn("Matching item for custom_text not found.");
            }
        
            // --- Second product: Extra Custom Text (optional) ---
           if (cardholder_custom_text_extra.length > 0) {
              const matchingItem2 = cart.items.find(item =>
                item.properties &&
                item.properties["Actual Product"] == actual_product_id &&
                item.properties["Cardholder Extra Custom Text"] == cardholder_custom_text_extra
              );
        
              if (matchingItem2) {
                const newQty2 = matchingItem2.quantity - 1;
                updates[matchingItem2.key] = newQty2;
                $('.engrave-charge .t4s-cart_meta_propertyList[actual_product_id="' + actual_product_id + '"][cardholder-custom-text-extra="' + cardholder_custom_text_extra + '"]')
                .parents(".cart-item-data")
                .find(".qty.quantity")
                .html(`Qty : <span>${newQty2}</span>`);
              } else {
                console.warn("Matching item for extra_custom_text not found.");
              }
            }
        
            // --- Call /cart/update.js once ---
            if (Object.keys(updates).length > 0) {
               iscart.classList.add('is--contentUpdate');
              const updateRes = await fetch('/cart/update.js', {
                method: 'POST',
                headers: {
                  'Content-Type': 'application/json'
                },
                body: JSON.stringify({ updates })
              });
        
              const result = await updateRes.json();
              iscart.classList.remove('is--contentUpdate');
              $(document).trigger('cart:updated');
              if(window.location.pathname==="/cart"){ window.location.reload()}
            }
        
          } catch (error) {
            console.error("Error in combined cart quantity decrease:", error);
          }
        }, 3000);

      } else if (!cardholder_image.length && cardholder_custom_text.length > 0){
        setTimeout(async function () {
          let iscart = document.getElementById('t4s-mini_cart') || document.querySelector('.t4s-cartPage__form');
          try {
            const updates = {};
        
            // Fetch current cart
            const res = await fetch('/cart.js');
            const cart = await res.json();
        
            // --- First product: Cardholder Custom Text ---
            const matchingItem1 = cart.items.find(item =>
              item.properties &&
              item.properties["Actual Product"] == actual_product_id &&
              item.properties["Cardholder Custom Text"] == cardholder_custom_text &&
              !item.properties["Cardholder Image"] &&
              !item.properties["Cardholder Logo"]
            );
        
            if (matchingItem1) {
              const newQty1 = matchingItem1.quantity - 1;
              updates[matchingItem1.key] = newQty1;
        
              // Update DOM manually
              $('.engrave-charge .t4s-cart_meta_propertyList[actual_product_id="' + actual_product_id + '"][cardholder-custom-text="' + cardholder_custom_text + '"][cardholder-image=""][cardholder-logo=""]')
                .parents(".cart-item-data")
                .find(".qty.quantity")
                .html(`Qty : <span>${newQty1}</span>`);
            } else {
              console.warn("Matching item for custom_text not found.");
            }
        
            // --- Second product: Extra Custom Text (optional) ---
            if (cardholder_custom_text_extra.length > 0) {
              const matchingItem2 = cart.items.find(item =>
                item.properties &&
                item.properties["Actual Product"] == actual_product_id &&
                item.properties["Cardholder Extra Custom Text"] == cardholder_custom_text_extra
              );
        
              if (matchingItem2) {
                const newQty2 = matchingItem2.quantity - 1;
                updates[matchingItem2.key] = newQty2;
                $('.engrave-charge .t4s-cart_meta_propertyList[actual_product_id="' + actual_product_id + '"][cardholder-custom-text-extra="' + cardholder_custom_text_extra + '"]')
                .parents(".cart-item-data")
                .find(".qty.quantity")
                .html(`Qty : <span>${newQty2}</span>`);
              } else {
                console.warn("Matching item for extra_custom_text not found.");
              }
            }
        
            // --- Call /cart/update.js once ---
            if (Object.keys(updates).length > 0) {
               iscart.classList.add('is--contentUpdate');
              const updateRes = await fetch('/cart/update.js', {
                method: 'POST',
                headers: {
                  'Content-Type': 'application/json'
                },
                body: JSON.stringify({ updates })
              });
        
              const result = await updateRes.json();
               iscart.classList.remove('is--contentUpdate');
              $(document).trigger('cart:updated');
              if(window.location.pathname==="/cart"){ window.location.reload()}
            }
        
          } catch (error) {
            console.error("Error in combined cart quantity decrease:", error);
          }
        }, 3000);
      }
    }

    //3 added custom text as well
    if(airpods_engrave_text.length > 0){
      setTimeout(function(index, value){
        $(".engrave-charge .t4s-cart_meta_propertyList[actual_product_id='"+actual_product_id+"'][airpods-engrave-text="+airpods_engrave_text+"]").parents(".cart-item-data").find(".quantity .minus").click();
        $(".engrave-charge .t4s-cart_meta_propertyList[actual_product_id='"+actual_product_id+"'][airpods-engrave-text="+airpods_engrave_text+"]").parents(".cart-item-data").find(".qty.quantity").html("Qty : <span>"+(parseInt($(".engrave-charge .t4s-cart_meta_propertyList[actual_product_id='"+actual_product_id+"'][airpods-engrave-text="+airpods_engrave_text+"]").parents(".cart-item-data").find(".qty.quantity span").text())-1)+"</span>");
      }, 2500);
    } else if (airpods_custom_text.length > 0){
      setTimeout(function(index, value){
        $(".engrave-charge .t4s-cart_meta_propertyList[actual_product_id='"+actual_product_id+"'][airpods-custom-text="+airpods_custom_text+"]").parents(".cart-item-data").find(".quantity .minus").click();
        $(".engrave-charge .t4s-cart_meta_propertyList[actual_product_id='"+actual_product_id+"'][airpods-custom-text="+airpods_custom_text+"]").parents(".cart-item-data").find(".qty.quantity").html("Qty : <span>"+(parseInt($(".engrave-charge .t4s-cart_meta_propertyList[actual_product_id='"+actual_product_id+"'][airpods-custom-text="+airpods_custom_text+"]").parents(".cart-item-data").find(".qty.quantity span").text())-1)+"</span>");
      }, 2500);
    }

    //4 added custom text as well
    if(watch_engrave_text.length > 0){
      setTimeout(function(index, value){
        $(".engrave-charge .t4s-cart_meta_propertyList[actual_product_id='"+actual_product_id+"'][watch-engrave-text="+watch_engrave_text+"]").parents(".cart-item-data").find(".quantity .minus").click();
        $(".engrave-charge .t4s-cart_meta_propertyList[actual_product_id='"+actual_product_id+"'][watch-engrave-text="+watch_engrave_text+"]").parents(".cart-item-data").find(".qty.quantity").html("Qty : <span>"+(parseInt($(".engrave-charge .t4s-cart_meta_propertyList[actual_product_id='"+actual_product_id+"'][watch-engrave-text="+watch_engrave_text+"]").parents(".cart-item-data").find(".qty.quantity span").text())-1)+"</span>");
      }, 2500);
    } else if (watch_custom_text.length > 0){
      setTimeout(function(index, value){
        $(".engrave-charge .t4s-cart_meta_propertyList[actual_product_id='"+actual_product_id+"'][watch-custom-text="+watch_custom_text+"]").parents(".cart-item-data").find(".quantity .minus").click();
        $(".engrave-charge .t4s-cart_meta_propertyList[actual_product_id='"+actual_product_id+"'][watch-custom-text="+watch_custom_text+"]").parents(".cart-item-data").find(".qty.quantity").html("Qty : <span>"+(parseInt($(".engrave-charge .t4s-cart_meta_propertyList[actual_product_id='"+actual_product_id+"'][watch-custom-text="+watch_custom_text+"]").parents(".cart-item-data").find(".qty.quantity span").text())-1)+"</span>");
      }, 2500);
    }

    //5 added custom text as well
    if(wallet_engrave_text.length > 0 || wallet_image.length > 0 || wallet_logo != 0 && wallet_logo.length > 0 || wallet_custom_text.length > 0 || wallet_custom_text_extra.length > 0){
      if(wallet_image.length > 0 && !wallet_custom_text.length){
        wallet_image = $(this).parents(".cart-item-data").find(".t4s-cart_meta_propertyList").attr("wallet-image");
        setTimeout(function(index, value){
          console.log('img only')
          $('.engrave-charge .t4s-cart_meta_propertyList[actual_product_id="'+actual_product_id+'"][wallet-image='+wallet_image+'][wallet-custom-text=""]').parents(".cart-item-data").find(".quantity .minus").click();
          $('.engrave-charge .t4s-cart_meta_propertyList[actual_product_id="'+actual_product_id+'"][wallet-image='+wallet_image+'][wallet-custom-text=""]').parents(".cart-item-data").find(".qty.quantity").html("Qty : <span>"+(parseInt($('.engrave-charge .t4s-cart_meta_propertyList[actual_product_id="'+actual_product_id+'"][wallet-image='+wallet_image+'][wallet-custom-text=""]').parents(".cart-item-data").find(".qty.quantity span").text())-1)+"</span>");
        }, 2500);
      } else if(wallet_image.length > 0 && wallet_custom_text.length > 0){
        wallet_image = $(this).parents(".cart-item-data").find(".t4s-cart_meta_propertyList").attr("wallet-image");
        setTimeout(async function () {
          let iscart = document.getElementById('t4s-mini_cart') || document.querySelector('.t4s-cartPage__form');
          
          const updates = {};

          // Fetch current cart
          const res = await fetch('/cart.js');
          const cart = await res.json();

          // --- First product: Wallet Custom Text + Image ---
          const matchingItem1 = cart.items.find(item =>
            item.properties &&
            item.properties["Actual Product"] == actual_product_id &&
            item.properties["Wallet Custom Text"] == wallet_custom_text &&
            item.properties["Wallet Image"]
          );

          if (matchingItem1) {
            const newQty1 = matchingItem1.quantity - 1;
            updates[matchingItem1.key] = newQty1;

            // Update DOM manually
            $('.engrave-charge .t4s-cart_meta_propertyList[actual_product_id="' + actual_product_id + '"][wallet-custom-text="' + wallet_custom_text + '"][wallet-image="' + wallet_image + '"]')
              .parents(".cart-item-data")
              .find(".qty.quantity")
              .html(`Qty : <span>${newQty1}</span>`);
          } else {
            console.warn("Matching item for wallet custom_text + image not found.");
          }

          // --- Second product: Extra Custom Text (optional) ---
          if (wallet_custom_text_extra.length > 0) {
            const matchingItem2 = cart.items.find(item =>
              item.properties &&
              item.properties["Actual Product"] == actual_product_id &&
              item.properties["Wallet Extra Custom Text"] == wallet_custom_text_extra
            );

            if (matchingItem2) {
              const newQty2 = matchingItem2.quantity - 1;
              updates[matchingItem2.key] = newQty2;

              $('.engrave-charge .t4s-cart_meta_propertyList[actual_product_id="' + actual_product_id + '"][wallet-custom-text-extra="' + wallet_custom_text_extra + '"]')
                .parents(".cart-item-data")
                .find(".qty.quantity")
                .html(`Qty : <span>${newQty2}</span>`);
            } else {
              console.warn("Matching item for wallet extra_custom_text not found.");
            }
          }

          // --- Call /cart/update.js once ---
          if (Object.keys(updates).length > 0) {
            iscart.classList.add('is--contentUpdate');
            const updateRes = await fetch('/cart/update.js', {
              method: 'POST',
              headers: {
                'Content-Type': 'application/json'
              },
              body: JSON.stringify({ updates })
            });

            const result = await updateRes.json();
            iscart.classList.remove('is--contentUpdate');
            $(document).trigger('cart:updated');
            if (window.location.pathname === "/cart") {
              window.location.reload();
            }
          }
         
        }, 3000);
      } else if (wallet_logo != 0 && !wallet_custom_text.length){
        wallet_logo = $(this).parents(".cart-item-data").find(".t4s-cart_meta_propertyList").attr("wallet-logo");
        setTimeout(function(index, value){
          console.log('logo only')
          $('.engrave-charge .t4s-cart_meta_propertyList[actual_product_id="'+actual_product_id+'"][wallet-logo='+wallet_logo+'][wallet-custom-text=""]').parents(".cart-item-data").find(".quantity .minus").click();
          $('.engrave-charge .t4s-cart_meta_propertyList[actual_product_id="'+actual_product_id+'"][wallet-logo='+wallet_logo+'][wallet-custom-text=""]').parents(".cart-item-data").find(".qty.quantity").html("Qty : <span>"+(parseInt($('.engrave-charge .t4s-cart_meta_propertyList[actual_product_id="'+actual_product_id+'"][wallet-logo='+wallet_logo+'][wallet-custom-text=""]').parents(".cart-item-data").find(".qty.quantity span").text())-1)+"</span>");
        }, 2500);
      } else if (wallet_logo != 0 && wallet_custom_text.length > 0){
        wallet_logo = $(this).parents(".cart-item-data").find(".t4s-cart_meta_propertyList").attr("wallet-logo");
        setTimeout(async function () {
          let iscart = document.getElementById('t4s-mini_cart') || document.querySelector('.t4s-cartPage__form');

          try {
            const updates = {};

            // Fetch current cart
            const res = await fetch('/cart.js');
            const cart = await res.json();

            // --- First product: Wallet Custom Text + Logo ---
            const matchingItem1 = cart.items.find(item =>
              item.properties &&
              item.properties["Actual Product"] == actual_product_id &&
              item.properties["Wallet Custom Text"] == wallet_custom_text &&
              item.properties["Wallet Logo"]
            );

            if (matchingItem1) {
              const newQty1 = matchingItem1.quantity - 1;
              updates[matchingItem1.key] = newQty1;

              // Update DOM manually
              $('.engrave-charge .t4s-cart_meta_propertyList[actual_product_id="' + actual_product_id + '"][wallet-custom-text="' + wallet_custom_text + '"][wallet-logo="' + wallet_logo + '"]')
                .parents(".cart-item-data")
                .find(".qty.quantity")
                .html(`Qty : <span>${newQty1}</span>`);
            } else {
              console.warn("Matching wallet item for custom text + logo not found.");
            }

            // --- Second product: Extra Custom Text (optional) ---
            if (wallet_custom_text_extra.length > 0) {
              const matchingItem2 = cart.items.find(item =>
                item.properties &&
                item.properties["Actual Product"] == actual_product_id &&
                item.properties["Wallet Extra Custom Text"] == wallet_custom_text_extra
              );

              if (matchingItem2) {
                const newQty2 = matchingItem2.quantity - 1;
                updates[matchingItem2.key] = newQty2;

                $('.engrave-charge .t4s-cart_meta_propertyList[actual_product_id="' + actual_product_id + '"][wallet-custom-text-extra="' + wallet_custom_text_extra + '"]')
                  .parents(".cart-item-data")
                  .find(".qty.quantity")
                  .html(`Qty : <span>${newQty2}</span>`);
              } else {
                console.warn("Matching wallet item for extra custom text not found.");
              }
            }

            // --- Call /cart/update.js once ---
            if (Object.keys(updates).length > 0) {
              iscart.classList.add('is--contentUpdate');
              const updateRes = await fetch('/cart/update.js', {
                method: 'POST',
                headers: {
                  'Content-Type': 'application/json'
                },
                body: JSON.stringify({ updates })
              });

              const result = await updateRes.json();
              iscart.classList.remove('is--contentUpdate');
              $(document).trigger('cart:updated');

              if (window.location.pathname === "/cart") {
                window.location.reload();
              }
            }

          } catch (error) {
            console.error("Error in wallet logo + text cart update:", error);
          }
        }, 3000);
      } else if (wallet_logo == 0 && wallet_engrave_text.length > 0){
        setTimeout(function() {
          console.log('engrave text no logo',wallet_engrave_text_length)
          let wallet_engrave_text_str = Array.isArray(wallet_engrave_text)
            ? wallet_engrave_text.join(', ')
            : wallet_engrave_text;
        
          let selector = '.engrave-charge .t4s-cart_meta_propertyList' +
            '[actual_product_id="' + actual_product_id + '"]' +
            '[wallet-engrave-text="' + wallet_engrave_text_str + '"]' +
            '[wallet-image=""][wallet-logo=""]';
        
          let $target = $(selector);
          let $input = $target.parents(".cart-item-data").find("input.t4s-quantity-input.t4s-add-quantity");
        
          let currentQty = parseInt($input.val()) || 0;
          let engraveLength = parseInt(wallet_engrave_text_length) || 0;
        
          let newQty = currentQty - engraveLength;
          $input.val(newQty).trigger('change');
        
          $target.parents(".cart-item-data")
            .find(".qty.quantity")
            .html("Qty : <span>" + newQty + "</span>");
        
        }, 2500);
      } else if (!wallet_image.length && wallet_engrave_text.length > 0){
        setTimeout(function() {
          console.log('engrave text no logo',wallet_engrave_text_length)
          let wallet_engrave_text_str = Array.isArray(wallet_engrave_text)
            ? wallet_engrave_text.join(', ')
            : wallet_engrave_text;
        
          let selector = '.engrave-charge .t4s-cart_meta_propertyList' +
            '[actual_product_id="' + actual_product_id + '"]' +
            '[wallet-engrave-text="' + wallet_engrave_text_str + '"]' +
            '[wallet-image=""][wallet-logo=""]';
        
          let $target = $(selector);
          let $input = $target.parents(".cart-item-data").find("input.t4s-quantity-input.t4s-add-quantity");
        
          let currentQty = parseInt($input.val()) || 0;
          let engraveLength = parseInt(wallet_engrave_text_length) || 0;
        
          let newQty = currentQty - engraveLength;
          $input.val(newQty).trigger('change');
        
          $target.parents(".cart-item-data")
            .find(".qty.quantity")
            .html("Qty : <span>" + newQty + "</span>");
        
        }, 2500);
      } else if (wallet_logo == 0 && wallet_custom_text.length > 0){
        setTimeout(async function () {
          let iscart = document.getElementById('t4s-mini_cart') || document.querySelector('.t4s-cartPage__form');

          try {
            const updates = {};

            // Fetch current cart
            const res = await fetch('/cart.js');
            const cart = await res.json();

            // --- First product: Wallet Custom Text only ---
            const matchingItem1 = cart.items.find(item =>
              item.properties &&
              item.properties["Actual Product"] == actual_product_id &&
              item.properties["Wallet Custom Text"] == wallet_custom_text &&
              !item.properties["Wallet Image"] &&
              !item.properties["Wallet Logo"]
            );

            if (matchingItem1) {
              const newQty1 = matchingItem1.quantity - 1;
              updates[matchingItem1.key] = newQty1;

              // Update DOM manually
              $('.engrave-charge .t4s-cart_meta_propertyList[actual_product_id="' + actual_product_id + '"][wallet-custom-text="' + wallet_custom_text + '"][wallet-image=""][wallet-logo=""]')
                .parents(".cart-item-data")
                .find(".qty.quantity")
                .html(`Qty : <span>${newQty1}</span>`);
            } else {
              console.warn("Matching wallet item for custom text only not found.");
            }

            // --- Second product: Wallet Extra Custom Text (optional) ---
            if (wallet_custom_text_extra.length > 0) {
              const matchingItem2 = cart.items.find(item =>
                item.properties &&
                item.properties["Actual Product"] == actual_product_id &&
                item.properties["Wallet Extra Custom Text"] == wallet_custom_text_extra
              );

              if (matchingItem2) {
                const newQty2 = matchingItem2.quantity - 1;
                updates[matchingItem2.key] = newQty2;

                $('.engrave-charge .t4s-cart_meta_propertyList[actual_product_id="' + actual_product_id + '"][wallet-custom-text-extra="' + wallet_custom_text_extra + '"]')
                  .parents(".cart-item-data")
                  .find(".qty.quantity")
                  .html(`Qty : <span>${newQty2}</span>`);
              } else {
                console.warn("Matching wallet item for extra custom text not found.");
              }
            }

            // --- Call /cart/update.js once ---
            if (Object.keys(updates).length > 0) {
              iscart.classList.add('is--contentUpdate');
              const updateRes = await fetch('/cart/update.js', {
                method: 'POST',
                headers: {
                  'Content-Type': 'application/json'
                },
                body: JSON.stringify({ updates })
              });

              const result = await updateRes.json();
              iscart.classList.remove('is--contentUpdate');
              $(document).trigger('cart:updated');

              if (window.location.pathname === "/cart") {
                window.location.reload();
              }
            }

          } catch (error) {
            console.error("Error in wallet custom text only cart update:", error);
          }
        }, 3000);
      } else if (!wallet_image.length && wallet_custom_text.length > 0){
        setTimeout(async function () {
          let iscart = document.getElementById('t4s-mini_cart') || document.querySelector('.t4s-cartPage__form');

          try {
            const updates = {};

            // Fetch current cart
            const res = await fetch('/cart.js');
            const cart = await res.json();

            // --- First product: Wallet Custom Text only ---
            const matchingItem1 = cart.items.find(item =>
              item.properties &&
              item.properties["Actual Product"] == actual_product_id &&
              item.properties["Wallet Custom Text"] == wallet_custom_text &&
              !item.properties["Wallet Image"] &&
              !item.properties["Wallet Logo"]
            );

            if (matchingItem1) {
              const newQty1 = matchingItem1.quantity - 1;
              updates[matchingItem1.key] = newQty1;

              // Update DOM manually
              $('.engrave-charge .t4s-cart_meta_propertyList[actual_product_id="' + actual_product_id + '"][wallet-custom-text="' + wallet_custom_text + '"][wallet-image=""][wallet-logo=""]')
                .parents(".cart-item-data")
                .find(".qty.quantity")
                .html(`Qty : <span>${newQty1}</span>`);
            } else {
              console.warn("Matching wallet item for custom text only not found.");
            }

            // --- Second product: Wallet Extra Custom Text (optional) ---
            if (wallet_custom_text_extra.length > 0) {
              const matchingItem2 = cart.items.find(item =>
                item.properties &&
                item.properties["Actual Product"] == actual_product_id &&
                item.properties["Wallet Extra Custom Text"] == wallet_custom_text_extra
              );

              if (matchingItem2) {
                const newQty2 = matchingItem2.quantity - 1;
                updates[matchingItem2.key] = newQty2;

                $('.engrave-charge .t4s-cart_meta_propertyList[actual_product_id="' + actual_product_id + '"][wallet-custom-text-extra="' + wallet_custom_text_extra + '"]')
                  .parents(".cart-item-data")
                  .find(".qty.quantity")
                  .html(`Qty : <span>${newQty2}</span>`);
              } else {
                console.warn("Matching wallet item for extra custom text not found.");
              }
            }

            // --- Call /cart/update.js once ---
            if (Object.keys(updates).length > 0) {
              iscart.classList.add('is--contentUpdate');
              const updateRes = await fetch('/cart/update.js', {
                method: 'POST',
                headers: {
                  'Content-Type': 'application/json'
                },
                body: JSON.stringify({ updates })
              });

              const result = await updateRes.json();
              iscart.classList.remove('is--contentUpdate');
              $(document).trigger('cart:updated');

              if (window.location.pathname === "/cart") {
                window.location.reload();
              }
            }

          } catch (error) {
            console.error("Error in wallet custom text only cart update:", error);
          }
        }, 3000);
      }
    }

    //6 added custom text as well
    if(lanyard_engrave_text.length > 0 || lanyard_image.length > 0 || lanyard_logo != 0 && lanyard_logo.length > 0 || lanyard_custom_text.length > 0 || lanyard_custom_text_extra.length > 0){
      if(lanyard_image.length > 0 && !lanyard_custom_text.length){
        lanyard_image = $(this).parents(".cart-item-data").find(".t4s-cart_meta_propertyList").attr("lanyard-image");
        setTimeout(function(index, value){
          console.log('img only')
          $('.engrave-charge .t4s-cart_meta_propertyList[actual_product_id="'+actual_product_id+'"][lanyard-image='+lanyard_image+'][lanyard-custom-text=""]').parents(".cart-item-data").find(".quantity .minus").click();
          $('.engrave-charge .t4s-cart_meta_propertyList[actual_product_id="'+actual_product_id+'"][lanyard-image='+lanyard_image+'][lanyard-custom-text=""]').parents(".cart-item-data").find(".qty.quantity").html("Qty : <span>"+(parseInt($('.engrave-charge .t4s-cart_meta_propertyList[actual_product_id="'+actual_product_id+'"][lanyard-image='+lanyard_image+'][lanyard-custom-text=""]').parents(".cart-item-data").find(".qty.quantity span").text())-1)+"</span>");
        }, 2500);
      } else if(lanyard_image.length > 0 && lanyard_custom_text.length > 0){
        lanyard_image = $(this).parents(".cart-item-data").find(".t4s-cart_meta_propertyList").attr("lanyard-image");
        setTimeout(async function () {
          let iscart = document.getElementById('t4s-mini_cart') || document.querySelector('.t4s-cartPage__form');

          try {
            const updates = {};

            // Fetch current cart
            const res = await fetch('/cart.js');
            const cart = await res.json();

            // --- First product: Lanyard Custom Text ---
            const matchingItem1 = cart.items.find(item =>
              item.properties &&
              item.properties["Actual Product"] == actual_product_id &&
              item.properties["Lanyard Custom Text"] == lanyard_custom_text &&
              item.properties["Lanyard Image"]
            );

            if (matchingItem1) {
              const newQty1 = matchingItem1.quantity - 1;
              updates[matchingItem1.key] = newQty1;

              // Update DOM manually
              $('.engrave-charge .t4s-cart_meta_propertyList[actual_product_id="' + actual_product_id + '"][lanyard-custom-text="' + lanyard_custom_text + '"][lanyard-image=' + lanyard_image + ']')
                .parents(".cart-item-data")
                .find(".qty.quantity")
                .html(`Qty : <span>${newQty1}</span>`);
            } else {
              console.warn("Matching item for lanyard_custom_text not found.");
            }

            // --- Second product: Lanyard Extra Custom Text (optional) ---
            if (lanyard_custom_text_extra.length > 0) {
              const matchingItem2 = cart.items.find(item =>
                item.properties &&
                item.properties["Actual Product"] == actual_product_id &&
                item.properties["Lanyard Extra Custom Text"] == lanyard_custom_text_extra
              );

              if (matchingItem2) {
                const newQty2 = matchingItem2.quantity - 1;
                updates[matchingItem2.key] = newQty2;

                $('.engrave-charge .t4s-cart_meta_propertyList[actual_product_id="' + actual_product_id + '"][lanyard-custom-text-extra="' + lanyard_custom_text_extra + '"]')
                  .parents(".cart-item-data")
                  .find(".qty.quantity")
                  .html(`Qty : <span>${newQty2}</span>`);
              } else {
                console.warn("Matching item for lanyard_custom_text_extra not found.");
              }
            }

            // --- Call /cart/update.js once ---
            if (Object.keys(updates).length > 0) {
              iscart.classList.add('is--contentUpdate');
              const updateRes = await fetch('/cart/update.js', {
                method: 'POST',
                headers: {
                  'Content-Type': 'application/json'
                },
                body: JSON.stringify({ updates })
              });

              const result = await updateRes.json();
              iscart.classList.remove('is--contentUpdate');
              $(document).trigger('cart:updated');
              if (window.location.pathname === "/cart") {
                window.location.reload();
              }
            }

          } catch (error) {
            console.error("Error in combined cart update:", error);
          }
        }, 3000);
      } else if (lanyard_logo != 0 && !lanyard_custom_text.length){
        lanyard_logo = $(this).parents(".cart-item-data").find(".t4s-cart_meta_propertyList").attr("lanyard-logo");
        setTimeout(function(index, value){
          console.log('logo only')
          $('.engrave-charge .t4s-cart_meta_propertyList[actual_product_id="'+actual_product_id+'"][lanyard-logo='+lanyard_logo+'][lanyard-custom-text=""]').parents(".cart-item-data").find(".quantity .minus").click();
          $('.engrave-charge .t4s-cart_meta_propertyList[actual_product_id="'+actual_product_id+'"][lanyard-logo='+lanyard_logo+'][lanyard-custom-text=""]').parents(".cart-item-data").find(".qty.quantity").html("Qty : <span>"+(parseInt($('.engrave-charge .t4s-cart_meta_propertyList[actual_product_id="'+actual_product_id+'"][lanyard-logo='+lanyard_logo+'][lanyard-custom-text=""]').parents(".cart-item-data").find(".qty.quantity span").text())-1)+"</span>");
        }, 2500);
      } else if (lanyard_logo != 0 && lanyard_custom_text.length > 0){
        lanyard_logo = $(this).parents(".cart-item-data").find(".t4s-cart_meta_propertyList").attr("lanyard-logo");
        setTimeout(async function () {
          let iscart = document.getElementById('t4s-mini_cart') || document.querySelector('.t4s-cartPage__form');

          try {
            const updates = {};

            // Fetch current cart
            const res = await fetch('/cart.js');
            const cart = await res.json();

            // --- First product: Lanyard Custom Text ---
            const matchingItem1 = cart.items.find(item =>
              item.properties &&
              item.properties["Actual Product"] == actual_product_id &&
              item.properties["Lanyard Custom Text"] == lanyard_custom_text &&
              item.properties["Lanyard Logo"]
            );

            if (matchingItem1) {
              const newQty1 = matchingItem1.quantity - 1;
              updates[matchingItem1.key] = newQty1;

              // Update DOM manually
              $('.engrave-charge .t4s-cart_meta_propertyList[actual_product_id="' + actual_product_id + '"][lanyard-custom-text="' + lanyard_custom_text + '"][lanyard-logo=' + lanyard_logo + ']')
                .parents(".cart-item-data")
                .find(".qty.quantity")
                .html(`Qty : <span>${newQty1}</span>`);
            } else {
              console.warn("Matching item for lanyard_custom_text not found.");
            }

            // --- Second product: Lanyard Extra Custom Text (optional) ---
            if (lanyard_custom_text_extra.length > 0) {
              const matchingItem2 = cart.items.find(item =>
                item.properties &&
                item.properties["Actual Product"] == actual_product_id &&
                item.properties["Lanyard Extra Custom Text"] == lanyard_custom_text_extra
              );

              if (matchingItem2) {
                const newQty2 = matchingItem2.quantity - 1;
                updates[matchingItem2.key] = newQty2;

                $('.engrave-charge .t4s-cart_meta_propertyList[actual_product_id="' + actual_product_id + '"][lanyard-custom-text-extra="' + lanyard_custom_text_extra + '"]')
                  .parents(".cart-item-data")
                  .find(".qty.quantity")
                  .html(`Qty : <span>${newQty2}</span>`);
              } else {
                console.warn("Matching item for lanyard_custom_text_extra not found.");
              }
            }

            // --- Call /cart/update.js once ---
            if (Object.keys(updates).length > 0) {
              iscart.classList.add('is--contentUpdate');
              const updateRes = await fetch('/cart/update.js', {
                method: 'POST',
                headers: {
                  'Content-Type': 'application/json'
                },
                body: JSON.stringify({ updates })
              });

              const result = await updateRes.json();
              iscart.classList.remove('is--contentUpdate');
              $(document).trigger('cart:updated');
              if (window.location.pathname === "/cart") {
                window.location.reload();
              }
            }

          } catch (error) {
            console.error("Error in combined cart update:", error);
          }
        }, 3000);
      } else if (lanyard_logo == 0 && lanyard_engrave_text.length > 0){
        setTimeout(function() {
          let lanyard_engrave_text_str = Array.isArray(lanyard_engrave_text)
            ? lanyard_engrave_text.join(', ')
            : lanyard_engrave_text;
        
          let selector = '.engrave-charge .t4s-cart_meta_propertyList' +
            '[actual_product_id="' + actual_product_id + '"]' +
            '[lanyard-engrave-text="' + lanyard_engrave_text_str + '"]' +
            '[lanyard-image=""][lanyard-logo=""]';
        
          let $target = $(selector);
          let $input = $target.parents(".cart-item-data").find("input.t4s-quantity-input.t4s-add-quantity");
        
          let currentQty = parseInt($input.val()) || 0;
          let engraveLength = parseInt(lanyard_engrave_text_length) || 0;
        
          let newQty = currentQty - engraveLength;
          $input.val(newQty).trigger('change');
        
          $target.parents(".cart-item-data")
            .find(".qty.quantity")
            .html("Qty : <span>" + newQty + "</span>");
        
        }, 2500);
      } else if (!lanyard_image.length && lanyard_engrave_text.length > 0){
        setTimeout(function(index, value){
          console.log('engrave text no image')
          $('.engrave-charge .t4s-cart_meta_propertyList[actual_product_id="'+actual_product_id+'"][lanyard-engrave-text='+lanyard_engrave_text+'][lanyard-image=""][lanyard-logo=""]').parents(".cart-item-data").find(".quantity .minus").click();
          $('.engrave-charge .t4s-cart_meta_propertyList[actual_product_id="'+actual_product_id+'"][lanyard-engrave-text='+lanyard_engrave_text+'][lanyard-image=""][lanyard-logo=""]').parents(".cart-item-data").find(".qty.quantity").html("Qty : <span>"+(parseInt($('.engrave-charge .t4s-cart_meta_propertyList[actual_product_id="'+actual_product_id+'"][lanyard-engrave-text='+lanyard_engrave_text+'][lanyard-image=""][lanyard-logo=""]').parents(".cart-item-data").find(".qty.quantity span").text())-1)+"</span>");
        }, 2500);
      } else if (lanyard_logo == 0 && lanyard_custom_text.length > 0){
         setTimeout(async function () {
          let iscart = document.getElementById('t4s-mini_cart') || document.querySelector('.t4s-cartPage__form');
          try {
            const updates = {};

            // Fetch current cart
            const res = await fetch('/cart.js');
            const cart = await res.json();

            // --- First product: Lanyard Custom Text ---
            const matchingItem1 = cart.items.find(item =>
              item.properties &&
              item.properties["Actual Product"] == actual_product_id &&
              item.properties["Lanyard Custom Text"] == lanyard_custom_text &&
              !item.properties["Lanyard Image"] &&
              !item.properties["Lanyard Logo"]
            );

            if (matchingItem1) {
              const newQty1 = matchingItem1.quantity - 1;
              updates[matchingItem1.key] = newQty1;

              // Update DOM manually
              $('.engrave-charge .t4s-cart_meta_propertyList[actual_product_id="' + actual_product_id + '"][lanyard-custom-text="' + lanyard_custom_text + '"][lanyard-image=""][lanyard-logo=""]')
                .parents(".cart-item-data")
                .find(".qty.quantity")
                .html(`Qty : <span>${newQty1}</span>`);
            } else {
              console.warn("Matching item for lanyard custom_text not found.");
            }

            // --- Second product: Extra Custom Text (optional) ---
            if (lanyard_custom_text_extra.length > 0) {
              const matchingItem2 = cart.items.find(item =>
                item.properties &&
                item.properties["Actual Product"] == actual_product_id &&
                item.properties["Lanyard Extra Custom Text"] == lanyard_custom_text_extra
              );

              if (matchingItem2) {
                const newQty2 = matchingItem2.quantity - 1;
                updates[matchingItem2.key] = newQty2;
                $('.engrave-charge .t4s-cart_meta_propertyList[actual_product_id="' + actual_product_id + '"][lanyard-custom-text-extra="' + lanyard_custom_text_extra + '"]')
                  .parents(".cart-item-data")
                  .find(".qty.quantity")
                  .html(`Qty : <span>${newQty2}</span>`);
              } else {
                console.warn("Matching item for lanyard extra_custom_text not found.");
              }
            }

            // --- Call /cart/update.js once ---
            if (Object.keys(updates).length > 0) {
              iscart.classList.add('is--contentUpdate');
              const updateRes = await fetch('/cart/update.js', {
                method: 'POST',
                headers: {
                  'Content-Type': 'application/json'
                },
                body: JSON.stringify({ updates })
              });

              const result = await updateRes.json();
              iscart.classList.remove('is--contentUpdate');
              $(document).trigger('cart:updated');
              if (window.location.pathname === "/cart") {
                window.location.reload();
              }
            }

          } catch (error) {
            console.error("Error in combined cart update:", error);
          }
        }, 3000);
      } else if (!lanyard_image.length && lanyard_custom_text.length > 0){
        setTimeout(async function () {
          let iscart = document.getElementById('t4s-mini_cart') || document.querySelector('.t4s-cartPage__form');
          try {
            const updates = {};

            // Fetch current cart
            const res = await fetch('/cart.js');
            const cart = await res.json();

            // --- First product: Lanyard Custom Text ---
            const matchingItem1 = cart.items.find(item =>
              item.properties &&
              item.properties["Actual Product"] == actual_product_id &&
              item.properties["Lanyard Custom Text"] == lanyard_custom_text &&
              !item.properties["Lanyard Image"] &&
              !item.properties["Lanyard Logo"]
            );

            if (matchingItem1) {
              const newQty1 = matchingItem1.quantity - 1;
              updates[matchingItem1.key] = newQty1;

              // Update DOM manually
              $('.engrave-charge .t4s-cart_meta_propertyList[actual_product_id="' + actual_product_id + '"][lanyard-custom-text="' + lanyard_custom_text + '"][lanyard-image=""][lanyard-logo=""]')
                .parents(".cart-item-data")
                .find(".qty.quantity")
                .html(`Qty : <span>${newQty1}</span>`);
            } else {
              console.warn("Matching item for lanyard custom_text not found.");
            }

            // --- Second product: Extra Custom Text (optional) ---
            if (lanyard_custom_text_extra.length > 0) {
              const matchingItem2 = cart.items.find(item =>
                item.properties &&
                item.properties["Actual Product"] == actual_product_id &&
                item.properties["Lanyard Extra Custom Text"] == lanyard_custom_text_extra
              );

              if (matchingItem2) {
                const newQty2 = matchingItem2.quantity - 1;
                updates[matchingItem2.key] = newQty2;
                $('.engrave-charge .t4s-cart_meta_propertyList[actual_product_id="' + actual_product_id + '"][lanyard-custom-text-extra="' + lanyard_custom_text_extra + '"]')
                  .parents(".cart-item-data")
                  .find(".qty.quantity")
                  .html(`Qty : <span>${newQty2}</span>`);
              } else {
                console.warn("Matching item for lanyard extra_custom_text not found.");
              }
            }

            // --- Call /cart/update.js once ---
            if (Object.keys(updates).length > 0) {
              iscart.classList.add('is--contentUpdate')
              const updateRes = await fetch('/cart/update.js', {
                method: 'POST',
                headers: {
                  'Content-Type': 'application/json'
                },
                body: JSON.stringify({ updates })
              });

              const result = await updateRes.json();
              iscart.classList.remove('is--contentUpdate');
              $(document).trigger('cart:updated');
              if (window.location.pathname === "/cart") { window.location.reload() }
            }

          } catch (error) {
            console.error("Error in combined cart update:", error);
          }
        }, 3000);
      }
    }

    //7 passport added custom text as well
    if(passport_engrave_text.length > 0 || passport_image.length > 0 || passport_logo != 0 && passport_logo.length > 0 || passport_custom_text.length > 0 || passport_custom_text_extra.length > 0){
      if(passport_image.length > 0 && !passport_custom_text.length){
        passport_image = $(this).parents(".cart-item-data").find(".t4s-cart_meta_propertyList").attr("passport-image");
        setTimeout(function(index, value){
          console.log('img only')
          $('.engrave-charge .t4s-cart_meta_propertyList[actual_product_id="'+actual_product_id+'"][passport-image='+passport_image+'][passport-custom-text=""]').parents(".cart-item-data").find(".quantity .plus").click();
          $('.engrave-charge .t4s-cart_meta_propertyList[actual_product_id="'+actual_product_id+'"][passport-image='+passport_image+'][passport-custom-text=""]').parents(".cart-item-data").find(".qty.quantity").html("Qty : <span>"+(parseInt($('.engrave-charge .t4s-cart_meta_propertyList[actual_product_id="'+actual_product_id+'"][passport-image='+passport_image+'][passport-custom-text=""]').parents(".cart-item-data").find(".qty.quantity span").text())-1)+"</span>");
        }, 2500);
      } else if(passport_image.length > 0 && passport_custom_text.length > 0){
        passport_image = $(this).parents(".cart-item-data").find(".t4s-cart_meta_propertyList").attr("passport-image");
        setTimeout(async function () {
          let iscart = document.getElementById('t4s-mini_cart') || document.querySelector('.t4s-cartPage__form');

          try {
            const updates = {};

            // Fetch current cart
            const res = await fetch('/cart.js');
            const cart = await res.json();

            // --- First product: Passport Custom Text + Image ---
            const matchingItem1 = cart.items.find(item =>
              item.properties &&
              item.properties["Actual Product"] == actual_product_id &&
              item.properties["Passport Custom Text"] == passport_custom_text &&
              item.properties["Passport Image"]
            );

            if (matchingItem1) {
              const newQty1 = matchingItem1.quantity - 1;
              updates[matchingItem1.key] = newQty1;

              // Update DOM manually
              $('.engrave-charge .t4s-cart_meta_propertyList[actual_product_id="' + actual_product_id + '"][passport-custom-text="' + passport_custom_text + '"][passport-image=' + passport_image + ']')
                .parents(".cart-item-data")
                .find(".qty.quantity")
                .html(`Qty : <span>${newQty1}</span>`);
            } else {
              console.warn("Matching item for passport_custom_text + image not found.");
            }

            // --- Second product: Passport Extra Custom Text (optional) ---
            if (passport_custom_text_extra.length > 0) {
              const matchingItem2 = cart.items.find(item =>
                item.properties &&
                item.properties["Actual Product"] == actual_product_id &&
                item.properties["Passport Extra Custom Text"] == passport_custom_text_extra
              );

              if (matchingItem2) {
                const newQty2 = matchingItem2.quantity - 1;
                updates[matchingItem2.key] = newQty2;

                $('.engrave-charge .t4s-cart_meta_propertyList[actual_product_id="' + actual_product_id + '"][passport-custom-text-extra="' + passport_custom_text_extra + '"]')
                  .parents(".cart-item-data")
                  .find(".qty.quantity")
                  .html(`Qty : <span>${newQty2}</span>`);
              } else {
                console.warn("Matching item for passport_custom_text_extra not found.");
              }
            }

            // --- Call /cart/update.js once ---
            if (Object.keys(updates).length > 0) {
              iscart.classList.add('is--contentUpdate');
              const updateRes = await fetch('/cart/update.js', {
                method: 'POST',
                headers: {
                  'Content-Type': 'application/json'
                },
                body: JSON.stringify({ updates })
              });

              const result = await updateRes.json();
              iscart.classList.remove('is--contentUpdate');
              $(document).trigger('cart:updated');
              if (window.location.pathname === "/cart") {
                window.location.reload();
              }
            }

          } catch (error) {
            console.error("Error in combined cart update (passport image + text):", error);
          }
        }, 3000);
      } else if (passport_logo != 0 && !passport_custom_text.length){
        passport_logo = $(this).parents(".cart-item-data").find(".t4s-cart_meta_propertyList").attr("passport-logo");
        setTimeout(function(index, value){
          console.log('logo only')
          $('.engrave-charge .t4s-cart_meta_propertyList[actual_product_id="'+actual_product_id+'"][passport-logo='+passport_logo+'][passport-custom-text=""]').parents(".cart-item-data").find(".quantity .plus").click();
          $('.engrave-charge .t4s-cart_meta_propertyList[actual_product_id="'+actual_product_id+'"][passport-logo='+passport_logo+'][passport-custom-text=""]').parents(".cart-item-data").find(".qty.quantity").html("Qty : <span>"+(parseInt($('.engrave-charge .t4s-cart_meta_propertyList[actual_product_id="'+actual_product_id+'"][passport-logo='+passport_logo+'][passport-custom-text=""]').parents(".cart-item-data").find(".qty.quantity span").text())-1)+"</span>");
        }, 2500);
      } else if (passport_logo != 0 && passport_custom_text.length > 0){
        passport_logo = $(this).parents(".cart-item-data").find(".t4s-cart_meta_propertyList").attr("passport-logo");
        setTimeout(async function () {
          let iscart = document.getElementById('t4s-mini_cart') || document.querySelector('.t4s-cartPage__form');

          try {
            const updates = {};

            // Fetch current cart
            const res = await fetch('/cart.js');
            const cart = await res.json();

            // --- First product: Passport Custom Text + Logo ---
            const matchingItem1 = cart.items.find(item =>
              item.properties &&
              item.properties["Actual Product"] == actual_product_id &&
              item.properties["Passport Custom Text"] == passport_custom_text &&
              item.properties["Passport Logo"]
            );

            if (matchingItem1) {
              const newQty1 = matchingItem1.quantity - 1;
              updates[matchingItem1.key] = newQty1;

              // Update DOM manually
              $('.engrave-charge .t4s-cart_meta_propertyList[actual_product_id="' + actual_product_id + '"][passport-custom-text="' + passport_custom_text + '"][passport-logo=' + passport_logo + ']')
                .parents(".cart-item-data")
                .find(".qty.quantity")
                .html(`Qty : <span>${newQty1}</span>`);
            } else {
              console.warn("Matching item for passport_custom_text + logo not found.");
            }

            // --- Second product: Passport Extra Custom Text (optional) ---
            if (passport_custom_text_extra.length > 0) {
              const matchingItem2 = cart.items.find(item =>
                item.properties &&
                item.properties["Actual Product"] == actual_product_id &&
                item.properties["Passport Extra Custom Text"] == passport_custom_text_extra
              );

              if (matchingItem2) {
                const newQty2 = matchingItem2.quantity - 1;
                updates[matchingItem2.key] = newQty2;

                $('.engrave-charge .t4s-cart_meta_propertyList[actual_product_id="' + actual_product_id + '"][passport-custom-text-extra="' + passport_custom_text_extra + '"]')
                  .parents(".cart-item-data")
                  .find(".qty.quantity")
                  .html(`Qty : <span>${newQty2}</span>`);
              } else {
                console.warn("Matching item for passport_custom_text_extra not found.");
              }
            }

            // --- Call /cart/update.js once ---
            if (Object.keys(updates).length > 0) {
              iscart.classList.add('is--contentUpdate');
              const updateRes = await fetch('/cart/update.js', {
                method: 'POST',
                headers: {
                  'Content-Type': 'application/json'
                },
                body: JSON.stringify({ updates })
              });

              const result = await updateRes.json();
              iscart.classList.remove('is--contentUpdate');
              $(document).trigger('cart:updated');
              if (window.location.pathname === "/cart") {
                window.location.reload();
              }
            }

          } catch (error) {
            console.error("Error in combined cart update (passport logo + text):", error);
          }
        }, 3000);
      } else if (passport_logo == 0 && passport_engrave_text.length > 0){
        setTimeout(function() {
          console.log('engrave text no logo',passport_engrave_text_length)
          let passport_engrave_text_str = Array.isArray(passport_engrave_text)
            ? passport_engrave_text.join(', ')
            : passport_engrave_text;
        
          let selector = '.engrave-charge .t4s-cart_meta_propertyList' +
            '[actual_product_id="' + actual_product_id + '"]' +
            '[passport-engrave-text="' + passport_engrave_text_str + '"]' +
            '[passport-image=""][passport-logo=""]';
        
          let $target = $(selector);
          let $input = $target.parents(".cart-item-data").find("input.t4s-quantity-input.t4s-add-quantity");
        
          let currentQty = parseInt($input.val()) || 0;
          let engraveLength = parseInt(passport_engrave_text_length) || 0;
        
          let newQty = currentQty - engraveLength;
          $input.val(newQty).trigger('change');
        
          $target.parents(".cart-item-data")
            .find(".qty.quantity")
            .html("Qty : <span>" + newQty + "</span>");
        
        }, 2500);
      } else if (!passport_image.length && passport_engrave_text.length > 0){
        setTimeout(function() {
          console.log('engrave text no logo',passport_engrave_text_length)
          let passport_engrave_text_str = Array.isArray(passport_engrave_text)
            ? passport_engrave_text.join(', ')
            : passport_engrave_text;
        
          let selector = '.engrave-charge .t4s-cart_meta_propertyList' +
            '[actual_product_id="' + actual_product_id + '"]' +
            '[passport-engrave-text="' + passport_engrave_text_str + '"]' +
            '[passport-image=""][passport-logo=""]';
        
          let $target = $(selector);
          let $input = $target.parents(".cart-item-data").find("input.t4s-quantity-input.t4s-add-quantity");
        
          let currentQty = parseInt($input.val()) || 0;
          let engraveLength = parseInt(passport_engrave_text_length) || 0;
        
          let newQty = currentQty - engraveLength;
          $input.val(newQty).trigger('change');
        
          $target.parents(".cart-item-data")
            .find(".qty.quantity")
            .html("Qty : <span>" + newQty + "</span>");
        
        }, 2500);
      } else if (passport_logo == 0 && passport_custom_text.length > 0){
        setTimeout(async function () {
          let iscart = document.getElementById('t4s-mini_cart') || document.querySelector('.t4s-cartPage__form');
          try {
            const updates = {};

            // Fetch current cart
            const res = await fetch('/cart.js');
            const cart = await res.json();

            // --- First product: Passport Custom Text only (no image, no logo) ---
            const matchingItem1 = cart.items.find(item =>
              item.properties &&
              item.properties["Actual Product"] == actual_product_id &&
              item.properties["Passport Custom Text"] == passport_custom_text &&
              !item.properties["Passport Image"] &&
              !item.properties["Passport Logo"]
            );

            if (matchingItem1) {
              const newQty1 = matchingItem1.quantity - 1;
              updates[matchingItem1.key] = newQty1;

              // Update DOM manually
              $('.engrave-charge .t4s-cart_meta_propertyList[actual_product_id="' + actual_product_id + '"][passport-custom-text="' + passport_custom_text + '"][passport-image=""][passport-logo=""]')
                .parents(".cart-item-data")
                .find(".qty.quantity")
                .html(`Qty : <span>${newQty1}</span>`);
            } else {
              console.warn("Matching item for passport custom_text (no image/logo) not found.");
            }

            // --- Second product: Passport Extra Custom Text (optional) ---
            if (passport_custom_text_extra.length > 0) {
              const matchingItem2 = cart.items.find(item =>
                item.properties &&
                item.properties["Actual Product"] == actual_product_id &&
                item.properties["Passport Extra Custom Text"] == passport_custom_text_extra
              );

              if (matchingItem2) {
                const newQty2 = matchingItem2.quantity - 1;
                updates[matchingItem2.key] = newQty2;

                $('.engrave-charge .t4s-cart_meta_propertyList[actual_product_id="' + actual_product_id + '"][passport-custom-text-extra="' + passport_custom_text_extra + '"]')
                  .parents(".cart-item-data")
                  .find(".qty.quantity")
                  .html(`Qty : <span>${newQty2}</span>`);
              } else {
                console.warn("Matching item for passport extra_custom_text not found.");
              }
            }

            // --- Call /cart/update.js once ---
            if (Object.keys(updates).length > 0) {
              iscart.classList.add('is--contentUpdate');
              const updateRes = await fetch('/cart/update.js', {
                method: 'POST',
                headers: {
                  'Content-Type': 'application/json'
                },
                body: JSON.stringify({ updates })
              });

              const result = await updateRes.json();
              iscart.classList.remove('is--contentUpdate');
              $(document).trigger('cart:updated');
              if (window.location.pathname === "/cart") {
                window.location.reload();
              }
            }

          } catch (error) {
            console.error("Error in combined cart update (passport custom_text only):", error);
          }
        }, 3000);
      }
    }

    //8 laptop added custom text as well
    if(laptop_engrave_text.length > 0 || laptop_image.length > 0 || laptop_logo != 0 && laptop_logo.length > 0 || laptop_custom_text.length > 0 || laptop_custom_text_extra.length > 0){
      if(laptop_image.length > 0 && !laptop_custom_text.length){
        laptop_image = $(this).parents(".cart-item-data").find(".t4s-cart_meta_propertyList").attr("laptop-image");
        setTimeout(function(index, value){
          console.log('img only')
          $('.engrave-charge .t4s-cart_meta_propertyList[actual_product_id="'+actual_product_id+'"][laptop-image='+laptop_image+'][laptop-custom-text=""]').parents(".cart-item-data").find(".quantity .minus").click();
          $('.engrave-charge .t4s-cart_meta_propertyList[actual_product_id="'+actual_product_id+'"][laptop-image='+laptop_image+'][laptop-custom-text=""]').parents(".cart-item-data").find(".qty.quantity").html("Qty : <span>"+(parseInt($('.engrave-charge .t4s-cart_meta_propertyList[actual_product_id="'+actual_product_id+'"][laptop-image='+laptop_image+'][laptop-custom-text=""]').parents(".cart-item-data").find(".qty.quantity span").text())-1)+"</span>");
        }, 2500);
      } else if (laptop_image.length > 0 && laptop_custom_text.length > 0) {
        laptop_image = $(this).parents(".cart-item-data").find(".t4s-cart_meta_propertyList").attr("laptop-image");

        setTimeout(async function () {
          let iscart = document.getElementById('t4s-mini_cart') || document.querySelector('.t4s-cartPage__form');

          try {
            const updates = {};

            // Fetch current cart
            const res = await fetch('/cart.js');
            const cart = await res.json();

            // --- First product: Laptop Custom Text + Image ---
            const matchingItem1 = cart.items.find(item =>
              item.properties &&
              item.properties["Actual Product"] == actual_product_id &&
              item.properties["Laptop Custom Text"] == laptop_custom_text &&
              item.properties["Laptop Image"] == laptop_image
            );

            if (matchingItem1) {
              const newQty1 = matchingItem1.quantity - 1;
              updates[matchingItem1.key] = newQty1;

              // Update DOM manually
              $('.engrave-charge .t4s-cart_meta_propertyList[actual_product_id="' + actual_product_id + '"][laptop-custom-text="' + laptop_custom_text + '"][laptop-image="' + laptop_image + '"]')
                .parents(".cart-item-data")
                .find(".qty.quantity")
                .html(`Qty : <span>${newQty1}</span>`);
            } else {
              console.warn("Matching laptop item with text + image not found.");
            }

            // --- Second product: Laptop Extra Custom Text (optional) ---
            if (laptop_custom_text_extra.length > 0) {
              const matchingItem2 = cart.items.find(item =>
                item.properties &&
                item.properties["Actual Product"] == actual_product_id &&
                item.properties["Laptop Extra Custom Text"] == laptop_custom_text_extra
              );

              if (matchingItem2) {
                const newQty2 = matchingItem2.quantity - 1;
                updates[matchingItem2.key] = newQty2;

                $('.engrave-charge .t4s-cart_meta_propertyList[actual_product_id="' + actual_product_id + '"][laptop-custom-text-extra="' + laptop_custom_text_extra + '"]')
                  .parents(".cart-item-data")
                  .find(".qty.quantity")
                  .html(`Qty : <span>${newQty2}</span>`);
              } else {
                console.warn("Matching laptop extra custom text item not found.");
              }
            }

            // --- Update cart if needed ---
            if (Object.keys(updates).length > 0) {
              iscart.classList.add('is--contentUpdate');

              const updateRes = await fetch('/cart/update.js', {
                method: 'POST',
                headers: {
                  'Content-Type': 'application/json'
                },
                body: JSON.stringify({ updates })
              });

              const result = await updateRes.json();
              iscart.classList.remove('is--contentUpdate');
              $(document).trigger('cart:updated');

              if (window.location.pathname === "/cart") {
                window.location.reload();
              }
            }

          } catch (error) {
            console.error("Error in laptop cart update:", error);
          }
        }, 3000);
      } else if (laptop_logo != 0 && !laptop_custom_text.length){
        laptop_logo = $(this).parents(".cart-item-data").find(".t4s-cart_meta_propertyList").attr("laptop-logo");
        setTimeout(function(index, value){
          console.log('logo only')
          $('.engrave-charge .t4s-cart_meta_propertyList[actual_product_id="'+actual_product_id+'"][laptop-logo='+laptop_logo+'][laptop-custom-text=""]').parents(".cart-item-data").find(".quantity .minus").click();
          $('.engrave-charge .t4s-cart_meta_propertyList[actual_product_id="'+actual_product_id+'"][laptop-logo='+laptop_logo+'][laptop-custom-text=""]').parents(".cart-item-data").find(".qty.quantity").html("Qty : <span>"+(parseInt($('.engrave-charge .t4s-cart_meta_propertyList[actual_product_id="'+actual_product_id+'"][laptop-logo='+laptop_logo+'][laptop-custom-text=""]').parents(".cart-item-data").find(".qty.quantity span").text())-1)+"</span>");
        }, 2500);
      } else if (laptop_logo != 0 && laptop_custom_text.length > 0){
        laptop_logo = $(this).parents(".cart-item-data").find(".t4s-cart_meta_propertyList").attr("laptop-logo");
        setTimeout(async function () {
          let iscart = document.getElementById('t4s-mini_cart') || document.querySelector('.t4s-cartPage__form');

          try {
            const updates = {};

            // Fetch current cart
            const res = await fetch('/cart.js');
            const cart = await res.json();

            // --- First product: Laptop Custom Text + Logo ---
            const matchingItem1 = cart.items.find(item =>
              item.properties &&
              item.properties["Actual Product"] == actual_product_id &&
              item.properties["Laptop Custom Text"] == laptop_custom_text &&
              item.properties["Laptop Logo"]
            );

            if (matchingItem1) {
              const newQty1 = matchingItem1.quantity - 1;
              updates[matchingItem1.key] = newQty1;

              // Update DOM manually
              $('.engrave-charge .t4s-cart_meta_propertyList[actual_product_id="' + actual_product_id + '"][laptop-custom-text="' + laptop_custom_text + '"][laptop-logo="' + laptop_logo + '"]')
                .parents(".cart-item-data")
                .find(".qty.quantity")
                .html(`Qty : <span>${newQty1}</span>`);
            } else {
              console.warn("Matching laptop item with logo + text not found.");
            }

            // --- Second product: Laptop Extra Custom Text (optional) ---
            if (laptop_custom_text_extra.length > 0) {
              const matchingItem2 = cart.items.find(item =>
                item.properties &&
                item.properties["Actual Product"] == actual_product_id &&
                item.properties["Laptop Extra Custom Text"] == laptop_custom_text_extra
              );

              if (matchingItem2) {
                const newQty2 = matchingItem2.quantity - 1;
                updates[matchingItem2.key] = newQty2;

                $('.engrave-charge .t4s-cart_meta_propertyList[actual_product_id="' + actual_product_id + '"][laptop-custom-text-extra="' + laptop_custom_text_extra + '"]')
                  .parents(".cart-item-data")
                  .find(".qty.quantity")
                  .html(`Qty : <span>${newQty2}</span>`);
              } else {
                console.warn("Matching laptop extra custom text item not found.");
              }
            }

            // --- Final update call ---
            if (Object.keys(updates).length > 0) {
              iscart.classList.add('is--contentUpdate');

              const updateRes = await fetch('/cart/update.js', {
                method: 'POST',
                headers: {
                  'Content-Type': 'application/json'
                },
                body: JSON.stringify({ updates })
              });

              const result = await updateRes.json();
              iscart.classList.remove('is--contentUpdate');
              $(document).trigger('cart:updated');

              if (window.location.pathname === "/cart") {
                window.location.reload();
              }
            }

          } catch (error) {
            console.error("Error in laptop logo + text cart update:", error);
          }
        }, 3000);
      } else if (laptop_logo == 0 && laptop_engrave_text.length > 0){
        setTimeout(function(index, value){
          console.log('engrave text no logo')
          $('.engrave-charge .t4s-cart_meta_propertyList[actual_product_id="'+actual_product_id+'"][laptop-engrave-text='+laptop_engrave_text+'][laptop-image=""][laptop-logo=""]').parents(".cart-item-data").find(".quantity .minus").click();
          $('.engrave-charge .t4s-cart_meta_propertyList[actual_product_id="'+actual_product_id+'"][laptop-engrave-text='+laptop_engrave_text+'][laptop-image=""][laptop-logo=""]').parents(".cart-item-data").find(".qty.quantity").html("Qty : <span>"+(parseInt($('.engrave-charge .t4s-cart_meta_propertyList[actual_product_id="'+actual_product_id+'"][laptop-engrave-text='+laptop_engrave_text+'][laptop-image=""][laptop-logo=""]').parents(".cart-item-data").find(".qty.quantity span").text())-1)+"</span>");
        }, 2500);
      } else if (!laptop_image.length && laptop_engrave_text.length > 0){
        setTimeout(function(index, value){
          console.log('engrave text no image')
          $('.engrave-charge .t4s-cart_meta_propertyList[actual_product_id="'+actual_product_id+'"][laptop-engrave-text='+laptop_engrave_text+'][laptop-image=""][laptop-logo=""]').parents(".cart-item-data").find(".quantity .minus").click();
          $('.engrave-charge .t4s-cart_meta_propertyList[actual_product_id="'+actual_product_id+'"][laptop-engrave-text='+laptop_engrave_text+'][laptop-image=""][laptop-logo=""]').parents(".cart-item-data").find(".qty.quantity").html("Qty : <span>"+(parseInt($('.engrave-charge .t4s-cart_meta_propertyList[actual_product_id="'+actual_product_id+'"][laptop-engrave-text='+laptop_engrave_text+'][laptop-image=""][laptop-logo=""]').parents(".cart-item-data").find(".qty.quantity span").text())-1)+"</span>");
        }, 2500);
      } else if (laptop_logo == 0 && laptop_custom_text.length > 0){
         setTimeout(async function () {
          let iscart = document.getElementById('t4s-mini_cart') || document.querySelector('.t4s-cartPage__form');

          try {
            const updates = {};

            // Fetch current cart
            const res = await fetch('/cart.js');
            const cart = await res.json();

            // --- First product: Laptop Custom Text Only (No Logo, No Image) ---
            const matchingItem1 = cart.items.find(item =>
              item.properties &&
              item.properties["Actual Product"] == actual_product_id &&
              item.properties["Laptop Custom Text"] == laptop_custom_text &&
              !item.properties["Laptop Image"] &&
              !item.properties["Laptop Logo"]
            );

            if (matchingItem1) {
              const newQty1 = matchingItem1.quantity - 1;
              updates[matchingItem1.key] = newQty1;

              // Update DOM manually
              $('.engrave-charge .t4s-cart_meta_propertyList[actual_product_id="' + actual_product_id + '"][laptop-custom-text="' + laptop_custom_text + '"][laptop-image=""][laptop-logo=""]')
                .parents(".cart-item-data")
                .find(".qty.quantity")
                .html(`Qty : <span>${newQty1}</span>`);
            } else {
              console.warn("Matching laptop item with text only not found.");
            }

            // --- Second product: Laptop Extra Custom Text (Optional) ---
            if (laptop_custom_text_extra.length > 0) {
              const matchingItem2 = cart.items.find(item =>
                item.properties &&
                item.properties["Actual Product"] == actual_product_id &&
                item.properties["Laptop Extra Custom Text"] == laptop_custom_text_extra
              );

              if (matchingItem2) {
                const newQty2 = matchingItem2.quantity - 1;
                updates[matchingItem2.key] = newQty2;

                $('.engrave-charge .t4s-cart_meta_propertyList[actual_product_id="' + actual_product_id + '"][laptop-custom-text-extra="' + laptop_custom_text_extra + '"]')
                  .parents(".cart-item-data")
                  .find(".qty.quantity")
                  .html(`Qty : <span>${newQty2}</span>`);
              } else {
                console.warn("Matching laptop extra custom text item not found.");
              }
            }

            // --- Final Update ---
            if (Object.keys(updates).length > 0) {
              iscart.classList.add('is--contentUpdate');

              const updateRes = await fetch('/cart/update.js', {
                method: 'POST',
                headers: {
                  'Content-Type': 'application/json'
                },
                body: JSON.stringify({ updates })
              });

              const result = await updateRes.json();
              iscart.classList.remove('is--contentUpdate');
              $(document).trigger('cart:updated');

              if (window.location.pathname === "/cart") {
                window.location.reload();
              }
            }

          } catch (error) {
            console.error("Error in laptop text-only cart update:", error);
          }
        }, 3000);
      }
    }

    if(men_pouch_image.length > 0 || men_pouch_logo != 0 && men_pouch_logo.length > 0 || men_pouch_custom_text.length > 0 || men_pouch_custom_text_extra.length > 0){
      if(men_pouch_image.length > 0 && !men_pouch_custom_text.length){
        men_pouch_image = $(this).parents(".cart-item-data").find(".t4s-cart_meta_propertyList").attr("men-pouch-image");
        setTimeout(function(){
          console.log('men img only');
          $('.engrave-charge .t4s-cart_meta_propertyList[actual_product_id="'+actual_product_id+'"][men-pouch-image='+men_pouch_image+'][men-pouch-custom-text=""]').parents(".cart-item-data").find(".quantity .minus").click();
        }, 2500);
      } else if(men_pouch_image.length > 0 && men_pouch_custom_text.length > 0){
        men_pouch_image = $(this).parents(".cart-item-data").find(".t4s-cart_meta_propertyList").attr("men-pouch-image");
        setTimeout(async function () {
          const iscart = document.getElementById('t4s-mini_cart') || document.querySelector('.t4s-cartPage__form');
          try {
            const updates = {};

            // Fetch current cart
            const res = await fetch('/cart.js');
            const cart = await res.json();

            // --- First product: Men Pouch Custom Text with Image ---
            const matchingItem1 = cart.items.find(item =>
              item.properties &&
              item.properties["Actual Product"] == actual_product_id &&
              item.properties["Men Pouch Custom Text"] == men_pouch_custom_text &&
              item.properties["Men Pouch Image"]
            );

            if (matchingItem1) {
              const newQty1 = matchingItem1.quantity - 1;
              updates[matchingItem1.key] = newQty1;

              // Update DOM manually
              $('.engrave-charge .t4s-cart_meta_propertyList[actual_product_id="' + actual_product_id + '"][men-pouch-custom-text="' + men_pouch_custom_text + '"][men-pouch-image="' + men_pouch_image + '"]')
                .parents(".cart-item-data")
                .find(".qty.quantity")
                .html(`Qty : <span>${newQty1}</span>`);
            } else {
              console.warn("Matching item for men pouch custom_text not found.");
            }

            // --- Second product: Men Pouch Extra Custom Text (optional) ---
            if (men_pouch_custom_text_extra.length > 0) {
              const matchingItem2 = cart.items.find(item =>
                item.properties &&
                item.properties["Actual Product"] == actual_product_id &&
                item.properties["Men Pouch Extra Custom Text"] == men_pouch_custom_text_extra
              );

              if (matchingItem2) {
                const newQty2 = matchingItem2.quantity - 1;
                updates[matchingItem2.key] = newQty2;

                $('.engrave-charge .t4s-cart_meta_propertyList[actual_product_id="' + actual_product_id + '"][men-pouch-custom-text-extra="' + men_pouch_custom_text_extra + '"]')
                  .parents(".cart-item-data")
                  .find(".qty.quantity")
                  .html(`Qty : <span>${newQty2}</span>`);
              } else {
                console.warn("Matching item for men pouch extra_custom_text not found.");
              }
            }

            // --- Call /cart/update.js once if needed ---
            if (Object.keys(updates).length > 0) {
              iscart.classList.add('is--contentUpdate');

              const updateRes = await fetch('/cart/update.js', {
                method: 'POST',
                headers: {
                  'Content-Type': 'application/json'
                },
                body: JSON.stringify({ updates })
              });

              const result = await updateRes.json();
              iscart.classList.remove('is--contentUpdate');
              $(document).trigger('cart:updated');
              if (window.location.pathname === "/cart") {
                window.location.reload();
              }
            }

          } catch (error) {
            console.error("Error in men pouch cart update:", error);
          }
        }, 3000);
      } else if (men_pouch_logo != 0 && !men_pouch_custom_text.length){
        men_pouch_logo = $(this).parents(".cart-item-data").find(".t4s-cart_meta_propertyList").attr("men-pouch-logo");
        setTimeout(function(){
          console.log('men logo only');
          $('.engrave-charge .t4s-cart_meta_propertyList[actual_product_id="'+actual_product_id+'"][men-pouch-logo='+men_pouch_logo+'][men-pouch-custom-text=""]').parents(".cart-item-data").find(".quantity .minus").click();
        }, 2500);
      } else if (men_pouch_logo != 0 && men_pouch_custom_text.length > 0){
        men_pouch_logo = $(this).parents(".cart-item-data").find(".t4s-cart_meta_propertyList").attr("men-pouch-logo");
        setTimeout(async function () {
          let iscart = document.getElementById('t4s-mini_cart') || document.querySelector('.t4s-cartPage__form');
          try {
            const updates = {};

            // Fetch current cart
            const res = await fetch('/cart.js');
            const cart = await res.json();

            // --- First product: Men Pouch Custom Text + Logo ---
            const matchingItem1 = cart.items.find(item =>
              item.properties &&
              item.properties["Actual Product"] == actual_product_id &&
              item.properties["Men Pouch Custom Text"] == men_pouch_custom_text &&
              item.properties["Men Pouch Logo"]
            );

            if (matchingItem1) {
              const newQty1 = matchingItem1.quantity - 1;
              updates[matchingItem1.key] = newQty1;

              // Update DOM manually
              $('.engrave-charge .t4s-cart_meta_propertyList[actual_product_id="' + actual_product_id + '"][men-pouch-custom-text="' + men_pouch_custom_text + '"][men-pouch-logo="' + men_pouch_logo + '"]')
                .parents(".cart-item-data")
                .find(".qty.quantity")
                .html(`Qty : <span>${newQty1}</span>`);
            } else {
              console.warn("Matching item for men pouch logo + custom_text not found.");
            }

            // --- Second product: Men Pouch Extra Custom Text (optional) ---
            if (men_pouch_custom_text_extra.length > 0) {
              const matchingItem2 = cart.items.find(item =>
                item.properties &&
                item.properties["Actual Product"] == actual_product_id &&
                item.properties["Men Pouch Extra Custom Text"] == men_pouch_custom_text_extra
              );

              if (matchingItem2) {
                const newQty2 = matchingItem2.quantity - 1;
                updates[matchingItem2.key] = newQty2;

                $('.engrave-charge .t4s-cart_meta_propertyList[actual_product_id="' + actual_product_id + '"][men-pouch-custom-text-extra="' + men_pouch_custom_text_extra + '"]')
                  .parents(".cart-item-data")
                  .find(".qty.quantity")
                  .html(`Qty : <span>${newQty2}</span>`);
              } else {
                console.warn("Matching item for men pouch extra_custom_text not found.");
              }
            }

            // --- Call /cart/update.js once ---
            if (Object.keys(updates).length > 0) {
              iscart.classList.add('is--contentUpdate');

              const updateRes = await fetch('/cart/update.js', {
                method: 'POST',
                headers: {
                  'Content-Type': 'application/json'
                },
                body: JSON.stringify({ updates })
              });

              const result = await updateRes.json();
              iscart.classList.remove('is--contentUpdate');
              $(document).trigger('cart:updated');

              if (window.location.pathname === "/cart") {
                window.location.reload();
              }
            }

          } catch (error) {
            console.error("Error in men pouch logo + text cart update:", error);
          }
        }, 3000);
      } else if (men_pouch_logo == 0 && men_pouch_custom_text.length > 0){
        setTimeout(async function () {
          let iscart = document.getElementById('t4s-mini_cart') || document.querySelector('.t4s-cartPage__form');
          try {
            const updates = {};

            // Fetch current cart
            const res = await fetch('/cart.js');
            const cart = await res.json();

            // --- First product: Men Pouch Custom Text (no logo or image) ---
            const matchingItem1 = cart.items.find(item =>
              item.properties &&
              item.properties["Actual Product"] == actual_product_id &&
              item.properties["Men Pouch Custom Text"] == men_pouch_custom_text &&
              !item.properties["Men Pouch Image"] &&
              !item.properties["Men Pouch Logo"]
            );

            if (matchingItem1) {
              const newQty1 = matchingItem1.quantity - 1;
              updates[matchingItem1.key] = newQty1;

              // Update DOM manually
              $('.engrave-charge .t4s-cart_meta_propertyList[actual_product_id="' + actual_product_id + '"][men-pouch-custom-text="' + men_pouch_custom_text + '"][men-pouch-image=""][men-pouch-logo=""]')
                .parents(".cart-item-data")
                .find(".qty.quantity")
                .html(`Qty : <span>${newQty1}</span>`);
            } else {
              console.warn("Matching item for men pouch custom_text (no logo/image) not found.");
            }

            // --- Second product: Extra Custom Text (optional) ---
            if (men_pouch_custom_text_extra.length > 0) {
              const matchingItem2 = cart.items.find(item =>
                item.properties &&
                item.properties["Actual Product"] == actual_product_id &&
                item.properties["Men Pouch Extra Custom Text"] == men_pouch_custom_text_extra
              );

              if (matchingItem2) {
                const newQty2 = matchingItem2.quantity - 1;
                updates[matchingItem2.key] = newQty2;

                $('.engrave-charge .t4s-cart_meta_propertyList[actual_product_id="' + actual_product_id + '"][men-pouch-custom-text-extra="' + men_pouch_custom_text_extra + '"]')
                  .parents(".cart-item-data")
                  .find(".qty.quantity")
                  .html(`Qty : <span>${newQty2}</span>`);
              } else {
                console.warn("Matching item for men pouch extra_custom_text not found.");
              }
            }

            // --- Call /cart/update.js once ---
            if (Object.keys(updates).length > 0) {
              iscart.classList.add('is--contentUpdate');
              const updateRes = await fetch('/cart/update.js', {
                method: 'POST',
                headers: {
                  'Content-Type': 'application/json'
                },
                body: JSON.stringify({ updates })
              });

              const result = await updateRes.json();
              iscart.classList.remove('is--contentUpdate');
              $(document).trigger('cart:updated');

              if (window.location.pathname === "/cart") {
                window.location.reload();
              }
            }

          } catch (error) {
            console.error("Error in men pouch custom_text (no logo) update:", error);
          }
        }, 3000);
      }
    }

    if(lady_pouch_image.length > 0 || lady_pouch_logo != 0 && lady_pouch_logo.length > 0 || lady_pouch_custom_text.length > 0 || lady_pouch_custom_text_extra.length > 0){
      if(lady_pouch_image.length > 0 && !lady_pouch_custom_text.length){
        lady_pouch_image = $(this).parents(".cart-item-data").find(".t4s-cart_meta_propertyList").attr("lady-pouch-image");
        setTimeout(function(){
          console.log('lady img only');
          $('.engrave-charge .t4s-cart_meta_propertyList[actual_product_id="'+actual_product_id+'"][lady-pouch-image='+lady_pouch_image+'][lady-pouch-custom-text=""]').parents(".cart-item-data").find(".quantity .minus").click();
        }, 2500);
      } else if(lady_pouch_image.length > 0 && lady_pouch_custom_text.length > 0){
        lady_pouch_image = $(this).parents(".cart-item-data").find(".t4s-cart_meta_propertyList").attr("lady-pouch-image");
        setTimeout(async function () {
          let iscart = document.getElementById('t4s-mini_cart') || document.querySelector('.t4s-cartPage__form');
          try {
            const updates = {};
            
            // Fetch current cart
            const res = await fetch('/cart.js');
            const cart = await res.json();

            // --- First product: Lady Pouch Custom Text with Image ---
            const matchingItem1 = cart.items.find(item =>
              item.properties &&
              item.properties["Actual Product"] == actual_product_id &&
              item.properties["Lady Pouch Custom Text"] == lady_pouch_custom_text &&
              item.properties["Lady Pouch Image"]
            );

            if (matchingItem1) {
              const newQty1 = matchingItem1.quantity - 1;
              updates[matchingItem1.key] = newQty1;

              // Update DOM manually
              $('.engrave-charge .t4s-cart_meta_propertyList[actual_product_id="' + actual_product_id + '"][lady-pouch-custom-text="' + lady_pouch_custom_text + '"][lady-pouch-image="' + lady_pouch_image + '"]')
                .parents(".cart-item-data")
                .find(".qty.quantity")
                .html(`Qty : <span>${newQty1}</span>`);
            } else {
              console.warn("Matching item for lady pouch custom_text not found.");
            }

            // --- Second product: Lady Pouch Extra Custom Text (optional) ---
            if (lady_pouch_custom_text_extra.length > 0) {
              const matchingItem2 = cart.items.find(item =>
                item.properties &&
                item.properties["Actual Product"] == actual_product_id &&
                item.properties["Lady Pouch Extra Custom Text"] == lady_pouch_custom_text_extra
              );

              if (matchingItem2) {
                const newQty2 = matchingItem2.quantity - 1;
                updates[matchingItem2.key] = newQty2;

                $('.engrave-charge .t4s-cart_meta_propertyList[actual_product_id="' + actual_product_id + '"][lady-pouch-custom-text-extra="' + lady_pouch_custom_text_extra + '"]')
                  .parents(".cart-item-data")
                  .find(".qty.quantity")
                  .html(`Qty : <span>${newQty2}</span>`);
              } else {
                console.warn("Matching item for lady pouch extra_custom_text not found.");
              }
            }

            // --- Call /cart/update.js once ---
            if (Object.keys(updates).length > 0) {
              iscart.classList.add('is--contentUpdate');
              const updateRes = await fetch('/cart/update.js', {
                method: 'POST',
                headers: {
                  'Content-Type': 'application/json'
                },
                body: JSON.stringify({ updates })
              });

              const result = await updateRes.json();
              iscart.classList.remove('is--contentUpdate');
              $(document).trigger('cart:updated');
              if (window.location.pathname === "/cart") {
                window.location.reload();
              }
            }

          } catch (error) {
            console.error("Error in lady pouch cart update:", error);
          }
        }, 3000);
      } else if (lady_pouch_logo != 0 && !lady_pouch_custom_text.length){
        lady_pouch_logo = $(this).parents(".cart-item-data").find(".t4s-cart_meta_propertyList").attr("lady-pouch-logo");
        setTimeout(function(){
          console.log('lady logo only');
          $('.engrave-charge .t4s-cart_meta_propertyList[actual_product_id="'+actual_product_id+'"][lady-pouch-logo='+lady_pouch_logo+'][lady-pouch-custom-text=""]').parents(".cart-item-data").find(".quantity .minus").click();
        }, 2500);
      } else if (lady_pouch_logo != 0 && lady_pouch_custom_text.length > 0){
        lady_pouch_logo = $(this).parents(".cart-item-data").find(".t4s-cart_meta_propertyList").attr("lady-pouch-logo");
        setTimeout(async function () {
          let iscart = document.getElementById('t4s-mini_cart') || document.querySelector('.t4s-cartPage__form');
          try {
            const updates = {};

            // Fetch current cart
            const res = await fetch('/cart.js');
            const cart = await res.json();

            // --- First product: Lady Pouch Custom Text + Logo ---
            const matchingItem1 = cart.items.find(item =>
              item.properties &&
              item.properties["Actual Product"] == actual_product_id &&
              item.properties["Lady Pouch Custom Text"] == lady_pouch_custom_text &&
              item.properties["Lady Pouch Logo"]
            );

            if (matchingItem1) {
              const newQty1 = matchingItem1.quantity - 1;
              updates[matchingItem1.key] = newQty1;

              // Update DOM manually
              $('.engrave-charge .t4s-cart_meta_propertyList[actual_product_id="' + actual_product_id + '"][lady-pouch-custom-text="' + lady_pouch_custom_text + '"][lady-pouch-logo="' + lady_pouch_logo + '"]')
                .parents(".cart-item-data")
                .find(".qty.quantity")
                .html(`Qty : <span>${newQty1}</span>`);
            } else {
              console.warn("Matching item for lady pouch logo+custom_text not found.");
            }

            // --- Second product: Lady Pouch Extra Custom Text (optional) ---
            if (lady_pouch_custom_text_extra.length > 0) {
              const matchingItem2 = cart.items.find(item =>
                item.properties &&
                item.properties["Actual Product"] == actual_product_id &&
                item.properties["Lady Pouch Extra Custom Text"] == lady_pouch_custom_text_extra
              );

              if (matchingItem2) {
                const newQty2 = matchingItem2.quantity - 1;
                updates[matchingItem2.key] = newQty2;

                $('.engrave-charge .t4s-cart_meta_propertyList[actual_product_id="' + actual_product_id + '"][lady-pouch-custom-text-extra="' + lady_pouch_custom_text_extra + '"]')
                  .parents(".cart-item-data")
                  .find(".qty.quantity")
                  .html(`Qty : <span>${newQty2}</span>`);
              } else {
                console.warn("Matching item for lady pouch extra_custom_text not found.");
              }
            }

            // --- Call /cart/update.js once ---
            if (Object.keys(updates).length > 0) {
              iscart.classList.add('is--contentUpdate');
              const updateRes = await fetch('/cart/update.js', {
                method: 'POST',
                headers: {
                  'Content-Type': 'application/json'
                },
                body: JSON.stringify({ updates })
              });

              const result = await updateRes.json();
              iscart.classList.remove('is--contentUpdate');
              $(document).trigger('cart:updated');
              if (window.location.pathname === "/cart") {
                window.location.reload();
              }
            }

          } catch (error) {
            console.error("Error in lady pouch logo + text cart update:", error);
          }
        }, 3000);
      } else if (lady_pouch_logo == 0 && lady_pouch_custom_text.length > 0){
        setTimeout(async function () {
          let iscart = document.getElementById('t4s-mini_cart') || document.querySelector('.t4s-cartPage__form');
          try {
            const updates = {};

            // Fetch current cart
            const res = await fetch('/cart.js');
            const cart = await res.json();

            // --- First product: Lady Pouch Custom Text (no logo or image) ---
            const matchingItem1 = cart.items.find(item =>
              item.properties &&
              item.properties["Actual Product"] == actual_product_id &&
              item.properties["Lady Pouch Custom Text"] == lady_pouch_custom_text &&
              !item.properties["Lady Pouch Image"] &&
              !item.properties["Lady Pouch Logo"]
            );

            if (matchingItem1) {
              const newQty1 = matchingItem1.quantity - 1;
              updates[matchingItem1.key] = newQty1;

              // Update DOM manually
              $('.engrave-charge .t4s-cart_meta_propertyList[actual_product_id="' + actual_product_id + '"][lady-pouch-custom-text="' + lady_pouch_custom_text + '"][lady-pouch-image=""][lady-pouch-logo=""]')
                .parents(".cart-item-data")
                .find(".qty.quantity")
                .html(`Qty : <span>${newQty1}</span>`);
            } else {
              console.warn("Matching item for lady pouch custom_text (no logo) not found.");
            }

            // --- Second product: Extra Custom Text (optional) ---
            if (lady_pouch_custom_text_extra.length > 0) {
              const matchingItem2 = cart.items.find(item =>
                item.properties &&
                item.properties["Actual Product"] == actual_product_id &&
                item.properties["Lady Pouch Extra Custom Text"] == lady_pouch_custom_text_extra
              );

              if (matchingItem2) {
                const newQty2 = matchingItem2.quantity - 1;
                updates[matchingItem2.key] = newQty2;

                $('.engrave-charge .t4s-cart_meta_propertyList[actual_product_id="' + actual_product_id + '"][lady-pouch-custom-text-extra="' + lady_pouch_custom_text_extra + '"]')
                  .parents(".cart-item-data")
                  .find(".qty.quantity")
                  .html(`Qty : <span>${newQty2}</span>`);
              } else {
                console.warn("Matching item for lady pouch extra_custom_text not found.");
              }
            }

            // --- Call /cart/update.js once ---
            if (Object.keys(updates).length > 0) {
              iscart.classList.add('is--contentUpdate');
              const updateRes = await fetch('/cart/update.js', {
                method: 'POST',
                headers: {
                  'Content-Type': 'application/json'
                },
                body: JSON.stringify({ updates })
              });

              const result = await updateRes.json();
              iscart.classList.remove('is--contentUpdate');
              $(document).trigger('cart:updated');
              if (window.location.pathname === "/cart") {
                window.location.reload();
              }
            }

          } catch (error) {
            console.error("Error in lady pouch custom_text (no logo) update:", error);
          }
        }, 3000);
      }
    }
      
    }); 

    //clear cart
    $(document).on("click", ".drawer-clear-cart", function(e){
      //console.log('clear cart clicked from custom_cart_widget.js')
      e.preventDefault();
      $.ajax({
        type: "POST",
        url: '/cart/clear.js',
        data: '',
        dataType: 'json',
        success: function() { 
          if($(".t4s-mini_cart__remove").length > 0){
              $(".t4s-mini_cart__remove").trigger("click");
          }
          if(body.hasClass("template-cart")){
             location.reload(true);
          }
        },
        error: function(XMLHttpRequest, textStatus) {
          /* error code */
        }
      });
    }); 
      //end of custom by chintan
})( jQuery_T4NT );